
function onYouTubeIframeAPIReady() {
    wpbingo.ProductVideo.loadVideos(wpbingo.ProductVideo.hosts.youtube)
}
window.wpbingo = window.wpbingo || {},
wpbingo.Sections = function t() {
    this.constructors = {},
    this.instances = [],
    $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}
,
wpbingo.Sections.prototype = _.assignIn({}, wpbingo.Sections.prototype, {
    _createInstance: function(t, e) {
        var a = $(t)
          , i = a.attr("data-section-id")
          , o = a.attr("data-section-type");
        if (e = e || this.constructors[o],
        !_.isUndefined(e)) {
            var n = _.assignIn(new e(t), {
                id: i,
                type: o,
                container: t
            });
            this.instances.push(n)
        }
    },
    _onSectionLoad: function(t) {
        var e = $("[data-section-id]", t.target)[0];
        e && this._createInstance(e)
    },
    _onSectionUnload: function(t) {
        this.instances = _.filter(this.instances, function(e) {
            var a = e.id === t.originalEvent.detail.sectionId;
            return a && _.isFunction(e.onUnload) && e.onUnload(t),
            !a
        })
    },
    _onSelect: function(t) {
        var e = _.find(this.instances, function(e) {
            return e.id === t.originalEvent.detail.sectionId
        });
        !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t)
    },
    _onDeselect: function(t) {
        var e = _.find(this.instances, function(e) {
            return e.id === t.originalEvent.detail.sectionId
        });
        !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t)
    },
    _onBlockSelect: function(t) {
        var e = _.find(this.instances, function(e) {
            return e.id === t.originalEvent.detail.sectionId
        });
        !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t)
    },
    _onBlockDeselect: function(t) {
        var e = _.find(this.instances, function(e) {
            return e.id === t.originalEvent.detail.sectionId
        });
        !_.isUndefined(e) && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t)
    },
    register: function(t, e) {
        this.constructors[t] = e,
        $("[data-section-type=" + t + "]").each((function(t, a) {
            this._createInstance(a, e)
        }
        ).bind(this))
    }
}),
wpbingo.LibraryLoader = function() {
    var t = {
        link: "link",
        script: "script"
    }
      , e = {
        requested: "requested",
        loaded: "loaded"
    }
      , a = "https://cdn.shopify.com/shopifycloud/"
      , i = {
        youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: t.script
        },
        plyrShopifyStyles: {
            tagId: "plyr-shopify-styles",
            src: a + "shopify-plyr/v1.0/shopify-plyr.css",
            type: t.link
        },
        modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: a + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: t.link
        }
    };
    function o(a, o) {
        var s, c = i[a];
        if (c && c.status !== e.requested) {
            if (o = o || function() {}
            ,
            c.status === e.loaded) {
                o();
                return
            }
            switch (c.status = e.requested,
            c.type) {
            case t.script:
                s = n(c, o);
                break;
            case t.link:
                s = r(c, o)
            }
            s.id = c.tagId,
            c.element = s;
            var l = document.getElementsByTagName(c.type)[0];
            l.parentNode.insertBefore(s, l)
        }
    }
    function n(t, a) {
        var i = document.createElement("script");
        return i.src = t.src,
        i.addEventListener("load", function() {
            t.status = e.loaded,
            a()
        }),
        i
    }
    function r(t, a) {
        var i = document.createElement("link");
        return i.href = t.src,
        i.rel = "stylesheet",
        i.type = "text/css",
        i.addEventListener("load", function() {
            t.status = e.loaded,
            a()
        }),
        i
    }
    return {
        load: o
    }
}(),
wpbingo.Disclosure = function() {
    var t = {
        disclosureInput: "[data-disclosure-input]",
        disclosureOptions: "[data-disclosure-option]"
    };
    function e(t) {
        this.$container = t,
        this.cache = {},
        this._cacheSelectors(),
        this._connectOptions()
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        _cacheSelectors: function() {
            this.cache = {
                $disclosureInput: this.$container.find(t.disclosureInput),
                $disclosureOptions: this.$container.find(t.disclosureOptions)
            }
        },
        _connectOptions: function() {
            this.cache.$disclosureOptions.on("click", (function(t) {
                t.preventDefault(),
                this._submitForm($(t.currentTarget).data("value"))
            }
            ).bind(this))
        },
        _submitForm: function(t) {
            this.cache.$disclosureInput.val(t),
            this.$container.parents("form").submit()
        },
        unload: function() {
            this.cache.$disclosureOptions.off(),
            this.$container.off()
        }
    }),
    e
}(),
wpbingo.Currency = function() {
    var t = "${{amount}}";
    function e(e, a) {
        "string" == typeof e && (e = e.replace(".", ""));
        var i = ""
          , o = /\{\{\s*(\w+)\s*\}\}/
          , n = a || t;
        function r(t, e, a, i) {
            if (a = a || ",",
            i = i || ".",
            isNaN(t) || null === t)
                return 0;
            var o, n = (t = (t / 100).toFixed(e)).split(".");
            return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? i + n[1] : "")
        }
        switch (n.match(o)[1]) {
        case "amount":
            i = r(e, 2);
            break;
        case "amount_no_decimals":
            i = r(e, 0);
            break;
        case "amount_with_comma_separator":
            i = r(e, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            i = r(e, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            i = r(e, 0, " ");
            break;
        case "amount_with_apostrophe_separator":
            i = r(e, 2, "'")
        }
        return n.replace(o, i)
    }
    return {
        formatMoney: e
    }
}(),
wpbingo.collectionPages = function() {
    var t, e, a, i, o, n, r, s, c, l = ".js-page-collection", d = "#JsCollectionProduct", u = ".js-collection-content-product", p = ".collection-sidebar", h = ".wpbingo-breadcrumbs__inner", m = ".active-facets-desktop", f = ".js-change-view", v = !0, g = function() {
        if ($(l)) {
            var e = window.History;
            e.Adapter.bind(window, "statechange", function() {
                e.getState()
            })
        }
        t(),
        i(),
        o(),
        n(),
        r(),
        s(),
        c()
    };
    return t = function() {
        if (Shopify.queryParams = {},
        location.search.length)
            for (var t, e = 0, a = location.search.substr(1).split("&"); e < a.length; e++)
                (t = a[e].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(t[0])] = decodeURIComponent(t[1]))
    }
    ,
    e = function(t, e) {
        var a = e
          , i = a.indexOf(t);
        if (i < 0)
            return "";
        var o = (a = a.slice(i + t.length, a.length)).indexOf("/") > -1 ? a.indexOf("/") : a.length;
        return (a = a.slice(0, o).toLowerCase()).replace("=", "")
    }
    ,
    a = function(t) {
        var a = $.param(Shopify.queryParams).replace(/%2B/g, "+")
          , i = "/collections/" + e("/collections/", location.pathname)
          , o = location.pathname.split("/");
        if (o.length >= 4) {
            var n = o[3].split("?").shift();
            "" != n && (a = a + "+" + n)
        }
        return t ? "" != a ? t + "?" + a : t : i + "?" + a
    }
    ,
    i = function() {
        (cViewCollection = wpbingo.getCookie("wpbingo_view_collection")) && ($(d).removeAttr("class"),
        $(d).addClass(cViewCollection),
        $(f).removeClass("active"),
        $("[data-view=" + cViewCollection + "]").addClass("active")),
        $(l).on("click", f, function(t) {
            t.preventDefault(),
            $(this).hasClass("active") || ($(".product-card__image-wrapper.slider", u).each(function() {
                $(".js-carousel", $(this)).slick("refresh")
            }),
            wpbingo.setCookie("wpbingo_view_collection", $(this).data("view"), 1),
            $(f).removeClass("active"),
            $(this).addClass("active"),
            $(d).removeAttr("class"),
            $(d).addClass($(this).data("view")))
        })
    }
    ,
    c = function() {
        $(l).on("click", ".js-collection-pagination a", function(t) {
            t.preventDefault();
            var e = $(this).attr("href").match(/page=\d+/g);
            if (e) {
                Shopify.queryParams.page = parseInt(e[0].match(/\d+/g));
                var i = window.history.state && window.history.state.searchParams ? window.history.state.searchParams : ""
                  , o = a();
                history.pushState({
                    searchParams: i
                }, "", `${o}${i && "&".concat(i)}`),
                $.ajax({
                    type: "get",
                    url: `${o}${i && "&".concat(i)}`,
                    success: function(t) {
                        $(u).replaceWith($(t).find(u)),
                        $(".product-card__image-wrapper.slider", u).each(function() {
                            wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                        }),
                        $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
                        wpbingo.click_atribute_image(),
                        wpbingo.zoom_thumb(),
                        wpbingo.popup_product_card(),
                        window.SPR && (SPR.initRatingHandler(),
                        SPR.initDomEls(),
                        SPR.loadProducts(),
                        SPR.loadBadges()),
                        wpbingo.countdown(),
                        initButtons(),
                        initButtonsCompare(),
                        wpbingo.sidebarCollection(),
                        wpbingo.toggleSidebar()
                    },
                    error: function(t, e) {
                        console.log(e)
                    }
                }),
                $("body,html").animate({
                    scrollTop: $(".header").height()
                }, 600)
            }
        })
    }
    ,
    r = function() {
        $(l).on("click", ".js-collection-loadmore a", function(t) {
            t.preventDefault();
            var e = $(this).attr("href");
            $(this).addClass("active"),
            e && (Shopify.queryParams.page = parseInt(e[0].match(/\d+/g)),
            window.history.state && window.history.state.searchParams && window.history.state.searchParams,
            a(),
            $.ajax({
                type: "get",
                url: e,
                success: function(t) {
                    $(".products__row", u).append($(t).find(".products__row").html()),
                    $(".js-collection-loadmore").empty(),
                    $(".js-collection-loadmore", u).append($(t).find(".js-collection-loadmore").html()),
                    $(".product-card__image-wrapper.slider", u).each(function() {
                        $(".js-carousel", $(this)).hasClass("slick-initialized") || wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                    }),
                    $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
                    window.SPR && (SPR.registerCallbacks(),
                    SPR.initRatingHandler(),
                    SPR.initDomEls(),
                    SPR.loadProducts(),
                    SPR.loadBadges()),
                    wpbingo.countdown(),
                    wpbingo.click_atribute_image(),
                    wpbingo.zoom_thumb(),
                    wpbingo.popup_product_card(),
                    initButtons(),
                    initButtonsCompare(),
                    wpbingo.sidebarCollection(),
                    wpbingo.christmas_snow(),
                    $(this).removeClass("active")
                },
                error: function(t, e) {
                    console.log(e)
                }
            }))
        })
    }
    ,
    s = function() {
        $(".js-collection-infinity").length > 0 && $(window).scroll(function() {
            if ($(document).scrollTop() > $(document).height() - 2e3 && !0 == v && $(".js-collection-infinity").length > 0) {
                $(".js-collection-infinity a").addClass("active");
                var t = $("a", ".js-collection-infinity").attr("href");
                t && (Shopify.queryParams.page = parseInt(t[0].match(/\d+/g)),
                window.history.state && window.history.state.searchParams && window.history.state.searchParams,
                a(),
                $.ajax({
                    type: "get",
                    url: t,
                    beforeSend: function(t) {
                        v = !1
                    },
                    success: function(t) {
                        v = !0,
                        $(".products__row", u).append($(t).find(".products__row").html()),
                        $(".js-collection-infinity").empty(),
                        $(".js-collection-infinity", u).append($(t).find(".js-collection-infinity").html()),
                        $(".product-card__image-wrapper.slider", u).each(function() {
                            $(".js-carousel", $(this)).hasClass("slick-initialized") || wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                        }),
                        $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
                        window.SPR && (SPR.initRatingHandler(),
                        SPR.initDomEls(),
                        SPR.loadProducts(),
                        SPR.loadBadges()),
                        wpbingo.click_atribute_image(),
                        wpbingo.zoom_thumb(),
                        wpbingo.popup_product_card(),
                        wpbingo.countdown(),
                        initButtons(),
                        initButtonsCompare(),
                        wpbingo.christmas_snow(),
                        wpbingo.sidebarCollection()
                    },
                    error: function(t, e) {
                        console.log(e)
                    }
                }))
            }
        })
    }
    ,
    o = function(t) {
        var e = ".FacetsWrapperDesktop ";
        if (t)
            var a = t;
        else
            var a = $(".sidebar-categories");
        if ($(".wpbingo-breadcrumbs").hasClass("have-collection"))
            var r = !0;
        $(a).on("click", "a", function(t) {
            t.preventDefault();
            var a = $(this).attr("href")
              , s = $(this).attr("title");
            History.pushState({
                param: Shopify.queryParams
            }, a, a),
            delete Shopify.queryParams.page,
            $("#pre-loading").addClass("load-product"),
            $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }),
            $.ajax({
                type: "get",
                url: a,
                success: function(t) {
                    document.title = s,
                    $(u).replaceWith($(t).find(u)),
                    $(p).replaceWith($(t).find(p)),
                    $(h).replaceWith($(t).find(h)),
                    $(m).replaceWith($(t).find(m)),
                    $(".js-page-collection").hasClass("dropdown") && ($(e).replaceWith($(t).find(e)),
                    wpbingo.countActiveSidebar()),
                    $(".wpbingo-breadcrumbs__image").replaceWith($(t).find(".wpbingo-breadcrumbs__image")),
                    r && wpbingo.elementslickCarousel($(".wpbingo-breadcrumbs__image .js-carousel")),
                    o(),
                    n($(".wpbingo-breadcrumbs .bwp_slider-carousel")),
                    wpbingo.click_atribute_image(),
                    wpbingo.zoom_thumb(),
                    $(".product-card__image-wrapper.slider", u).each(function() {
                        wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                    }),
                    $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
                    wpbingo.popup_product_card(),
                    wpbingo.hideLoading(),
                    window.SPR && (SPR.initRatingHandler(),
                    SPR.initDomEls(),
                    SPR.loadProducts(),
                    SPR.loadBadges()),
                    wpbingo.countdown(),
                    i(),
                    wpbingo.sidebarCollection(),
                    initButtons(),
                    initButtonsCompare(),
                    wpbingo.toggleSidebar(),
                    $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }),
                    setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }),
                        $("#pre-loading").removeClass("load-product")
                    }, 500)
                },
                error: function(t, e) {
                    console.log(e)
                }
            }),
            $("body,html").animate({
                scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
            }, 600)
        })
    }
    ,
    n = function(t) {
        if (t)
            var e = t;
        else
            var e = $(".wpbingo-breadcrumbs .bwp_slider-carousel");
        if ($(".wpbingo-breadcrumbs").hasClass("have-collection"))
            var a = !0;
        $(e).on("click", "a", function(t) {
            t.preventDefault();
            var e = $(this).attr("href")
              , r = $("h2", $(this)).text();
            History.pushState({
                param: Shopify.queryParams
            }, e, e),
            delete Shopify.queryParams.page,
            $("#pre-loading").addClass("load-product"),
            $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }),
            $.ajax({
                type: "get",
                url: e,
                success: function(t) {
                    document.title = r,
                    $(u).replaceWith($(t).find(u)),
                    $(p).replaceWith($(t).find(p)),
                    $(h).replaceWith($(t).find(h)),
                    $(m).replaceWith($(t).find(m)),
                    $(".wpbingo-breadcrumbs__image").replaceWith($(t).find(".wpbingo-breadcrumbs__image")),
                    o($(".sidebar-categories")),
                    $(".product-card__image-wrapper.slider", u).each(function() {
                        wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                    }),
                    $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
                    n(),
                    wpbingo.click_atribute_image(),
                    wpbingo.zoom_thumb(),
                    wpbingo.popup_product_card(),
                    wpbingo.hideLoading(),
                    window.SPR && (SPR.initRatingHandler(),
                    SPR.initDomEls(),
                    SPR.loadProducts(),
                    SPR.loadBadges()),
                    wpbingo.countdown(),
                    wpbingo.sidebarCollection(),
                    initButtonsCompare(),
                    initButtons(),
                    wpbingo.countActiveSidebar(),
                    $(".js-page-collection").hasClass("dropdown") || wpbingo.toggleSidebar(),
                    a && wpbingo.elementslickCarousel($(".wpbingo-breadcrumbs__image .js-carousel")),
                    i(),
                    $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }),
                    setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }),
                        $("#pre-loading").removeClass("load-product")
                    }, 500)
                },
                error: function(t, e) {
                    console.log(e)
                }
            }),
            $("body,html").animate({
                scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
            }, 600)
        })
    }
    ,
    g
}(),
wpbingo.Variants = function() {
    function t(t) {
        this.$container = t.$container,
        this.product = t.product,
        this.productSelectOption = t.productSelectOption,
        this.singleOptionSelector = t.singleOptionSelector,
        this.originalSelectorId = t.originalSelectorId,
        this.enableHistoryState = t.enableHistoryState,
        this.currentVariant = this._getVariantFromOptions(),
        $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _getCurrentOptions: function() {
            var t = _.map($(this.singleOptionSelector, this.$container), function(t) {
                var e = $(t)
                  , a = e.attr("type")
                  , i = {};
                return "radio" !== a && "checkbox" !== a ? (i.value = e.val(),
                i.index = e.data("index"),
                i) : !!e[0].checked && (i.value = e.val(),
                i.index = e.data("index"),
                i)
            });
            return _.compact(t)
        },
        _getVariantFromOptions: function() {
            var t = this._getCurrentOptions()
              , e = this.product.variants;
            return _.find(e, function(e) {
                return t.every(function(t) {
                    return _.isEqual(e[t.index], t.value)
                })
            })
        },
        _onSelectChange: function() {
            var t = this._getVariantFromOptions();
            if ($("[data-single-option-button]", this.$container).length && (this._updateVariantsButton(),
            !t || !t.available)) {
                this._updateVariantsButtonDisabed();
                return
            }
            this.$container.trigger({
                type: "variantChange",
                variant: t
            }),
            t && (this._updateMasterSelect(t),
            this._updateMedia(t),
            this._updatePrice(t),
            this._updateQuantity(t),
            this._updateOption(t),
            this._updatePricesticky(t),
            this._updateSKU(t),
            this._updateLabelvariant(t),
            this.currentVariant = t,
            this._updatePickUp(t),
            this._updateBtnText(t),
            this._updateDelivery(t),
            this.enableHistoryState && this._updateHistoryState(t))
        },
        _updateVariantsButtonDisabed: function() {
            for (var t = 2; t <= 3; t++)
                if ($(this.productSelectOption + t, this.$container).length) {
                    var e = !1;
                    $(this.productSelectOption + t + " " + this.singleOptionSelector, this.$container).each(function() {
                        var t = $(this)
                          , a = t.attr("type");
                        if (("radio" === a || "checkbox" === a) && this.checked && t.hasClass("disabled"))
                            return t.prop("checked", !1),
                            e = !0,
                            !1
                    }),
                    $(this.productSelectOption + t + " " + this.singleOptionSelector, this.$container).each(function() {
                        var t = $(this)
                          , a = t.attr("type");
                        if (e && ("radio" === a || "checkbox" === a) && !t.hasClass("disabled"))
                            return t.prop("checked", !0),
                            e = !1,
                            t.trigger("change"),
                            !1
                    })
                }
        },
        _updateVariantsButton: function() {
            for (var t = this._getCurrentOptions(), e = this.product.variants, a = 2; a <= 3; a++)
                if ($(this.productSelectOption + a, this.$container).length) {
                    var i = this.productSelectOption + a;
                    $(i + " " + this.singleOptionSelector, this.$container).each(function() {
                        var o, n = $(this), r = n.val();
                        2 === a ? o = _.findIndex(e, function(e) {
                            return e.option1 === t[0].value && e.option2 === r && !0 === e.available
                        }) : 3 === a && (o = _.findIndex(e, function(e) {
                            return e.option1 === t[0].value && e.option2 === t[1].value && e.option3 === r && !0 === e.available
                        })),
                        -1 !== o ? $(i + ".color-select", this.$container).length > 0 ? (n.removeClass("disabled"),
                        n.next("label").removeClass("disabled")) : (n.removeAttr("disabled", "disabled").removeClass("disabled"),
                        n.next("label").removeClass("disabled")) : $(i + ".color-select", this.$container).length > 0 ? (n.addClass("disabled"),
                        n.next("label").addClass("disabled")) : (n.attr("disabled", "disabled").addClass("disabled"),
                        n.next("label").addClass("disabled"))
                    })
                }
        },
        _updateMedia: function(t) {
            var e = t.featured_media || {}
              , a = this.currentVariant.featured_media || {}
              , i = !1;
            e.preview_image && a.preview_image && (i = e.preview_image.src === a.preview_image.src),
            t.featured_media && !i && this.$container.trigger({
                type: "variantMediaChange",
                variant: t
            })
        },
        _updatePrice: function(t) {
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
            (t.price !== this.currentVariant.price || t.compare_at_price !== this.currentVariant.compare_at_price) && this.$container.trigger({
                type: "variantPriceChange",
                variant: t
            })
        },
        _updateQuantity: function(t) {
            $(".product-single .content-variant_inventory").length > 0 && setTimeout(function() {
                $(".product-single .content-variant_inventory").load(window.location.href + ".content-variant_inventory .js-product-avaiable")
            }, 10)
        },
        _updateOption: function() {
            setTimeout(function() {
                $("#option-selector").load(window.location.href + " #option-selector")
            }, 10)
        },
        _updatePricesticky: function() {
            setTimeout(function() {
                $("#price-sticky").load(window.location.href + " #price-sticky")
            }, 10)
        },
        _updateSKU: function(t) {
            t.sku !== this.currentVariant.sku && this.$container.trigger({
                type: "variantSKUChange",
                variant: t
            })
        },
        _updateLabelvariant: function(t) {
            var e = $(".product-single .product-single__form .variants-wrapper");
            $(".mutil_slider-single").removeClass("active"),
            $(e).each(function() {
                var t = $(this);
                if ($("select", t).length > 0)
                    var e = $("select", t).find(":selected").val();
                else
                    var e = $("input:checked", t).attr("value");
                $(".variants__label span", t).html(e),
                $(".mutil_slider-single." + e).addClass("active")
            })
        },
        _updateHistoryState: function(t) {
            if (history.replaceState && t) {
                var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                window.history.replaceState({
                    path: e
                }, "", e),
                $(".product-single #buy_more_form").length > 0 && ($('#buy_more_form input[name="items[][id]"]').attr("value", t.id),
                wpbingo.discount_single())
            }
        },
        _updatePickUp: function(t) {
            $(".product-single .product-single__pick_up").length > 0 && ($(".product-single .product-single__pick_up").addClass("load-pick_up").css("height", $(".product-single .product-single__pick_up").height() + "px"),
            $(".product-single .product-single__pick_up").empty(),
            wpbingo.pick_up(t.id),
            setTimeout(function() {
                $(".product-single .product-single__pick_up").removeClass("load-pick_up").removeAttr("style")
            }, 1e3))
        },
        _updateBtnText: function(t) {
            $(".product-single .product-single__buttons .btn--add-to-cart .btn__text").length > 0 && setTimeout(function() {
                $(".product-single .product-single__buttons .btn--add-to-cart").load(window.location.href + " .btn__text")
            }, 10),
            $(".sticky-cart-single").length > 0 && setTimeout(function() {
                $(".sticky-cart-single .btn--add-to-cart").load(window.location.href + " .btn__text")
            }, 10)
        },
        _updateDelivery: function(t) {
            $(".product-single .estimated_delivery").length > 0 && $(".product-single .section-estimated_delivery[data-incoming]").length > 0 && ($(".product-single .section-estimated_delivery").addClass("load-delivery").css("height", $(".product-single .section-estimated_delivery").height() + "px"),
            setTimeout(function() {
                $(".product-single .section-estimated_delivery").load(window.location.href + ".product-single .estimated_delivery")
            }, 10),
            setTimeout(function() {
                $(".product-single .time_hour").length > 0 && wpbingo.time_estimated_delivery()
            }, 1200),
            setTimeout(function() {
                $(".product-single .time_hour").length > 0 && $(".product-single .section-estimated_delivery").removeClass("load-delivery").removeAttr("style")
            }, 1400))
        },
        _updateMasterSelect: function(t) {
            $(this.originalSelectorId, this.$container).val(t.id)
        }
    }),
    t
}(),
wpbingo.ProductModel = function() {
    var t = {}
      , e = {}
      , a = {}
      , i = {
        productMediaGroup: ".js-product-media-group",
        productMediaGroupWrapper: ".js-product-single-media",
        xrButton: "[data-shopify-xr]",
        xrButtonSingle: "[data-shopify-xr-single]"
    }
      , o = {
        viewInSpaceDisabled: "product-single__view-in-space--disabled"
    };
    function n(o, n) {
        t[n] = {
            loaded: !1
        },
        o.each(function(t) {
            var o = $(this)
              , r = o.data("media-id")
              , s = $(o.find("model-viewer")[0])
              , c = s.data("model-id");
            if (0 === t) {
                var l = o.closest(i.productMediaGroupWrapper).find(i.xrButtonSingle);
                a[n] = {
                    $element: l,
                    defaultId: c
                }
            }
            e[r] = {
                modelId: c,
                sectionId: n,
                $container: o,
                $element: s
            }
        }),
        window.Shopify.loadFeatures([{
            name: "shopify-xr",
            version: "1.0",
            onLoad: r
        }]),
        e.length < 1 || (window.Shopify.loadFeatures([{
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: s
        }]),
        wpbingo.LibraryLoader.load("modelViewerUiStyles"))
    }
    function r(e) {
        if (!e) {
            if (!window.ShopifyXR) {
                document.addEventListener("shopify_xr_initialized", function(t) {
                    t.detail.shopifyXREnabled ? r() : $(i.xrButton).addClass(o.viewInSpaceDisabled)
                });
                return
            }
            for (var a in t)
                if (t.hasOwnProperty(a)) {
                    var n = t[a];
                    if (n.loaded)
                        continue;
                    var s = $("#ModelJson-" + a);
                    window.ShopifyXR.addModels(JSON.parse(s.html())),
                    n.loaded = !0
                }
            window.ShopifyXR.setupXRElements()
        }
    }
    function s(t) {
        if (!t) {
            for (var a in e)
                if (e.hasOwnProperty(a)) {
                    var i = e[a];
                    i.modelViewerUi || (i.modelViewerUi = new Shopify.ModelViewerUI(i.$element)),
                    c(i)
                }
        }
    }
    function c(t) {
        var e = a[t.sectionId]
          , o = t.$container.closest(i.productMediaGroup);
        t.$element.on("shopify_model_viewer_ui_toggle_play", function() {
            wpbingo.updateSlickSwipe(o, !1)
        }).on("shopify_model_viewer_ui_toggle_pause", function() {
            wpbingo.updateSlickSwipe(o, !0)
        }),
        t.$container.on("mediaVisible", function() {
            e.$element.attr("data-shopify-model3d-id", t.modelId),
            t.modelViewerUi.play()
        }),
        t.$container.on("mediaHidden", function() {
            e.$element.attr("data-shopify-model3d-id", e.defaultId),
            t.modelViewerUi.pause()
        }).on("xrLaunch", function() {
            t.modelViewerUi.pause()
        })
    }
    function l(a) {
        for (var i in e)
            e.hasOwnProperty(i) && e[i].sectionId === a && (e[i].modelViewerUi.destroy(),
            delete e[i]);
        delete t[a]
    }
    return {
        init: n,
        removeSectionModels: l
    }
}(),
wpbingo.ProductVideo = function() {
    var t = {}
      , e = {
        html5: "html5",
        youtube: "youtube"
    }
      , a = {
        productMediaWrapper: ".js-product-media",
        productMediaGroup: ".js-product-media-group"
    }
      , i = {
        enableVideoLooping: "enable-video-looping",
        videoId: "video-id"
    };
    function o(a, i) {
        if (a.length) {
            var o = a.find("iframe, video")[0]
              , c = a.data("mediaId");
            if (o) {
                t[c] = {
                    mediaId: c,
                    sectionId: i,
                    host: s(o),
                    container: a,
                    element: o,
                    ready: function() {
                        r(this)
                    }
                };
                var l = t[c];
                switch (l.host) {
                case e.html5:
                    window.Shopify.loadFeatures([{
                        name: "video-ui",
                        version: "1.1",
                        onLoad: n
                    }]),
                    wpbingo.LibraryLoader.load("plyrShopifyStyles");
                    break;
                case e.youtube:
                    wpbingo.LibraryLoader.load("youtubeSdk")
                }
            }
        }
    }
    function n(t) {
        if (t) {
            l();
            return
        }
        c(e.html5)
    }
    function r(t) {
        if (!t.player) {
            var o = t.container.closest(a.productMediaWrapper)
              , n = o.data(i.enableVideoLooping);
            switch (t.host) {
            case e.html5:
                t.player = new Shopify.Plyr(t.element,{
                    loop: {
                        active: n
                    }
                });
                var r = $(t.container).closest(a.productMediaGroup);
                t.player.on("seeking", function() {
                    wpbingo.updateSlickSwipe(r, !1)
                }),
                t.player.on("seeked", function() {
                    wpbingo.updateSlickSwipe(r, !0)
                });
                break;
            case e.youtube:
                var s = o.data(i.videoId);
                t.player = new YT.Player(t.element,{
                    videoId: s,
                    events: {
                        onStateChange: function(t) {
                            0 === t.data && n && t.target.seekTo(0)
                        }
                    }
                })
            }
            o.on("mediaHidden xrLaunch", function() {
                t.player && (t.host === e.html5 && t.player.pause(),
                t.host === e.youtube && t.player.pauseVideo && t.player.pauseVideo())
            }),
            o.on("mediaVisible", function() {
                t.player && (t.host === e.html5 && t.player.play(),
                t.host === e.youtube && t.player.playVideo && t.player.playVideo())
            })
        }
    }
    function s(t) {
        return "VIDEO" === t.tagName ? e.html5 : "IFRAME" === t.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src) ? e.youtube : null
    }
    function c(e) {
        for (var a in t)
            if (t.hasOwnProperty(a)) {
                var i = t[a];
                i.host === e && i.ready()
            }
    }
    function l() {
        for (var a in t)
            if (t.hasOwnProperty(a)) {
                var i = t[a];
                if (i.nativeVideo)
                    continue;
                i.host === e.html5 && (i.element.setAttribute("controls", "controls"),
                i.nativeVideo = !0)
            }
    }
    function d(e) {
        for (var a in t)
            if (t.hasOwnProperty(a)) {
                var i = t[a];
                i.sectionId === e && (i.player && i.player.destroy(),
                delete t[a])
            }
    }
    return {
        init: o,
        hosts: e,
        loadVideos: c,
        removeSectionVideos: d
    }
}(),
wpbingo.Product = function() {
    function t(t) {
        var e = $(window)
          , a = this.$container = $(t)
          , i = a.attr("data-section-id");
        this.settings = {
            productPageLoad: !1,
            preloadImage: !1,
            enableHistoryState: a.data("enable-history-state"),
            namespace: ".productSection",
            sectionId: i
        },
        this.selectors = {
            productMediaGroup: ".js-product-media-group",
            productMediaGroupItem: ".js-product-media-item",
            productMediaWrapper: ".js-product-media",
            productMediaTypeModel: "[data-product-media-type-model]",
            productMediaTypeVideo: "[data-product-media-type-video]",
            productThumbnails: ".js-product-thumbnails",
            buyTogether: ".buy-together-products",
            productThumbnail: "[data-product-thumbnail]",
            productImageZoom: "[data-mfp-src]",
            meta: ".product-single__meta",
            productWrapper: ".product-single",
            productSelectOption: ".js-product-select-option--",
            originalSelectorId: ".js-product-select",
            singleOptionSelector: ".js-single-option-selector",
            slickDots: "[data-slick-dots]",
            slickNext: "[data-slick-next]",
            slickPrevious: "[data-slick-previous]",
            variantColor: "[data-color]"
        },
        this.classes = {
            hide: "d-none",
            priceContainerUnitAvailable: "price-container--unit-available",
            productInventoryInStock: "product-avaiable__text--instock",
            productInventoryOutStock: "product-avaiable__text--outstock"
        },
        this.slickMediaSettings = {
            slide: this.selectors.productMediaGroupItem,
            rows: 0,
            accessibility: !0,
            arrows: !0,
            appendDots: this.selectors.slickDots,
            prevArrow: this.selectors.slickPrevious,
            nextArrow: this.selectors.slickNext,
            dots: !1,
            rtl: wpbingo.rtl_slick(),
            infinite: !!$(this.selectors.productMediaGroup).data("infinite"),
            draggable: !!$(this.selectors.productMediaGroup).data("draggable"),
            adaptiveHeight: !0,
            fade: !!$(this.selectors.productMediaGroup).data("fade"),
            customPaging: (function(t, e) {
                var a = wpbingo.strings.productSlideLabel.replace("[slide_number]", e + 1).replace("[slide_max]", t.slideCount)
                  , i = $('[data-slick-index="' + e + '"]', this.$container).data("slick-media-label")
                  , o = 0 === e ? ' aria-current="true"' : "";
                return '<a href="javascript:void(0)" aria-label="' + a + " " + i + '" aria-controls="slick-slide0' + e + '"' + o + "></a>"
            }
            ).bind(this)
        },
        $("#ProductJson-" + i).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML),
        this.zoomType = a.data("image-zoom-type"),
        this.isStackedLayout = a.data("stacked-layout"),
        this.isNothumLayout = a.data("nothum"),
        this.focusableElements = 'iframe,input,button,video,[tabindex="0"]',
        this.slickThumbsSettings = {
            slidesToShow: $(this.selectors.productThumbnails).data("columns"),
            slidesToScroll: 1,
            rows: 0,
            accessibility: !0,
            arrows: !0,
            dots: !1,
            infinite: !1,
            focusOnSelect: !0,
            adaptiveHeight: !0,
            rtl: !!$("body").hasClass("rtl") && !$(this.selectors.productThumbnails).data("vertical"),
            vertical: !!$(this.selectors.productThumbnails).data("vertical"),
            responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    vertical: !1
                }
            }, ]
        },
        !this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container) ? (this.slickMediaSettings.asNavFor = this.selectors.productThumbnails + "-" + i,
        this.slickThumbsSettings.asNavFor = this.selectors.productMediaGroup + "-" + i) : 991 > $(window).width() && "gird-sticky" == $(this.selectors.productWrapper).data("layout_thumb") && (this.slickMediaSettings.asNavFor = this.selectors.productThumbnails + "-" + i,
        this.slickThumbsSettings.asNavFor = this.selectors.productMediaGroup + "-" + i),
        this.view_gallery_product(),
        this.event_buy_together(),
        this.event_group_product(),
        this.initBreakpoints(),
        this.initProductVariant(),
        this.initModelViewerLibraries(),
        this.initShopifyXrLaunch(),
        this.initProductVideo(),
        this.initStickyProductMeta(),
        this.count_view_product(),
        this.count_sale_product(),
        this.percent_sale_product(),
        this.delivery_return(),
        this.ask_a_question(),
        this.back_in_stock(),
        this.single_product_share(),
        this.gallery_cursor(),
        this.discount_single(),
        this.sticky_gird(),
        this.sticky_sidebar(),
        this.image_360(),
        this.tab_information(),
        $(".product-single").data(),
        $(".product-single__video img").css("width", $(".product-single__thumbnail img").width()),
        $(".product-single__video img").css("height", $(".product-single__thumbnail img").height() - 2.5),
        e.on("load" + this.settings.namespace, wpbingo.initStickyProductMeta).on("resize" + this.settings.namespace, wpbingo.debounce(this.initStickyProductMeta, 150).bind(this)))
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        initBreakpoints: function() {
            var t = this;
            t.isStackedLayout ? 991 > $(window).width() ? (t.createMediaCarousel(),
            t.createThumbnailCarousel()) : enquire.register(wpbingo.variables.mediaMobile, {
                match: function() {
                    t.createMediaCarousel()
                },
                unmatch: function() {
                    t.destroyMediaCarousel()
                }
            }) : (t.createMediaCarousel(),
            t.createThumbnailCarousel())
        },
        initProductVariant: function() {
            var t = {
                $container: this.$container,
                enableHistoryState: this.settings.enableHistoryState || !1,
                productSelectOption: this.selectors.productSelectOption,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId + "--" + this.settings.sectionId,
                product: this.productSingleObject
            };
            this.variants = new wpbingo.Variants(t),
            this.$container.on("variantChange" + this.settings.namespace, this.productPage.bind(this)),
            this.$container.on("variantMediaChange" + this.settings.namespace, this.showVariantMedia.bind(this))
        },
        initModelViewerLibraries: function() {
            if (this.$container.data("has-model")) {
                var t = $(this.selectors.productMediaTypeModel, this.$container);
                wpbingo.ProductModel.init(t, this.settings.sectionId)
            }
        },
        initShopifyXrLaunch: function() {
            $(document).on("shopify_xr_launch", (function() {
                $(this.selectors.productMediaWrapper + ":not(." + this.classes.hide + ")", this.$container).trigger("xrLaunch")
            }
            ).bind(this))
        },
        initProductVideo: function() {
            var t = this.settings.sectionId;
            $(this.selectors.productMediaTypeVideo, this.$container).each(function() {
                var e = $(this);
                wpbingo.ProductVideo.init(e, t)
            })
        },
        trapCarouselFocus: function(t, e) {
            t && (t.find(".slick-slide:not(.slick-active)").find(this.focusableElements).attr("tabindex", e ? "0" : "-1"),
            t.find(".slick-active").find(this.focusableElements).attr("tabindex", "0"))
        },
        updateCarouselDotsA11y: function(t) {
            $(this.selectors.slickDots).find("a").removeAttr("aria-current").eq(t).attr("aria-current", "true")
        },
        view_gallery_product: function() {
            $element = $(".product-single"),
            $(".product-media__wrapper.product-media__wrapper--image", $element).bind("click", function(t) {
                t.preventDefault();
                var e = $(this).closest(".js-product-media-group")
                  , a = []
                  , i = []
                  , o = 0
                  , n = 0;
                if ($(".js-product-media-item", e).each(function() {
                    if ($("img", $(this)).data("number", o),
                    !0 == $("img", $(this)).data("image")) {
                        var t = $("img", $(this)).attr("src");
                        t && (i[o] = {
                            href: t
                        },
                        o++)
                    }
                }),
                i) {
                    $.each(i, function(t, e) {
                        e && (a[n] = {
                            src: e.href,
                            w: 3 * $(".mfp-image", $element).width(),
                            h: 3 * $(".mfp-image", $element).height()
                        },
                        n++)
                    });
                    var r = document.querySelectorAll(".pswp")[0]
                      , s = {
                        index: $("img", $(this)).data("number"),
                        closeOnScroll: !1,
                        history: !1,
                        shareEl: !1
                    }
                      , i = new PhotoSwipe(r,PhotoSwipeUI_Default,a,s);
                    i.init()
                }
            })
        },
        event_buy_together: function() {
            $(document).on("change", '#buy_together_form .item-product input[type="checkbox"]', function(t) {
                var e = $(this);
                e.closest(".item-product").hasClass("active") ? e.closest(".item-product").removeClass("active") : e.closest(".item-product").addClass("active"),
                moneyFormat = wpbingo.strings.moneyFormat;
                var a = e.closest(".item-products-wrap")
                  , i = a.closest(".buy-together-products")
                  , o = i.find(".item-products-wrap")
                  , n = 0
                  , r = 0;
                a.find(".item-product").each(function() {
                    var t = $(this).attr("data-product_id");
                    if ($(this).hasClass("active")) {
                        if ($('input[type="hidden"]', $(this)).prop("disabled", !1),
                        $('input[type="number"]', $(this)).prop("disabled", !1),
                        $("select", $(this)).length > 0) {
                            var e = $("select", $(this)).find(":selected").data("price");
                            $("select", $(this)).prop("disabled", !1)
                        } else
                            var e = $('input[type="checkbox"]', $(this)).attr("data-price");
                        isNaN(e) || (r = Number(r) + Number(e)),
                        n++,
                        o.find('.item-product-inner[data-product_id="' + t + '"]').removeClass("buy-together-hidden")
                    } else
                        o.find('.item-product-inner[data-product_id="' + t + '"]:not(.buy-together-content)').addClass("buy-together-hidden"),
                        $('input[type="hidden"]', $(this)).prop("disabled", !0),
                        $('input[type="number"]', $(this)).prop("disabled", !0),
                        $("select", $(this)).length > 0 && $("select", $(this)).prop("disabled", !0)
                }),
                i.find(".for-items-text span").html(n),
                i.find(".total-price-html span").html('<span class="money">' + wpbingo.Currency.formatMoney(r, moneyFormat) + "</span>"),
                $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
            }),
            $(document).on("change", "#buy_together_form .item-product select", function(t) {
                moneyFormat = wpbingo.strings.moneyFormat;
                var e = $(this).closest(".item-products-wrap")
                  , a = e.closest(".buy-together-products")
                  , i = 0
                  , o = 0
                  , n = $(this).closest(".item-product")
                  , r = n.attr("data-product_id")
                  , s = $(this).closest(".buy-together-products").find('.item-product-inner[data-product_id="' + r + '"]')
                  , c = $(this).find(":selected").data("price")
                  , l = $(this).find(":selected").data("image");
                $(".buy-together-price", n).html('<span class="money">' + wpbingo.Currency.formatMoney(c, moneyFormat) + "</span>"),
                $(".image img", s).attr("src", l),
                $(".image img", s).attr("srcset", l),
                e.find(".item-product").each(function() {
                    if ($(this).hasClass("active")) {
                        if ($("select", $(this)).length > 0)
                            var t = $("select", $(this)).find(":selected").data("price");
                        else
                            var t = $('input[type="checkbox"]', $(this)).attr("data-price");
                        isNaN(t) || (o = Number(o) + Number(t)),
                        i++
                    }
                }),
                a.find(".total-price-html span").html('<span class="money">' + wpbingo.Currency.formatMoney(o, moneyFormat) + "</span>"),
                $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
            }),
            $("#buy_together_form .buy-together-add-all-to-cart").on("click", function(t) {
                t.preventDefault(),
                $(this).addClass("active");
                let e = document.querySelector("#buy_together_form");
                var a = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(e),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(t) {
                        $(".buy-together-add-all-to-cart").removeClass("active"),
                        ajaxCart.load(),
                        $("body").addClass("drawer--open"),
                        $(".js-drawer-close").on("click", function() {
                            $("body").removeClass("drawer--open")
                        })
                    },
                    error: function(t, e) {
                        "function" == typeof errorCallback ? errorCallback(t, e) : ShopifyAPI.onError(t, e)
                    }
                };
                jQuery.ajax(a)
            })
        },
        event_group_product: function() {
            $("#group_table_product .add-group-to-cart").on("click", function(t) {
                t.preventDefault(),
                $(this).removeClass("added"),
                $(this).addClass("active");
                let e = document.querySelector("#group_table_product");
                var a = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(e),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(t) {
                        $("#group_table_product .add-group-to-cart").removeClass("active"),
                        $("#group_table_product .add-group-to-cart").addClass("added"),
                        setTimeout(function() {
                            $("#group_table_product .add-group-to-cart").removeClass("added")
                        }, 3e3),
                        ajaxCart.load(),
                        $("body").addClass("drawer--open"),
                        $(".js-drawer-close").on("click", function() {
                            $("body").removeClass("drawer--open")
                        })
                    },
                    error: function(t, e) {
                        "function" == typeof errorCallback ? errorCallback(t, e) : ShopifyAPI.onError(t, e)
                    }
                };
                jQuery.ajax(a)
            })
        },
        translateCarouselDots: function(t, e, a) {
            if (!(t <= a.max)) {
                var i = 0
                  , o = (t - a.max) * a.width;
                e >= a.max - 1 && (i = o < (i = (e + 2 - a.max) * a.width) ? o : i),
                $(this.selectors.slickDots).find("ul").css("transform", "translateX(-" + i + "px)")
            }
        },
        triggerMediaChangeEvent: function(t) {
            $(this.selectors.productMediaWrapper, this.$container).trigger("mediaHidden"),
            $(this.selectors.productMediaWrapper, this.$container).filter('[data-media-id="' + t + '"]').trigger("mediaVisible")
        },
        showVariantMedia: function(t) {
            var e, a = t.variant, i = this.settings.sectionId + "-" + a.featured_media.id, o = $(this.selectors.productMediaWrapper + '[data-media-id="' + i + '"]');
            if (this.triggerMediaChangeEvent(i),
            !wpbingo.variables.isMobile && this.isStackedLayout) {
                if (0 !== (e = o.closest(".slick-slide").index()) || wpbingo.variables.productPageLoad) {
                    if (wpbingo.variables.productPageSticky)
                        $("html, body").animate({
                            scrollTop: o.offset().top
                        }, 250);
                    else {
                        var n = $(document).scrollTop();
                        o.closest($(this.selectors.productMediaGroupItem, this.$container)).prependTo($(this.selectors.productMediaGroup, this.$container)),
                        $(document).scrollTop(n)
                    }
                }
            } else {
                if (e = o.closest(".slick-slide").data("slick-index"),
                _.isUndefined(e))
                    return;
                (0 !== e || wpbingo.variables.productPageLoad) && $(this.selectors.productMediaGroup, this.$container).slick("slickGoTo", e)
            }
            wpbingo.variables.productPageLoad || (wpbingo.variables.productPageLoad = !0)
        },
        setFeaturedMedia: function() {
            var t = $(this.selectors.productMediaGroup, this.$container).find(".slick-slide.slick-current.slick-active " + this.selectors.productMediaWrapper).attr("data-media-id");
            this.triggerMediaChangeEvent(t)
        },
        createMediaCarousel: function() {
            if (!($(this.selectors.productMediaGroupItem).length < 2) && $(this.selectors.productMediaGroup, this.$container) && !this.isCarouselActive) {
                this.isCarouselActive = !0;
                var t = {
                    max: 9,
                    width: 20
                }
                  , e = !1;
                if ($(this.selectors.productMediaGroupItem, this.$container).on("focusin", (function() {
                    !e && (this.trapCarouselFocus($(this.selectors.productMediaGroup)),
                    e = !0)
                }
                ).bind(this)),
                $(".mutil_slider-single").length > 0) {
                    var a = this.settings.sectionId
                      , i = this.slickMediaSettings;
                    if (!this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container))
                        var o = !0;
                    $(".mutil_slider-single").each(function(t) {
                        i.nextArrow = $("[data-slick-next]", $(this)),
                        i.prevArrow = $("[data-slick-previous]", $(this)),
                        o && (i.asNavFor = ".js-product-thumbnails-" + a + "-" + (t + 1)),
                        $(".js-product-media-group", $(this)).slick(i)
                    })
                } else
                    $(this.selectors.productMediaGroup, this.$container).slick(this.slickMediaSettings).on("beforeChange", (function(e, a, i, o) {
                        this.updateCarouselDotsA11y(o),
                        this.translateCarouselDots(a.slideCount, o, t)
                    }
                    ).bind(this));
                $(window).width() > 991 && "slider" == $(this.selectors.productWrapper).data("layout_thumb") && $(".js-product-media-group", this.selectors.productWrapper).slick("slickGoTo", 1)
            }
        },
        destroyMediaCarousel: function() {
            $(this.selectors.productMediaGroup, this.$container).length && this.isCarouselActive && (this.trapCarouselFocus($(this.selectors.productMediaGroup, this.$container), !0),
            $(this.selectors.productMediaGroup, this.$container).slick("unslick"),
            this.isCarouselActive = !1)
        },
        createThumbnailCarousel: function() {
            if (!($(this.selectors.productMediaGroupItem).length < 2) && $(this.selectors.productMediaGroup, this.$container)) {
                if ($(".mutil_slider-single").length > 0) {
                    var t = this.settings.sectionId
                      , e = this.slickThumbsSettings;
                    if (!this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container))
                        var a = !0;
                    $(".mutil_slider-single").each(function(i) {
                        a && (e.asNavFor = ".js-product-media-group-" + t + "-" + (i + 1)),
                        $(".js-product-thumbnails", $(this)).slick(e)
                    })
                } else
                    $(this.selectors.productThumbnails, this.$container).slick(this.slickThumbsSettings)
            }
        },
        initStickyProductMeta: function() {
            var t = $(this.selectors.meta, this.$container)
              , e = $(this.selectors.productWrapper, this.$container);
            if (t.length && !($(this.selectors.productMediaWrapper, this.$container).length < 2)) {
                if (t.trigger("detach.ScrollToFixed"),
                !wpbingo.variables.isMobile) {
                    var a = t.outerHeight()
                      , i = $(this.selectors.productMediaGroup, this.$container).height()
                      , o = e.offset().top + e.height();
                    o -= a,
                    a < i && a < $(window).height() ? (wpbingo.variables.productPageSticky = !0,
                    t.scrollToFixed({
                        limit: o
                    })) : wpbingo.variables.productPageSticky = !1
                }
            }
        },
        getBaseUnit: function(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
        },
        productPage: function(t) {
            var e = wpbingo.strings.moneyFormat
              , a = t.variant
              , i = wpbingo.strings
              , o = {
                addToCart: ".btn--add-to-cart",
                addToCartText: ".btn--add-to-cart .btn__text",
                quantityElements: ".js-quantity-selector",
                shopifyPaymentButton: ".shopify-payment-button",
                priceContainer: "[data-price-container]",
                productPrice: ".js-product-price",
                priceA11y: ".js-product-price-a11y",
                comparePrice: ".js-product-compare-price",
                comparePriceA11y: ".js-product-compare-price-a11y",
                comparePriceWrapper: ".product-single__price--wrapper",
                productAvailable: ".js-product-avaiable",
                productAvailableText: ".js-product-avaiable-text",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-price-base-unit]",
                SKU: ".js-variant-sku"
            };
            if (a) {
                if ($(o.priceContainer, this.$container).removeClass(this.classes.hide),
                $(o.productAvailable, this.$container).removeClass(this.classes.hide),
                $(o.productPrice, this.$container).attr("aria-hidden", "false"),
                $(o.priceA11y, this.$container).attr("aria-hidden", "false"),
                a.available ? ($(o.addToCart, this.$container).removeClass("disabled").prop("disabled", !1),
                $(o.addToCartText, this.$container).html(i.addToCart),
                $(o.productAvailableText).removeClass(this.classes.productInventoryOutStock).addClass(this.classes.productInventoryInStock).html(wpbingo.strings.inStock),
                $(o.quantityElements, this.$container).removeClass(this.classes.hide),
                $(o.shopifyPaymentButton, this.$container).removeClass(this.classes.hide)) : ($(o.addToCart, this.$container).addClass("disabled").prop("disabled", !0),
                $(o.addToCartText, this.$container).html(i.soldOut),
                $(o.productAvailableText).removeClass(this.classes.productInventoryInStock).addClass(this.classes.productInventoryOutStock).html(wpbingo.strings.outStock),
                $(o.quantityElements, this.$container).addClass(this.classes.hide),
                $(o.shopifyPaymentButton, this.$container).addClass(this.classes.hide)),
                $(o.productPrice, this.$container).html(wpbingo.Currency.formatMoney(a.price, e)).removeClass(this.classes.hide),
                a.compare_at_price > a.price ? ($(o.comparePrice, this.$container).html(wpbingo.Currency.formatMoney(a.compare_at_price, e)),
                $(o.comparePriceWrapper, this.$container).removeClass(this.classes.hide),
                $(o.productPrice, this.$container).addClass("on-sale"),
                $(o.comparePriceWrapper, this.$container).attr("aria-hidden", "false"),
                $(o.comparePriceA11y, this.$container).attr("aria-hidden", "false")) : ($(o.comparePriceWrapper, this.$container).addClass(this.classes.hide).attr("aria-hidden", "true"),
                $(o.productPrice, this.$container).removeClass("on-sale"),
                $(o.comparePrice, this.$container).html(""),
                $(o.comparePriceA11y, this.$container).attr("aria-hidden", "true")),
                a.unit_price) {
                    var n = $(o.unitPrice, this.$container)
                      , r = $(o.unitPriceBaseUnit, this.$container);
                    n.html(wpbingo.Currency.formatMoney(a.unit_price, e)),
                    r.html(this.getBaseUnit(a)),
                    $(o.priceContainer, this.$container).addClass(this.classes.priceContainerUnitAvailable)
                }
                $(o.SKU).html("" != a.sku ? a.sku : "N/A")
            } else
                $(o.addToCart, this.$container).addClass("disabled").prop("disabled", !0),
                $(o.addToCartText, this.$container).html(i.unavailable),
                $(o.quantityElements, this.$container).addClass(this.classes.hide),
                $(o.shopifyPaymentButton, this.$container).addClass(this.classes.hide),
                $(o.priceContainer, this.$container).addClass(this.classes.hide),
                $(o.productAvailable, this.$container).addClass(this.classes.hide),
                $(o.productPrice, this.$container).attr("aria-hidden", "true"),
                $(o.priceA11y, this.$container).attr("aria-hidden", "true"),
                $(o.comparePriceWrapper, this.$container).attr("aria-hidden", "true"),
                $(o.comparePriceA11y, this.$container).attr("aria-hidden", "true")
        },
        onUnload: function() {
            this.$container.off(this.settings.namespace),
            wpbingo.ProductModel.removeSectionModels(this.settings.sectionId),
            wpbingo.ProductVideo.removeSectionVideos(this.settings.sectionId),
            this.isStackedLayout && $(window).width() > 991 && this.destroyMediaCarousel()
        },
        count_view_product: function() {
            if ($(".product-count-view").length > 0) {
                $(".product-count-view").data("id_product");
                var t = $(".product-count-view").data("min") ? $(".product-count-view").data("min") : 30
                  , e = $(".product-count-view").data("max") ? $(".product-count-view").data("max") : 40
                  , a = $(".product-count-view").data("timeout") ? $(".product-count-view").data("timeout") : 1e4
                  , i = Math.round(Math.random() * (e - t)) + t;
                $("span", ".product-count-view").html(i),
                setTimeout(function i() {
                    var o = Math.round(Math.random() * (e - t)) + t;
                    $("span", ".product-count-view").html(o),
                    setTimeout(i, a)
                }, a)
            }
        },
        count_sale_product: function() {
            if ($(".product-count-sale").length > 0) {
                var t = $(".product-count-sale").data("id_product")
                  , e = $(".product-count-sale").data("min") ? $(".product-count-sale").data("min") : 30
                  , a = $(".product-count-sale").data("max") ? $(".product-count-sale").data("max") : 40
                  , i = $(".product-count-sale").data("time_min") ? $(".product-count-sale").data("time_min") : 30
                  , o = $(".product-count-sale").data("time_max") ? $(".product-count-sale").data("time_max") : 40
                  , n = wpbingo.getCookie("product_" + t)
                  , r = wpbingo.getCookie("time_" + t);
                if (n && r)
                    $("span.count", ".product-count-sale").html(n),
                    $("span.time", ".product-count-sale").html(r);
                else {
                    var s = Math.round(Math.random() * (a - e)) + e
                      , c = Math.round(Math.random() * (o - i)) + i;
                    wpbingo.setCookie("product_" + t, s, {
                        expires: 864e5
                    }),
                    wpbingo.setCookie("time_" + t, c, {
                        expires: 864e5
                    }),
                    $("span.count", ".product-count-sale").html(s),
                    $("span.time", ".product-count-sale").html(c)
                }
            }
        },
        percent_sale_product: function() {
            setTimeout(function() {
                var t = $(".js-product-avaiable #variant-inventory_percent.show").data("percent");
                $(".js-product-avaiable #variant-inventory_percent .percent").css("--progress-bar-width", t)
            }, 500)
        },
        delivery_return: function() {
            if ($(".product-single .delivery_return").length > 0) {
                var t = $(".product-single .delivery_return");
                $(".content-shipping", t).slideUp(),
                $(".delivery_return-title", t).on("click", function() {
                    $(".delivery_return-content", t).hasClass("active") || ($(".delivery_return-content", t).addClass("active"),
                    $(".content-shipping", t).slideDown())
                }),
                $(".delivery_return-close", t).on("click", function() {
                    $(".delivery_return-content", t).hasClass("active") && ($(".content-shipping", t).slideUp(),
                    setTimeout(function() {
                        $(".delivery_return-content", t).removeClass("active")
                    }, 500))
                })
            }
        },
        ask_a_question: function() {
            $(".product-single .product-ask_a_question").length > 0 && ($(".product-ask_a_question .ask_a_question-form .content-form").slideUp(),
            $(".product-ask_a_question .open-ask_a_question").on("click", function() {
                $(".product-ask_a_question .ask_a_question-form").hasClass("active") ? $(".product-ask_a_question .ask_a_question-form").removeClass("active") : ($(".product-ask_a_question .ask_a_question-form").addClass("active"),
                $(".product-ask_a_question .ask_a_question-form .content-form").slideDown())
            }),
            $(".product-ask_a_question .close-ask_a_question-form").on("click", function() {
                $(".product-ask_a_question .ask_a_question-form").hasClass("active") && ($(".product-ask_a_question .ask_a_question-form .content-form").slideUp(),
                setTimeout(function() {
                    $(".product-ask_a_question .ask_a_question-form").removeClass("active")
                }, 500))
            }),
            setTimeout(function() {
                $(".product-ask_a_question .alert").remove()
            }, 2e3))
        },
        back_in_stock: function() {
            $(".product-single .product-back_in_stock").length > 0 && ($(".product-back_in_stock .back_in_stock-form .content-form").slideUp(),
            $(".product-back_in_stock .open-back_in_stock").on("click", function() {
                $(".product-back_in_stock .back_in_stock-form").hasClass("active") ? $(".product-back_in_stock .back_in_stock-form").removeClass("active") : ($(".product-back_in_stock .back_in_stock-form").addClass("active"),
                $(".product-back_in_stock .back_in_stock-form .content-form").slideDown())
            }),
            $(".product-back_in_stock .close-back_in_stock-form").on("click", function() {
                $(".product-back_in_stock .back_in_stock-form").hasClass("active") && ($(".product-back_in_stock .back_in_stock-form .content-form").slideUp(),
                setTimeout(function() {
                    $(".product-back_in_stock .back_in_stock-form").removeClass("active")
                }, 500))
            }),
            setTimeout(function() {
                $(".product-back_in_stock .alert").remove()
            }, 2e3))
        },
        single_product_share: function() {
            if ($(".product-single .product_share").length > 0) {
                var t = $(".product-single .product_share");
                $(".content-product_share", t).slideUp(),
                $(".product_share_label", t).on("click", function() {
                    $(".product_share-content", t).hasClass("active") || ($(".product_share-content", t).addClass("active"),
                    $(".content-product_share", t).slideDown())
                }),
                $(".product_share-close", t).on("click", function() {
                    $(".product_share-content", t).hasClass("active") && ($(".content-product_share", t).slideUp(),
                    setTimeout(function() {
                        $(".product_share-content", t).removeClass("active")
                    }, 500))
                }),
                $(".product_share-copy button", t).click(function() {
                    var e = $(".product_share-copy .url_share", t).attr("value")
                      , a = $(".product_share-copy", t).data("text")
                      , i = $("<input>");
                    $("body").append(i),
                    i.val(e).select(),
                    document.execCommand("copy"),
                    i.remove();
                    var o = $("div.copy-notification");
                    0 == o.length && (o = $("<div/>", {
                        class: "copy-notification",
                        text: a
                    }),
                    $("body").append(o),
                    o.fadeIn("slow", function() {
                        setTimeout(function() {
                            o.fadeOut("slow", function() {
                                o.remove()
                            })
                        }, 1e3)
                    }))
                })
            }
        },
        gallery_cursor: function() {
            $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mouseenter(function() {
                $(".gallery-cursor", $(this)).addClass("show")
            }),
            $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mousemove(function(t) {
                var e = $(this).offset()
                  , a = t.pageX - e.left - 25
                  , i = t.pageY - e.top - 25;
                $(".gallery-cursor", $(this)).css({
                    top: i + "px",
                    left: a + "px"
                })
            }),
            $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mouseleave(function(t) {
                $(".gallery-cursor", $(this)).removeClass("show")
            })
        },
        discount_single: function() {
            $(".product-single #buy_more_form").length > 0 && $("#buy_more_form .buy-more-cart").on("click", function(t) {
                t.preventDefault(),
                $(this).addClass("active");
                let e = document.querySelector("#buy_more_form");
                var a = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(e),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(t) {
                        $(".buy-more-cart").removeClass("active"),
                        $(".buy-more-cart").addClass("added"),
                        $("body").addClass("drawer--open"),
                        $(".js-drawer-close").on("click", function() {
                            $("body").removeClass("drawer--open")
                        }),
                        ajaxCart.load(),
                        wpbingo.discount_single()
                    },
                    error: function(t, e) {
                        "function" == typeof errorCallback ? errorCallback(t, e) : ShopifyAPI.onError(t, e)
                    }
                };
                jQuery.ajax(a)
            })
        },
        sticky_gird: function() {
            if ($(window).width() > 992 && $(".product-single.gird-sticky").length > 0) {
                var t = $(".product-single.gird-sticky")
                  , e = []
                  , a = 0
                  , i = 0
                  , o = $(".js-product-media-group .js-product-media-item", t);
                $(".js-product-thumbnails a", t).on("click", function() {
                    var e = $(this).data("media-id")
                      , a = $(".js-product-media-group .js-product-media[data-media-id=" + e + "]", t);
                    $("html, body").animate({
                        scrollTop: a.offset().top
                    }, "300"),
                    a.css({
                        "padding-top": "15px"
                    }),
                    $(this).addClass("slick-current")
                }),
                $(window).on("load scroll resize", function() {
                    e = [],
                    a = 0,
                    o.each(function(t, a) {
                        e.push($(a).offset().top)
                    });
                    for (var n = 0; n < e.length; n++)
                        $(window).scrollTop() + .5 * $(window).height() > e[n] && a++;
                    a !== i && (i = a,
                    $(".js-product-thumbnails .product-single__thumbnail-wrapper", t).removeClass("slick-current"),
                    $(".js-product-thumbnails .product-single__thumbnail-wrapper", t).eq(a - 1).addClass("slick-current"))
                });
                var n = $(".js-product-single-media", t)
                  , r = $(".js-product-thumbnails", t).offset.left
                  , s = $(".js-product-thumbnails", t).width() + "px"
                  , c = $(".js-product-thumbnails", t).offset().top;
                n.height() > $(".js-product-thumbnails", t).height() && $(window).scroll(function() {
                    var e = $(window).scrollTop()
                      , a = $(".js-product-thumbnails", t).height() + "px"
                      , i = n.height() + n.offset().top - e;
                    e + 10 > c ? $(".js-product-thumbnails", t).css({
                        position: "fixed",
                        top: "15px",
                        left: r,
                        width: s,
                        height: a
                    }) : ($(".js-product-thumbnails", t).removeAttr("style"),
                    $(".js-product-media-group .js-product-media", t).removeAttr("style")),
                    i < $(".js-product-thumbnails", t).height() && $(".js-product-thumbnails", t).css({
                        position: "absolute",
                        top: n.height() - $(".js-product-thumbnails", t).height() + "px",
                        left: r,
                        width: s,
                        height: a
                    })
                });
                var l = 2 * $(".js-product-media-item", n).height()
                  , d = $(".product-single__metas", t).offset.left
                  , u = $(".product-single__metas", t).width() + "px"
                  , p = $(".product-single__metas", t).offset().top;
                n.height() > $(".product-single__metas", t).height() + l && $(window).scroll(function() {
                    var e = $(window).scrollTop()
                      , a = $(".product-single__metas", t).height() + "px"
                      , i = n.height() + n.offset().top - e;
                    e + 10 > p ? $(".product-single__metas", t).css({
                        position: "fixed",
                        top: "15px",
                        left: d,
                        width: u,
                        height: a
                    }) : $(".product-single__metas", t).removeAttr("style"),
                    i < $(".product-single__metas", t).height() + l && $(".product-single__metas", t).css({
                        position: "absolute",
                        top: n.height() - $(".product-single__metas", t).height() - l + "px",
                        left: d,
                        width: u,
                        height: a
                    })
                })
            }
        },
        sticky_sidebar: function() {
            if (1199 > $(window).width() && $(".product-single .bwp-single-sidebar").length > 0) {
                var t = $(".product-single .bwp-single-sidebar");
                $(".product-single .toggle-sidebar").on("click", function() {
                    t.hasClass("show") ? t.removeClass("show") : t.addClass("show")
                })
            }
        },
        image_360: function() {
            $(".product-single .bwp-image-360").length > 0 && $(".product-single .bwp-image-360").TreeSixtyImageRotate({
                totalFrames: $(".product-single .bwp-image-360").data("count"),
                endFrame: $(".product-single .bwp-image-360").data("count")
            }).initTreeSixty()
        },
        tab_information: function() {
            if ($(".template-product .product-more-info").length > 0) {
                var t = $(".template-product .product-more-info");
                $(window).width() > 991 ? $(".more-info-tabs__nav-link", t).on("click", function() {
                    var e = $(this).data("id");
                    $(".more-info-tabs__nav-link", t).removeClass("active"),
                    $(".more-info-tabs__content .tab-pane", t).removeClass("show"),
                    $(this).addClass("active"),
                    $("#" + e, t).addClass("show")
                }) : ($(".more-info-tabs__content .tab-pane", t).removeClass("show"),
                $(".more-info-tabs__nav-link", t).on("click", function() {
                    var e = $(this).data("id");
                    $(".more-info-tabs__content .tab-pane", t).slideUp(),
                    $("body,html").animate({
                        scrollTop: $(".more-info-tabs__content").offset().top - 50
                    }, 600),
                    $(this).hasClass("active") ? ($("#" + e, t).slideUp(),
                    $(".more-info-tabs__nav-link", t).removeClass("active")) : ($("#" + e, t).slideDown(),
                    $(".more-info-tabs__nav-link", t).removeClass("active"),
                    $(this).addClass("active"))
                }))
            }
        }
    }),
    t
}(),
wpbingo.ProductRecommendations = function() {
    function t(t) {
        this.$container = $(t);
        var e, a = this, i = this.$container.data("baseUrl") + "?section_id=product-recommendations&product_id=" + this.$container.data("productId") + "&limit=6";
        $.get(i).then(function(t) {
            var e = $(t).html();
            if ("" !== e.trim()) {
                a.$container.html(e);
                var i = $('[data-section-type="product-recommendations"]')
                  , o = $('[data-section-type="product-recommendations"]').data("title")
                  , n = $(".js-product-recommendations", a.$container);
                $(".wpbingo-title__heading", i).html(o),
                n.slick({
                    slidesToShow: i.data("columns"),
                    autoplay: i.data("autoplay"),
                    autoplaySpeed: i.data("autoplayspeed"),
                    arrows: i.data("nav"),
                    infinite: i.data("infinite"),
                    slidesToScroll: i.data("slidestoscroll") ? i.data("columns") : 1,
                    rtl: wpbingo.rtl_slick(),
                    responsive: [{
                        breakpoint: 1441,
                        settings: {
                            slidesToShow: i.data("column1440") ? i.data("column1440") : i.data("column"),
                            slidesToScroll: i.data("column1440") ? i.data("column1440") : i.data("column")
                        }
                    }, {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: i.data("column1"),
                            slidesToScroll: i.data("column1")
                        }
                    }, {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: i.data("column2"),
                            slidesToScroll: i.data("column2")
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: i.data("column3"),
                            slidesToScroll: i.data("column3")
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: i.data("column4"),
                            slidesToScroll: i.data("column4")
                        }
                    }]
                }),
                initButtons(".js-product-recommendations"),
                initButtonsCompare(".js-product-recommendations"),
                wpbingo.countdown(),
                wpbingo.click_atribute_image(),
                wpbingo.zoom_thumb(),
                wpbingo.popup_product_card(),
                $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
                $(".product-card__image-wrapper.slider").each(function() {
                    wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                })
            }
        })
    }
    return t
}(),
wpbingo.HeaderSection = function() {
    var t = {
        disclosureLocale: "[data-disclosure-locale]",
        disclosureCurrency: "[data-disclosure-currency]",
        searchOptions: ".js-header-search-options",
        searchMobileToggle: ".js-header-search-toggle",
        menuMobileToggle: ".js-menu-mobile",
        menuMobileChildToggle: ".js-mm-nav-item"
    };
    function e(t) {
        this.$container = $(t),
        this.cache = {},
        this.cacheSelectors();
        var e = $("body");
        this.cache.$localeDisclosure.length && (this.localeDisclosure = new wpbingo.Disclosure(this.cache.$localeDisclosure)),
        this.cache.$currencyDisclosure.length && (this.currencyDisclosure = new wpbingo.Disclosure(this.cache.$currencyDisclosure)),
        this.cache.$searchOptions.on("click", function(t) {
            t.preventDefault();
            var e = $(this)
              , a = e.closest("form");
            a.find(".js-header-search-options").removeClass("active"),
            e.addClass("active"),
            a.find(".dropdown-toggle").text(e.text()),
            a.find(".js-search-type").val(e.data("type"))
        }),
        this.cache.$searchMobileToggle.on("click", function(t) {
            t.preventDefault(),
            e.toggleClass("modal-search--open")
        }),
        this.cache.$menuMobileToggle.on("click", function(t) {
            t.preventDefault(),
            e.toggleClass("menu-mobile--open")
        }),
        this.cache.$menuMobileChildToggle.on("click", function(t) {
            t.preventDefault();
            var e = $(this);
            e.hasClass("mm-nav__prev") ? e.closest(".active--hidden").removeClass("active--hidden") : e.parents(".mm-nav__links").addClass("active--hidden"),
            e.closest(".menu-mobile__nav-item").toggleClass("active")
        })
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $localeDisclosure: this.$container.find(t.disclosureLocale),
                $currencyDisclosure: this.$container.find(t.disclosureCurrency),
                $searchOptions: this.$container.find(t.searchOptions),
                $searchMobileToggle: this.$container.find(t.searchMobileToggle),
                $menuMobileToggle: this.$container.find(t.menuMobileToggle),
                $menuMobileChildToggle: this.$container.find(t.menuMobileChildToggle)
            }
        },
        onUnload: function() {
            this.cache.$localeDisclosure.length && this.localeDisclosure.unload(),
            this.cache.$currencyDisclosure.length && this.currencyDisclosure.unload()
        }
    }),
    e
}(),
wpbingo.LoginRegister = function() {
    var t = {
        loginForm: ".js-login-form",
        recoverPasswordForm: ".js-recover-password",
        recoverPasswordToggle: ".js-forget-password",
        recoverPasswordSuccess: ".js-recover-password-success"
    };
    function e(t) {
        this.$container = $(t),
        this.cache = {},
        this.classes = {
            hidden: "d-none"
        },
        this.cacheSelectors(),
        this.initializeEvents(),
        this.resetPasswordSuccess()
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $loginForm: this.$container.find(t.loginForm),
                $recoverPasswordForm: this.$container.find(t.recoverPasswordForm),
                $recoverPasswordToggle: this.$container.find(t.recoverPasswordToggle),
                $recoverPasswordSuccess: this.$container.find(t.recoverPasswordSuccess)
            }
        },
        initializeEvents: function() {
            this.cache.$recoverPasswordToggle.length && this.cache.$recoverPasswordToggle.on("click", (function(t) {
                t.preventDefault();
                var e = !this.cache.$loginForm.hasClass(this.classes.hidden);
                this.displayRecoverPasswordForm(e)
            }
            ).bind(this)),
            "#recover" === window.location.hash && this.displayRecoverPasswordForm(!0)
        },
        displayRecoverPasswordForm: function(t) {
            t ? (this.cache.$loginForm.addClass(this.classes.hidden),
            this.cache.$recoverPasswordForm.removeClass(this.classes.hidden)) : (this.cache.$loginForm.removeClass(this.classes.hidden),
            this.cache.$recoverPasswordForm.addClass(this.classes.hidden))
        },
        resetPasswordSuccess: function() {
            void 0 !== window.resetPassword && window.resetPassword && this.cache.$recoverPasswordSuccess.removeClass(this.classes.hidden)
        }
    }),
    e
}(),
wpbingo.Search = function() {
    var t = {
        search: "[data-search]",
        searchPagination: ".search-pagination a"
    };
    function e(e) {
        var a = function() {
            void 0 !== ajaxCart && ajaxCart.init({
                formSelector: ".search-results [data-product-form]"
            })
        }
          , i = function(t, e) {
            $.get(e, function(e) {
                t.html(e),
                a()
            })
        }
          , o = function(t) {
            t.each(function() {
                var t = $(this);
                $.get(t.data("url"), function(e) {
                    t.html(e),
                    a()
                })
            })
        };
        this.$container = $(e),
        this.cache = {},
        this.cacheSelectors(),
        this.cache.$search.length && o(this.cache.$search),
        this.$container.on("click", t.searchPagination, function(e) {
            e.preventDefault();
            var a = $(this).parents(t.search)
              , o = $(this).attr("href");
            i(a, o)
        })
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $search: this.$container.find(t.search)
            }
        }
    }),
    e
}(),
wpbingo.QuickView = function() {
    var t = {
        body: "body",
        quickView: "[data-quickview]",
        quickViewTemplate: "#quickview-template",
        quickViewBtn: ".js-btn-quickview",
        quickViewContainer: "[data-quickview-container]",
        quickViewClose: "[data-quickview-close]",
        quickViewImages: "[data-quickview-images]",
        quickViewReview: "[data-quickview-review]",
        quickViewReview: "[data-quickview-review]",
        quickviewVariant: ".js-quickview-option-selector",
        originalSelectorId: "[data-quickview-variant]",
        quickViewProductPrice: ".js-qv-product-price",
        quickViewProductPriceCompare: ".js-qv-product-price-compare",
        quickViewQty: "[data-quickview-quantity]",
        quickViewSKU: "[data-quickview-sku]",
        quickViewAvaiable: ".product-avaiable",
        quickViewAvaiableInStock: ".product-avaiable--instock",
        quickViewAvaiableOutStock: ".product-avaiable--outstock",
        quickViewProductDetailsURL: ".js-qv-product-details"
    };
    function e(t) {
        this.$container = $(t),
        this.cache = {},
        this.productVariants = [],
        this.currentVariant = {},
        this.cacheSelectors(),
        this.initializeEvents()
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $body: $("body"),
                $quickViewContainer: this.$container.find(t.quickViewContainer)
            }
        },
        initializeEvents: function() {
            var e = this;
            $(t.body).on("click", t.quickViewBtn, function(a) {
                a.preventDefault();
                var i = $(this).data("handle");
                $(this).addClass("load-quickview"),
                $.getJSON("/products/" + i + ".js", function(a) {
                    a.available ? e.firstAvailableVariant(a.variants, e) : e.currentVariant = a.variants[0],
                    $(t.quickViewBtn).removeClass("load-quickview"),
                    e.buildQuickView(a),
                    e.buildMetafields(a),
                    e.renderReview(),
                    e.createImageCarousel(),
                    $("[data-quickview]").addClass("show"),
                    setTimeout(function() {
                        $("[data-quickview]").addClass("show-content")
                    }, 300),
                    setTimeout(function() {
                        $("[data-quickview]").addClass("transition")
                    }, 600);
                    var i = $(".quickview .product-quickview__variants .variants-wrapper");
                    $(i).each(function() {
                        var t = $(this);
                        if ($("select", t).length > 0)
                            var e = $("select", t).find(":selected").val();
                        else
                            var e = $("input:checked", t).attr("value");
                        $(".variants__label span", t).html(e)
                    })
                })
            }),
            $(t.body).on("click", t.quickViewClose, function(t) {
                t.preventDefault(),
                $("[data-quickview]").removeClass("transition"),
                setTimeout(function() {
                    $("[data-quickview]").removeClass("show-content")
                }, 400),
                setTimeout(function() {
                    $("[data-quickview]").removeClass("show")
                }, 700)
            }),
            $(t.quickViewContainer).on("change", t.quickviewVariant, function(t) {
                e.onVariantChange()
            })
        },
        firstAvailableVariant: function(t, e) {
            e.productVariants = t;
            for (var a = 0; a < t.length; a++) {
                var i = t[a];
                if (i.available) {
                    e.currentVariant = i;
                    break
                }
            }
        },
        buildQuickView: function(e) {
            var a = wpbingo.strings.moneyFormat
              , i = this.currentVariant
              , o = $(t.quickViewTemplate).html()
              , n = Handlebars.compile(o)
              , r = ""
              , s = ""
              , c = {
                id: e.id
            };
            if (void 0 !== e.media) {
                r += '<div class="quickview-images__list slick-carousel" data-quickview-images>';
                for (var l = 0; l < e.media.length; l++) {
                    var d = e.media[l];
                    "image" === d.media_type && (r += '<div class="slick-carousel__item"><div class="quickview-images__item" data-media-id=' + d.id + '><img class="img-fluid" alt="' + e.title + '" src="' + d.src + '" /></div></div>')
                }
                r += "</div>"
            }
            c.variantID = i.id,
            c.sku = null !== i.sku && "" !== i.sku ? i.sku : "N/A",
            c.images = r,
            c.title = e.title,
            c.url = e.url,
            c.vendor = e.vendor,
            s += '<div class="price-container">',
            s += '<div class="js-qv-product-price-compare product-single__price--compare-at ' + (null !== e.compare_at_price ? "" : "d-none") + '">' + wpbingo.Currency.formatMoney(e.compare_at_price, a) + "</div>",
            s += '<div class="js-qv-product-price product-single__price">' + wpbingo.Currency.formatMoney(e.price, a) + "</div>",
            s += '</div">',
            c.price = s,
            c.vendor = e.vendor,
            c.type = e.type,
            c.variants = this.buildVariant(e),
            $(t.quickViewContainer).html(n(c)),
            this.updateMedia(i),
            this.updateSKU(i),
            this.updateProductAvaiable(i),
            this.updateDetailsLink(i),
            $("#form-simple-addtocart .btn--add-to-cart").on("click", function(t) {
                t.preventDefault(),
                $(this).removeClass("added"),
                $(this).addClass("active");
                let e = document.querySelector("#form-simple-addtocart");
                var a = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(e),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(t) {
                        $("#form-simple-addtocart .btn--add-to-cart").removeClass("active"),
                        $("#form-simple-addtocart .btn--add-to-cart").addClass("added"),
                        setTimeout(function() {
                            $("#form-simple-addtocart .btn--add-to-cart").removeClass("added")
                        }, 2e3),
                        ajaxCart.load(),
                        $("body").addClass("drawer--open"),
                        $(".js-drawer-close").on("click", function() {
                            $("body").removeClass("drawer--open")
                        })
                    },
                    error: function(t, e) {
                        "function" == typeof errorCallback ? errorCallback(t, e) : ShopifyAPI.onError(t, e)
                    }
                };
                jQuery.ajax(a)
            }),
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        convertToSlug: function(t) {
            return t.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        buildMetafields: function(t) {
            var e = $(".js-btn-quickview[data-handle=" + t.handle + "]").closest(".product-card")
              , a = "";
            if (e.data("external")) {
                var i = e.data("external");
                $(".product-quickview__buttons").remove(),
                a += '<a href="' + i + '">' + wpbingo.strings.external + "</a>",
                $(".product-quickview__buttons_external").html(a)
            }
            if (e.data("short_description")) {
                var i = e.data("short_description");
                $(".product-quickview .product-quickview__description").html(i)
            }
            if (e.data("countdowns")) {
                var o = e.data("countdowns");
                $(".quickview .countdown-quickview").removeClass("hidden"),
                a += '<div class="countdown" data-countdown="' + o + '"></div>',
                $(".countdown-quickview .content").html(a);
                var n = $(".product-quickview .countdown-quickview .countdown")
                  , r = n.data("countdown")
                  , s = new Date(r).getTime()
                  , c = Date.now()
                  , l = "d"
                  , d = "h"
                  , u = "m"
                  , p = "s";
                s > c ? n.countdown(r, function(t) {
                    var e = '<div class="countdown__item"><span>%D</span><span>' + l + '</span></div><div class="countdown__item"><span>%H</span><span>' + d + '</span></div><div class="countdown__item"><span>%M</span><span>' + u + '</span></div><div class="countdown__item"><span>%S</span><span>' + p + "</span></div>";
                    n.html(t.strftime(e))
                }).on("finish.countdown", function() {
                    n.html(wpbingo.strings.countdownFinish)
                }) : $(".product-quickview .countdown-quickview").remove()
            }
            if (e.data("is_group_product")) {
                if (e.data("group_product")) {
                    var i = e.data("group_product");
                    let h = i.split(",");
                    $(".product-quickview .product-quickview__variants").remove(),
                    $(".product-quickview .price-container").remove(),
                    $("#form-simple-addtocart").remove(),
                    a += '<form method="post" id="group_table_product" action="/cart/add"  enctype="multipart/form-data" novalidate="novalidate"><input type="hidden" name="form_type" value="product"><div class="group_table"></div><div class="product-group__add-to-cart product-single__buttons"><button type="submit" class="add-group-to-cart"><span>' + wpbingo.strings.add_to_cart + "</span></button></div></form>",
                    $(".group-quickview").html(a);
                    var m = "";
                    for (let f of h)
                        $.getJSON("/products/" + f + ".js", function(t) {
                            if (console.log(t),
                            m += '<div data-product_id="' + t.id + '" class="item-product-group">',
                            m += '<div class="product-content">',
                            m += '<div class="product-thumb">',
                            m += '<a href="/product/' + t.handle + '"><img class="featured-banner__img" src="' + t.featured_image + '" alt="' + t.featured_image.alt + '" /></a>',
                            m += "</div>",
                            m += '<div class="product-info">',
                            m += '<h3 class="product-title"><a href="/product/' + t.handle + '">' + t.title + "</a></h3>",
                            t.variants.length > 1) {
                                m += '<select name="items[][id]" class="js-product-btp--' + t.id + ' product-single__variants">';
                                for (var e = 0; e < t.variants.length; e++)
                                    m += '<option data-price="' + t.variants[e].price + '" value="' + t.variants[e].id + '"> ' + t.variants[e].title + " - " + wpbingo.Currency.formatMoney(t.variants[e].price) + " </option>";
                                m += "</select>"
                            } else
                                m += '<div class="product-price">' + wpbingo.Currency.formatMoney(t.variants[0].price) + '</div><input name="items[][id]" type="hidden" value="' + t.variants[0].id + '">';
                            m += "</div>",
                            m += "</div>",
                            m += '<div class="quantity-content">',
                            m += '<button type="button" class="js-qty-adjust wpbingo-qty__adjust wpbingo-qty__adjust--minus"><i class="feather-minus"></i></button>',
                            m += '<input type="text" name="items[][quantity]" class="js-qty-number wpbingo-qty__number" value="1" min="0" aria-label="quantity" pattern="[0-9]*">',
                            m += '<button type="button" class="js-qty-adjust wpbingo-qty__adjust wpbingo-qty__adjust--plus"><i class="feather-plus"></i></button>',
                            m += "</div>",
                            m += "</div>",
                            $(".group-quickview .group_table").html(m)
                        });
                    $("#group_table_product .add-group-to-cart").on("click", function(t) {
                        t.preventDefault(),
                        $(this).removeClass("added"),
                        $(this).addClass("active");
                        let e = document.querySelector("#group_table_product");
                        var a = {
                            type: "POST",
                            url: "/cart/add.js",
                            data: new FormData(e),
                            processData: !1,
                            contentType: !1,
                            dataType: "json",
                            success: function(t) {
                                $("#group_table_product .add-group-to-cart").removeClass("active"),
                                $("#group_table_product .add-group-to-cart").addClass("added"),
                                setTimeout(function() {
                                    $("#group_table_product .add-group-to-cart").removeClass("added")
                                }, 3e3),
                                ajaxCart.load()
                            },
                            error: function(t, e) {
                                "function" == typeof errorCallback ? errorCallback(t, e) : ShopifyAPI.onError(t, e)
                            }
                        };
                        jQuery.ajax(a)
                    })
                } else
                    $(".product-quickview .product-quickview__variants").remove(),
                    $(".product-quickview .price-container").remove(),
                    $("#form-simple-addtocart").remove(),
                    a += '<div class="view-gruop-product"><a class="view-gruop-product-btn" href="' + t.url + '"><span>' + wpbingo.strings.view_group + "</span></a></div>",
                    $(".group-quickview").html(a)
            }
        },
        buildVariant: function(t) {
            var e = ""
              , a = this.currentVariant;
            if ("Title" !== t.options[0].name)
                for (var i = t.options, o = 0; o < i.length; o++) {
                    var n = i[o]
                      , r = o + 1
                      , s = "label";
                    if (wpbingo.settings.size_option,
                    wpbingo.settings.filter_name_1 === n.name ? s = wpbingo.settings.select_filter_1 : wpbingo.settings.filter_name_2 === n.name ? s = wpbingo.settings.select_filter_2 : wpbingo.settings.filter_name_3 === n.name && (s = wpbingo.settings.select_filter_3),
                    e += '<div class="variants-wrapper product-form__item ' + s + '" data-quickview-variant-option="' + r + '">',
                    e += '<label class="variants__label">' + n.name + ": <span></span></label>",
                    e += '<div class="variants__options">',
                    "select" === wpbingo.settings.quickViewVariantType) {
                        e += '<select class="js-quickview-option-selector product-form__input" data-id="quickViewOptionSelector-' + r + '" data-index="option' + r + '">';
                        for (var c = 0; c < n.values.length; c++) {
                            var l = n.values[c];
                            e += '<option value="' + _.escape(l) + '" ',
                            e += a.options[o] === l ? 'selected="selected"' : "",
                            e += ">" + l + "</option>"
                        }
                        e += "</select>"
                    } else if ("radio" === wpbingo.settings.quickViewVariantType)
                        for (var c = 0; c < n.values.length; c++) {
                            for (var l = n.values[c], d = !0, u = !1, p = "", h = 0; h < this.productVariants.length; h++) {
                                var m = this.productVariants[h];
                                if (m.available) {
                                    if (0 == o && m.option1 === l) {
                                        d = !1;
                                        break
                                    }
                                    if (1 == o && m.option2 === l && m.option1 == a.option1) {
                                        d = !1;
                                        break
                                    }
                                    if (2 == o && m.option3 === l && m.option2 == a.option2 && m.option1 == a.option1) {
                                        d = !1;
                                        break
                                    }
                                }
                            }
                            for (var f = 0; f < t.media.length; f++) {
                                var v = t.media[f]
                                  , g = v.alt;
                                if (g)
                                    var b = g.split("-");
                                if (b && b[1] == l) {
                                    u = !0;
                                    break
                                }
                            }
                            if (u)
                                for (var f = 0; f < t.media.length; f++) {
                                    var v = t.media[f]
                                      , g = v.alt;
                                    if (g)
                                        var b = g.split("-");
                                    if (b[1] == l) {
                                        var C = v.src;
                                        e += '<div class="single-option-selector">',
                                        e += '<input type="radio" data-single-option-button',
                                        e += a.options[o] === l ? " checked " : " ",
                                        d && (e += 'disabled="disabled"'),
                                        e += 'value="' + _.escape(l) + '" data-index="option' + r + '" name="option' + n.position + '" ',
                                        e += 'class="js-quickview-option-selector',
                                        d && (e += " disabled"),
                                        e += '" id="quickview-product-option-' + o + "-" + l.toLowerCase() + '">',
                                        e += '<label class="' + l + '" data-toggle="tooltip" title="' + l + '" for="quickview-product-option-' + o + "-" + l.toLowerCase() + '" ' + p,
                                        d && (e += ' class="disabled"'),
                                        e += 'style="background:url(' + C + ');background-size: cover;background-position: center;">' + l + '<span class="d-none"></span></label>',
                                        e += "</div>";
                                        break
                                    }
                                }
                            else
                                e += '<div class="single-option-selector">',
                                e += '<input type="radio" data-single-option-button',
                                e += a.options[o] === l ? " checked " : " ",
                                d && (e += 'disabled="disabled"'),
                                e += 'value="' + _.escape(l) + '" data-index="option' + r + '" name="option' + n.position + '" ',
                                e += 'class="js-quickview-option-selector',
                                d && (e += " disabled"),
                                e += '" id="quickview-product-option-' + o + "-" + l.toLowerCase() + '">',
                                e += '<label class="' + l + '" data-toggle="tooltip" title="' + l + '" for="quickview-product-option-' + o + "-" + l.toLowerCase() + '" ' + p,
                                d && (e += ' class="disabled"'),
                                e += ">" + l + '<span class="d-none"></span></label>',
                                e += "</div>"
                        }
                    e += "</div>",
                    e += "</div>"
                }
            return e
        },
        createImageCarousel: function() {
            $(t.quickView).find(t.quickViewImages).slick({
                infinite: !1,
                rows: 0,
                fade: !0,
                rtl: wpbingo.rtl_slick()
            })
        },
        renderReview: function() {
            if (window.SPR && wpbingo.settings.enableReview && $(t.quickView).find(t.quickViewReview).length)
                return window.SPR.registerCallbacks(),
                window.SPR.initRatingHandler(),
                window.SPR.initDomEls(),
                window.SPR.loadProducts(),
                window.SPR.loadBadges()
        },
        getCurrentOptions: function() {
            var e = _.map($(t.quickviewVariant, t.quickViewContainer), function(t) {
                var e = $(t)
                  , a = e.attr("type")
                  , i = {};
                return "radio" !== a && "checkbox" !== a ? (i.value = e.val(),
                i.index = e.data("index"),
                i) : !!e[0].checked && (i.value = e.val(),
                i.index = e.data("index"),
                i)
            });
            return _.compact(e)
        },
        getVariantFromOptions: function() {
            var t = this.getCurrentOptions()
              , e = this.productVariants;
            return _.find(e, function(e) {
                return t.every(function(t) {
                    return _.isEqual(e[t.index], t.value)
                })
            })
        },
        updateVariantsButton: function() {
            for (var e = this.getCurrentOptions(), a = this.productVariants, i = 2; i <= 3; i++)
                $('[data-quickview-variant-option="' + i + '"]', t.quickViewContainer).length && $('[data-quickview-variant-option="' + i + '"] ' + t.quickviewVariant, t.quickViewContainer).each(function() {
                    var t, o = $(this), n = o.val();
                    2 === i ? t = _.findIndex(a, function(t) {
                        return t.option1 === e[0].value && t.option2 === n && !0 === t.available
                    }) : 3 === i && (t = _.findIndex(a, function(t) {
                        return t.option1 === e[0].value && t.option2 === e[1].value && t.option3 === n && !0 === t.available
                    })),
                    -1 !== t ? (o.removeAttr("disabled", "disabled").removeClass("disabled"),
                    o.next("label").removeClass("disabled")) : (o.attr("disabled", "disabled").addClass("disabled"),
                    o.next("label").addClass("disabled"))
                })
        },
        updateVariantsButtonDisabed: function() {
            for (var e = 2; e <= 3; e++)
                if ($('[data-quickview-variant-option="' + e + '"]', t.quickViewContainer).length) {
                    var a = !1;
                    $('[data-quickview-variant-option="' + e + '"] ' + t.quickviewVariant, t.quickViewContainer).each(function() {
                        var t = $(this)
                          , e = t.attr("type");
                        if (("radio" === e || "checkbox" === e) && this.checked && t.hasClass("disabled"))
                            return t.prop("checked", !1),
                            a = !0,
                            !1
                    }),
                    $('[data-quickview-variant-option="' + e + '"] ' + t.quickviewVariant, t.quickViewContainer).each(function() {
                        var t = $(this)
                          , e = t.attr("type");
                        if (a && ("radio" === e || "checkbox" === e) && !t.hasClass("disabled"))
                            return t.prop("checked", !0),
                            a = !1,
                            t.trigger("change"),
                            !1
                    })
                }
        },
        updateMasterSelect: function(e) {
            e && $(t.originalSelectorId, t.quickViewContainer).val(e.id)
        },
        updateMedia: function(e) {
            $(t.quickViewImages, t.quickView).on("init", function(a, i) {
                e && e.featured_media && e.featured_media.id && $(t.quickViewImages, t.quickViewContainer).find(".quickview-images__item").each(function() {
                    var a = $(this).data("media-id");
                    if (e.featured_media.id == a) {
                        var i = $(this).closest(".slick-carousel__item").data("slick-index");
                        setTimeout(function() {
                            null != i && $(t.quickViewImages, t.quickViewContainer).slick("slickGoTo", i)
                        }, 100)
                    }
                })
            }),
            e && e.featured_media && e.featured_media.id && $(t.quickViewImages, t.quickViewContainer).find(".quickview-images__item").each(function() {
                var a = $(this).data("media-id");
                if (e.featured_media.id == a) {
                    var i = $(this).closest(".slick-carousel__item").data("slick-index");
                    null != i && $(t.quickViewImages, t.quickViewContainer).slick("slickGoTo", i)
                }
            })
        },
        updatePrice: function(e) {
            var a = wpbingo.strings.moneyFormat;
            e ? ($(t.quickViewProductPrice, t.quickViewContainer).removeClass("d-none"),
            $(t.quickViewProductPriceCompare, t.quickViewContainer).removeClass("d-none"),
            $(t.quickViewProductPrice, t.quickViewContainer).html(wpbingo.Currency.formatMoney(e.price, a)),
            e.compare_at_price > e.price ? ($(t.quickViewProductPriceCompare, t.quickViewContainer).html(wpbingo.Currency.formatMoney(e.compare_at_price, a)).removeClass("d-none"),
            $(t.quickViewProductPrice, t.quickViewContainer).addClass("on-sale")) : ($(t.quickViewProductPriceCompare, t.quickViewContainer).addClass("d-none"),
            $(t.quickViewProductPrice, t.quickViewContainer).removeClass("on-sale"))) : ($(t.quickViewProductPrice, t.quickViewContainer).addClass("d-none"),
            $(t.quickViewProductPriceCompare, t.quickViewContainer).addClass("d-none")),
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        updateSKU: function(e) {
            var a = e && null !== e.sku && "" !== e.sku ? e.sku : "N/A";
            $(t.quickViewSKU, t.quickViewContainer).html(a)
        },
        updateProductAvaiable: function(e) {
            var a = "product-avaiable--active"
              , i = wpbingo.strings;
            $(t.quickViewAvaiable, t.quickViewContainer).removeClass(a),
            e ? (e.available ? ($(t.quickViewQty, t.quickViewContainer).removeClass("d-none"),
            $(t.quickViewAvaiableInStock, t.quickViewContainer).addClass(a)) : ($(t.quickViewQty, t.quickViewContainer).addClass("d-none"),
            $(t.quickViewAvaiableOutStock, t.quickViewContainer).addClass(a)),
            e.available ? ($(t.quickViewContainer).find(".btn--add-to-cart").removeClass("disabled").prop("disabled", !1),
            $(t.quickViewContainer).find(".btn--add-to-cart .btn__text").html(i.addToCart)) : ($(t.quickViewContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0),
            $(t.quickViewContainer).find(".btn--add-to-cart .btn__text").html(i.soldOut))) : ($(t.quickViewQty, t.quickViewContainer).addClass("d-none"),
            $(t.quickViewContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0),
            $(t.quickViewContainer).find(".btn--add-to-cart .btn__text").html(i.unavailable))
        },
        updateDetailsLink: function(e) {
            if (e) {
                var a = $(t.quickViewProductDetailsURL, t.quickViewContainer).data("url") + "?variant=" + e.id;
                $(t.quickViewProductDetailsURL, t.quickViewContainer).removeClass("d-none").attr("href", a)
            } else
                $(t.quickViewProductDetailsURL, t.quickViewContainer).addClass("d-none")
        },
        onVariantChange: function() {
            var e = this.getVariantFromOptions();
            if ($("[data-single-option-button]", t.quickViewContainer).length && (this.updateVariantsButton(),
            !e || !e.available)) {
                this.updateVariantsButtonDisabed();
                return
            }
            var a = $(".quickview .product-quickview__variants .variants-wrapper");
            $(a).each(function() {
                var t = $(this);
                if ($("select", t).length > 0)
                    var e = $("select", t).find(":selected").val();
                else
                    var e = $("input:checked", t).attr("value");
                $(".variants__label span", t).html(e)
            }),
            this.updateMasterSelect(e),
            this.updateMedia(e),
            this.updatePrice(e),
            this.updateSKU(e),
            this.updateProductAvaiable(e),
            this.updateDetailsLink(e),
            this.currentVariant = e
        }
    }),
    e
}(),
"undefined" == typeof ShopifyAPI && (ShopifyAPI = {}),
ShopifyAPI.attributeToString = function(t) {
    return "string" != typeof t && "undefined" == (t += "") && (t = ""),
    jQuery.trim(t)
}
,
ShopifyAPI.onCartUpdate = function() {}
,
ShopifyAPI.updateCartNote = function(t, e) {
    var a = {
        type: "POST",
        url: "/cart/update.js",
        data: "note=" + ShopifyAPI.attributeToString(t),
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(t) : ShopifyAPI.onCartUpdate(t)
        },
        error: function(t, e) {
            ShopifyAPI.onError(t, e)
        }
    };
    jQuery.ajax(a)
}
,
ShopifyAPI.onError = function(XMLHttpRequest) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    data.message && alert(data.message + "(" + data.status + "): " + data.description)
}
,
ShopifyAPI.addItemFromForm = function(t, e, a) {
    var i = {
        type: "POST",
        url: "/cart/add.js",
        data: new FormData(t),
        processData: !1,
        contentType: !1,
        dataType: "json",
        success: function(a) {
            "function" == typeof e ? e(a, t) : ShopifyAPI.onItemAdded(a, t)
        },
        error: function(t, e) {
            "function" == typeof a ? a(t, e) : ShopifyAPI.onError(t, e)
        }
    };
    jQuery.ajax(i)
}
,
ShopifyAPI.getCart = function(t, e) {
    jQuery.getJSON("/cart.js", function(a) {
        "function" == typeof t ? t(a, e) : ShopifyAPI.onCartUpdate(a)
    })
}
,
ShopifyAPI.changeItem = function(t, e, a, i) {
    var o = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + e + "&line=" + t,
        dataType: "json",
        success: function(t) {
            if ("function" == typeof a ? a(t) : ShopifyAPI.onCartUpdate(t),
            i) {
                var e = "${{amount}}";
                void 0 !== wpbingo.strings.moneyFormat && (e = wpbingo.strings.moneyFormat);
                var o = $("#form-modal-addtocart input[data-modal-variant]").val();
                for (var n in t.items)
                    if (o == t.items[n].variant_id)
                        var r = t.items[n].final_line_price
                          , s = t.items[n].original_line_price;
                if ($("#form-modal-addtocart .modalcart__line_price .price").html(wpbingo.Currency.formatMoney(r, e)),
                t.items[n].discounts.length > 0)
                    for (var c in $("#form-modal-addtocart .modalcart__line_price .price_discount").html(wpbingo.Currency.formatMoney(s, e)),
                    t.items[n].discounts)
                        $(".js-cart-modal .discount").text(t.items[n].discounts[c].title);
                else
                    $("#form-modal-addtocart .modalcart__line_price .price_discount").empty(),
                    $(".js-cart-modal .discount").empty();
                $("#form-modal-addtocart .cart-modal__middle").removeClass("load_modal")
            }
        },
        error: function(t, e) {
            ShopifyAPI.onError(t, e)
        }
    };
    jQuery.ajax(o)
}
;
var ajaxCart = function(module, $) {
    "use strict";
    var init, loadCart, settings, isUpdating, $body, $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, initializeEvents, updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartModalAdded, cartModalupdate, updateModalRecommendations, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;
    return init = function(t) {
        settings = {
            formSelector: "[data-product-form]",
            cartContainer: "[data-cart-container]",
            addToCartSelector: 'button[type="submit"]',
            cartCountSelector: "[data-cart-count]",
            cartCostSelector: "[data-cart-cost]",
            cartRemoveSelector: "[data-cart-remove]",
            headerCartSelector: ".js-header-cart",
            cartModalSelector: ".js-cart-modal",
            cartModalCloseSelector: ".js-cart-modal-close",
            moneyFormat: "${{amount}}",
            disableAjaxCart: !1,
            cartTemplate: "#ajaxcart-template",
            cartModalHeaderTemplate: "#ajaxcart-header-template"
        },
        void 0 !== wpbingo.strings.moneyFormat && (settings.moneyFormat = wpbingo.strings.moneyFormat),
        $.extend(settings, t),
        $formContainer = $(settings.formSelector),
        $cartContainer = $(settings.cartContainer),
        $addToCart = $formContainer.find(settings.addToCartSelector),
        $cartCountSelector = $(settings.cartCountSelector),
        $cartCostSelector = $(settings.cartCostSelector),
        $body = $("body"),
        isUpdating = !1,
        initializeEvents(),
        !settings.disableAjaxCart && $addToCart.length && formOverride(),
        adjustCart()
    }
    ,
    initializeEvents = function() {
        $body.on("click", settings.cartModalCloseSelector, function() {
            $(".js-cart-modal .cart-modal__inner").removeClass("show"),
            setTimeout(function() {
                $(settings.cartModalSelector).fadeOut(400, function() {
                    $(this).remove()
                })
            }, 400)
        }),
        $body.on("click", settings.headerCartSelector, function(t) {
            if ("modal" == wpbingo.settings.cartType && $(window).width() > 767 && !$("body").hasClass("template-cart")) {
                t.preventDefault();
                return
            }
        }),
        $body.on("click", settings.cartRemoveSelector, function(t) {
            if (!isUpdating) {
                var e, a = $(this).data("line");
                a && ($('.ajaxcart__product[data-line="' + a + '"]').addClass("is-loading"),
                isUpdating = !0,
                setTimeout(function() {
                    ShopifyAPI.changeItem(a, 0, adjustCartCallback)
                }, 250)),
                wpbingo.discount_single()
            }
        }),
        $body.on("change", ".ajaxcart__note-input", function() {
            var t = $(this).val();
            $(".ajaxcart__info .save-ajaxcart__note").on("click", function() {
                ShopifyAPI.updateCartNote(t, function() {})
            })
        }),
        $body.on("change", ".discount_code_input", function() {
            var t = $(this).val();
            $(".ajaxcart__info .save-discount_code_input").on("click", function() {
                wpbingo.setCookie("wpbingo_discount", t, 1)
            })
        })
    }
    ,
    loadCart = function() {
        $body.addClass("ajaxcart--is-loading"),
        ShopifyAPI.getCart(cartUpdateCallback)
    }
    ,
    updateCountPrice = function(t) {
        $cartCountSelector && $cartCountSelector.html(t.item_count),
        $cartCostSelector && $cartCostSelector.html(wpbingo.Currency.formatMoney(t.total_price, settings.moneyFormat)),
        $(".cart-modal-totalprice span").html(wpbingo.Currency.formatMoney(t.total_price, settings.moneyFormat)),
        $(".cart-modal-totalcount span.count").html(t.item_count)
    }
    ,
    formOverride = function() {
        $body.on("submit", settings.formSelector, function(t) {
            t.preventDefault(),
            $(".btn--add-to-cart", $(this)).attr("disabled", "disabled").prepend('<span class="spinner-border spinner-border-sm"></span>'),
            $(".btn--add-to-cart", $(this)).removeClass("is-added").addClass("is-adding"),
            $(".ajaxcart-toast").toast("hide"),
            ShopifyAPI.addItemFromForm(t.target, itemAddedCallback, itemErrorCallback)
        })
    }
    ,
    itemAddedCallback = function(t) {
        $("form .btn--add-to-cart").removeAttr("disabled").find(".spinner-border").remove(),
        $("form .btn--add-to-cart").removeClass("is-adding").addClass("is-added"),
        "modal" == wpbingo.settings.cartType && cartModalAdded(t),
        ShopifyAPI.getCart(cartUpdateCallback, !0),
        wpbingo.discount_single()
    }
    ,
    itemErrorCallback = function(XMLHttpRequest) {
        var data = eval("(" + XMLHttpRequest.responseText + ")");
        if ($addToCart.removeAttr("disabled").find(".spinner-border").remove(),
        $addToCart.removeClass("is-adding is-added"),
        data.message && 422 === data.status) {
            var $toast = $(".ajaxcart-toast");
            $toast.find(".toast-body").html(data.description),
            $toast.toast("show")
        }
    }
    ,
    cartModalAdded = function(t) {
        var e = {}
          , a = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"
          , i = $(settings.cartModalHeaderTemplate).html()
          , o = Handlebars.compile(i);
        if (null != t.image && (a = t.image),
        updateModalRecommendations(t),
        e = {
            name: t.product_title,
            image: a,
            discount: t.discounts,
            variant_id: t.variant_id,
            variant: t.variant_title,
            options: t.options_with_values,
            price_discount: wpbingo.Currency.formatMoney(t.original_line_price, settings.moneyFormat),
            final_line_price: wpbingo.Currency.formatMoney(t.final_line_price, settings.moneyFormat),
            final_price: wpbingo.Currency.formatMoney(t.final_price, settings.moneyFormat),
            quantity: t.quantity
        },
        $body.append(o(e)),
        null != e.variant)
            for (var n in e.options)
                $(".js-cart-modal .variant").append("<span>" + e.options[n].name + " : " + e.options[n].value + "</span>");
        if (e.discount.length > 0) {
            for (var n in e.discount)
                $(".js-cart-modal .discount").text(e.discount[n].title);
            $("#form-modal-addtocart .modalcart__line_price .price_discount").html(wpbingo.Currency.formatMoney(t.original_line_price, settings.moneyFormat))
        } else
            $(".js-cart-modal .discount").empty(),
            $("#form-modal-addtocart .modalcart__line_price .price_discount").empty();
        $(".js-cart-modal").fadeIn(400),
        setTimeout(function() {
            $(".js-cart-modal .cart-modal__inner").addClass("show")
        }, 400)
    }
    ,
    cartModalupdate = function(t) {
        $("#form-modal-addtocart .modalcart__quantity input").change(function() {
            $("#form-modal-addtocart .cart-modal__middle").addClass("load_modal");
            var e = $("#form-modal-addtocart input[data-modal-variant]").val()
              , a = $("#form-modal-addtocart .modalcart__quantity input").val()
              , i = !0;
            for (var o in t.items)
                if (e == t.items[o].variant_id)
                    var n = parseInt(o) + 1;
            ShopifyAPI.changeItem(n, a, adjustCartCallback, i)
        }),
        $("#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust").on("click", function() {
            $("#form-modal-addtocart .cart-modal__middle").addClass("load_modal");
            var e = $("#form-modal-addtocart input[data-modal-variant]").val()
              , a = !0;
            for (var i in t.items)
                if (e == t.items[i].variant_id) {
                    var o = parseInt(i) + 1;
                    t.items[i]
                }
            setTimeout(function() {
                var t = $("#form-modal-addtocart .modalcart__quantity input").val();
                ShopifyAPI.changeItem(o, t, adjustCartCallback, a)
            }, 500)
        })
    }
    ,
    updateModalRecommendations = function(t) {
        var e, a = routes.product_recommendations_url + "?section_id=product-recommendations&product_id=" + t.product_id + "&limit=6";
        $.get(a).then(function(t) {
            var e = $(t).html();
            $(".cart-modal-recommendations").html(e);
            var a = $(".js-product-recommendations", $(".cart-modal-recommendations"));
            wpbingo.elementslickCarousel(a),
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        })
    }
    ,
    cartUpdateCallback = function(t, e) {
        updateCountPrice(t),
        buildCart(t, fire_work),
        cartModalupdate(t),
        e && $body.trigger("drawer.open")
    }
    ,
    buildCart = function(t) {
        if ($cartContainer.empty(),
        0 === t.item_count) {
            $cartContainer.append('<p class="cart-empty-message">' + wpbingo.strings.cartEmpty + '</p>\n<p class="cookie-message">' + wpbingo.strings.cartCookies + "</p>"),
            cartCallback(t),
            $(".js-drawer .drawer__title .count").text("0"),
            $(".shipping-bar-cart").addClass("hidden");
            return
        }
        var e = []
          , a = {}
          , i = {}
          , o = $(settings.cartTemplate).html()
          , n = Handlebars.compile(o);
        $.each(t.items, function(i, o) {
            var n, r = null;
            if (n = null !== o.image ? o.image.replace(/(\.[^.]*)$/, "_small$1").replace("http:", "") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif",
            null !== o.properties && $.each(o.properties, function(t, e) {
                "_" !== t.charAt(0) && e || delete o.properties[t]
            }),
            null !== o.properties && $.each(o.properties, function(t, e) {
                "_" !== t.charAt(0) && e || delete o.properties[t]
            }),
            0 !== o.line_level_discount_allocations.length)
                for (var s in o.line_level_discount_allocations) {
                    var c = o.line_level_discount_allocations[s].amount;
                    o.line_level_discount_allocations[s].formattedAmount = wpbingo.Currency.formatMoney(c, settings.moneyFormat)
                }
            if (0 !== t.cart_level_discount_applications.length)
                for (var l in t.cart_level_discount_applications) {
                    var d = t.cart_level_discount_applications[l].total_allocated_amount;
                    t.cart_level_discount_applications[l].formattedAmount = wpbingo.Currency.formatMoney(d, settings.moneyFormat)
                }
            o.unit_price_measurement && (r = {
                addRefererenceValue: 1 !== o.unit_price_measurement.reference_value,
                price: wpbingo.Currency.formatMoney(o.unit_price, settings.moneyFormat),
                reference_value: o.unit_price_measurement.reference_value,
                reference_unit: o.unit_price_measurement.reference_unit
            }),
            a = {
                key: o.key,
                line: i + 1,
                url: o.url,
                img: n,
                name: o.product_title,
                variation: null !== o.variant_title,
                variant: o.variant,
                options: o.options_with_values,
                variant_id: o.variant_id,
                properties: o.properties,
                itemAdd: o.quantity + 1,
                itemMinus: o.quantity - 1,
                itemQty: o.quantity,
                handle: o.handle,
                price: wpbingo.Currency.formatMoney(o.original_line_price, settings.moneyFormat),
                discountedPrice: wpbingo.Currency.formatMoney(o.final_line_price, settings.moneyFormat),
                discounts: o.line_level_discount_allocations,
                discountsApplied: 0 !== o.line_level_discount_allocations.length,
                vendor: o.vendor,
                unitPrice: r
            },
            e.push(a),
            wpbingo.discount_single()
        }),
        i = {
            items: e,
            note: t.note,
            totalPrice: wpbingo.Currency.formatMoney(t.total_price, settings.moneyFormat),
            cartDiscounts: t.cart_level_discount_applications,
            cartDiscountsApplied: 0 !== t.cart_level_discount_applications.length
        },
        $cartContainer.append(n(i)),
        cartCallback(t),
        i.note && $(".cart-table .cart-note__input textarea").val(i.note);
        var r = wpbingo.getCookie("wpbingo_discount");
        if (r && ($(".cart-table .discount_code_input").val(r),
        $(".js-drawer .discount_code_input").val(r)),
        $(".js-drawer .drawer__title .count").text(t.item_count),
        $(".shipping-bar-cart").removeClass("hidden"),
        $(".shipping-bar-cart").length) {
            var s = $(".shipping-bar-cart").data("price_shipping_bar");
            if (s > t.total_price && 0 != s) {
                var c = s - t.total_price
                  , l = wpbingo.Currency.formatMoney(c, settings.moneyFormat)
                  , d = t.total_price / s * 100;
                $(".shipping-bar-cart .title-spend .spend").html(l),
                $(".shipping-bar-cart .shipping-progress").css("width", d + "%"),
                $(".shipping-bar-cart .title-shipping").addClass("hide"),
                $(".shipping-bar-cart .title-spend").removeClass("hide"),
                $(".shipping-bar-cart .shipping-progress").removeClass("full"),
                $("[data-cart-container]").removeClass("fire-done"),
                $("#fire_work").addClass("hide")
            } else
                $(".shipping-bar-cart .title-shipping").removeClass("hide"),
                $(".shipping-bar-cart .title-spend").addClass("hide"),
                $(".shipping-bar-cart .shipping-progress").css("width", "100%"),
                $(".shipping-bar-cart .shipping-progress").addClass("full"),
                $("[data-cart-container]").hasClass("fire-done") || $("[data-cart-container]").addClass("fire"),
                $("[data-cart-container]").hasClass("fire") && ($("#fire_work").removeClass("hide"),
                confettiLoop()),
                setTimeout(function() {
                    $("[data-cart-container]").addClass("fire-done"),
                    $("[data-cart-container]").removeClass("fire")
                }, 1e3),
                setTimeout(function() {
                    $("#fire_work").addClass("hide")
                }, 5e3)
        }
        $(".pre_order-cart >span").each(function() {
            var t = $(this).data("handle");
            for (var e in i.items)
                i.items[e].variant_id == t && $('.ajaxcart__product[data-line="' + i.items[e].line + '"] .pre_order').removeClass("hide")
        }),
        wpbingo.checkbox_terms_conditions(),
        $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
    }
    ,
    cartCallback = function(t) {
        $body.removeClass("ajaxcart--is-loading"),
        window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize(),
        $body.trigger("drawer.footer")
    }
    ,
    adjustCart = function() {
        function t(t, e) {
            isUpdating = !0;
            var a = $('.ajaxcart__product[data-line="' + t + '"]').addClass("is-loading");
            0 === e && a.parent().addClass("is-removed"),
            setTimeout(function() {
                ShopifyAPI.changeItem(t, e, adjustCartCallback)
            }, 250)
        }
        $body.on("click", ".ajaxcart__qty-adjust", function() {
            if (!isUpdating) {
                var e = $(this)
                  , a = e.data("line")
                  , i = e.siblings(".ajaxcart__qty-num")
                  , o = parseInt(i.val().replace(/\D/g, ""));
                o = validateQty(o),
                e.hasClass("ajaxcart__qty--plus") ? o += 1 : (o -= 1) <= 0 && (o = 0),
                a ? t(a, o) : i.val(o)
            }
        }),
        $body.on("change", ".ajaxcart__qty-num", function() {
            if (!isUpdating) {
                var e = $(this)
                  , a = e.data("line")
                  , i = parseInt(e.val().replace(/\D/g, ""));
                i = validateQty(i),
                a && t(a, i)
            }
        }),
        $body.on("submit", "form.ajaxcart", function(t) {
            isUpdating && t.preventDefault()
        }),
        $body.on("focus", ".ajaxcart__qty-adjust", function() {
            var t = $(this);
            setTimeout(function() {
                t.select()
            }, 50)
        })
    }
    ,
    adjustCartCallback = function(t) {
        updateCountPrice(t),
        setTimeout(function() {
            ShopifyAPI.getCart(buildCart),
            isUpdating = !1
        }, 150)
    }
    ,
    validateQty = function(t) {
        return (parseFloat(t) !== parseInt(t) || isNaN(t)) && (t = 1),
        t
    }
    ,
    module = {
        init: init,
        load: loadCart
    }
}(ajaxCart || {}, jQuery);
wpbingo.drawerCart = function(t) {
    var e, a, i, o, n, r, s, c, l, d = {
        open: "drawer--open"
    };
    return r = function() {
        e = $("body"),
        a = $(".js-drawer"),
        i = ".js-drawer-close",
        o = ".js-header-cart",
        n = !1,
        e.on("drawer.open", function(t) {
            s(t)
        }),
        e.on("drawer.close", function(t) {
            c(t)
        }),
        e.on("drawer.footer", function() {
            l()
        }),
        e.on("click", o, function(t) {
            $("body").hasClass("template-cart") || (t.preventDefault(),
            e.trigger("drawer.open", t))
        }),
        e.on("click", i, function(t) {
            t.preventDefault(),
            e.trigger("drawer.close", t)
        })
    }
    ,
    s = function(t) {
        if (n) {
            t && t.preventDefault();
            return
        }
        t && t.preventDefault(),
        e.addClass(d.open),
        n = !0
    }
    ,
    c = function(t) {
        n && (27 !== t.keyCode && t.preventDefault(),
        e.removeClass(d.open),
        n = !1)
    }
    ,
    l = function() {
        if (a.hasClass("drawer--has-fixed-footer")) {
            var t = $(".ajaxcart__footer").removeAttr("style")
              , e = $(".ajaxcart__inner").removeAttr("style")
              , i = t.outerHeight();
            e.css("bottom", i),
            t.css("height", i),
            $(".ajaxcart__info .button_note").on("click", function() {
                $(".ajaxcart__info .ajaxcart__note").hasClass("active") ? $(".ajaxcart__info .ajaxcart__note").removeClass("active") : $(".ajaxcart__info .ajaxcart__note").addClass("active")
            }),
            $(".ajaxcart__info .button_discount").on("click", function() {
                $(".ajaxcart__info .discount_code").hasClass("active") ? $(".ajaxcart__info .discount_code").removeClass("active") : $(".ajaxcart__info .discount_code").addClass("active")
            }),
            $(".ajaxcart__info .button_shiping").on("click", function() {
                $(".drawer__inner #shipping-calculator").hasClass("active") ? $(".drawer__inner #shipping-calculator").removeClass("active") : $(".drawer__inner #shipping-calculator").addClass("active")
            }),
            $(".ajaxcart__info .close-ajaxcart__info").on("click", function() {
                $(".ajaxcart__info .ajaxcart__info_content >div").hasClass("active") && $(".ajaxcart__info .ajaxcart__info_content >div").removeClass("active")
            }),
            $(".ajaxcart__info .save").on("click", function() {
                $(".ajaxcart__info .ajaxcart__info_content >div").hasClass("active") && $(".ajaxcart__info .ajaxcart__info_content >div").removeClass("active")
            }),
            $(".drawer__inner #shipping-calculator .close-ajaxcart__info").on("click", function() {
                $(".drawer__inner #shipping-calculator").hasClass("active") && $(".drawer__inner #shipping-calculator").removeClass("active")
            }),
            Shopify.Cart.ShippingCalculator.show({
                submitButton: window.strings.shippingCalcSubmitButton,
                submitButtonDisabled: window.strings.shippingCalcSubmitButtonDisabled,
                customerIsLoggedIn: window.strings.shippingCalcCustomerIsLoggedIn,
                moneyFormat: window.strings.shippingCalcMoneyFormat,
                CalculateMessSuccess: window.strings.CalculateMessSuccess,
                CalculateMessPrice: window.strings.CalculateMessPrice,
                CalculateMessError: window.strings.CalculateMessError
            })
        }
    }
    ,
    t = {
        init: r
    }
}(),
wpbingo.variables = {
    productPageLoad: !1,
    productPageSticky: !0,
    mediaTablet: "screen and (max-width: 1024px)",
    mediaMobile: "screen and (max-width: 767px)",
    isTablet: !1,
    isMobile: !1
},
wpbingo.initializeEvents = function() {
    var t = $("body")
      , e = ".js-password-toggle"
      , a = ".js-scroll-to-top"
      , i = ".js-sidebar-toggle"
      , o = {
        passwordShow: "password-toggle--show"
    };
    if ($('[data-toggle="tooltip"]').tooltip(),
    t.on("click", e, function(t) {
        t.preventDefault();
        var e = $(this)
          , a = e.siblings(".form-control");
        e.hasClass(o.passwordShow) ? (e.removeClass(o.passwordShow),
        a.attr("type", "password")) : (e.addClass(o.passwordShow),
        a.attr("type", "text"))
    }),
    t.on("click", a, function(t) {
        t.preventDefault(),
        $("body, html").stop().animate({
            scrollTop: 0
        }, "500")
    }),
    t.on("click", i, function(e) {
        e.preventDefault(),
        t.toggleClass("collection-sidebar--open")
    }),
    $(window).scroll(function() {
        $(window).scrollTop() >= 200 ? $(a).fadeIn() : $(a).fadeOut()
    }),
    $(".js-scroll-to-top").length > 0) {
        var n = document.querySelector(".js-scroll-to-top path")
          , r = n.getTotalLength();
        n.style.transition = n.style.WebkitTransition = "none",
        n.style.strokeDasharray = r + " " + r,
        n.style.strokeDashoffset = r,
        n.getBoundingClientRect(),
        n.style.transition = n.style.WebkitTransition = "stroke-dashoffset 10ms linear";
        var s = function() {
            var t = $(window).scrollTop()
              , e = $(document).height() - $(window).height()
              , a = r - t * r / e;
            n.style.strokeDashoffset = a
        };
        s(),
        $(window).scroll(s)
    }
}
,
wpbingo.setBreakpoints = function() {
    enquire.register(wpbingo.variables.mediaTablet, {
        match: function() {
            wpbingo.variables.isTablet = !0
        },
        unmatch: function() {
            wpbingo.variables.isTablet = !1
        }
    }),
    enquire.register(wpbingo.variables.mediaMobile, {
        match: function() {
            wpbingo.variables.isMobile = !0
        },
        unmatch: function() {
            wpbingo.variables.isMobile = !1
        }
    })
}
,
wpbingo.updateSlickSwipe = function(t, e) {
    if (t.hasClass("slick-initialized")) {
        var a = {
            accessibility: e,
            draggable: e,
            swipe: e,
            touchMove: e
        };
        t.slick("slickSetOption", a, !1)
    }
}
,
wpbingo.showLoading = function() {
    $("body").append(void 0 != wpbingo.loading && "" != wpbingo.loading ? wpbingo.loading : "")
}
,
wpbingo.hideLoading = function() {
    $(".wpbingo-loading").remove()
}
,
wpbingo.cartInit = function() {
    var t = $("body");
    wpbingo.cookiesEnabled() || t.addClass("cart--no-cookies"),
    ("modal" == wpbingo.settings.cartType || "drawer" == wpbingo.settings.cartType) && (ajaxCart.init(),
    ajaxCart.load(),
    "drawer" == wpbingo.settings.cartType && wpbingo.drawerCart.init())
}
,
wpbingo.cookiesEnabled = function() {
    var t = navigator.cookieEnabled;
    return t || (document.cookie = "webcookie",
    t = -1 !== document.cookie.indexOf("webcookie")),
    t
}
,
wpbingo.setCookie = function(t, e, a) {
    var i = new Date;
    i.setTime(i.getTime() + 864e5 * a);
    var o = "expires=" + i.toGMTString();
    document.cookie = t + "=" + e + ";" + o + ";path=/"
}
,
wpbingo.getCookie = function(t) {
    for (var e = t + "=", a = decodeURIComponent(document.cookie).split(";"), i = 0; i < a.length; i++) {
        for (var o = a[i]; " " === o.charAt(0); )
            o = o.substring(1);
        if (0 === o.indexOf(e))
            return o.substring(e.length, o.length)
    }
    return ""
}
,
wpbingo.cookieConsent = function() {
    var t = wpbingo.getCookie("cookie_consent")
      , e = $(".cookie-consent")
      , a = ".cookie-consent-dismiss";
    cConsentAgree = ".cookie-consent-agree",
    "true" == t || "false" == t ? e.remove() : (setTimeout(function() {
        e.addClass("active")
    }, 1500),
    "" == t && wpbingo.setCookie("cookie_consent", "", 10)),
    $("body").on("click", a, function(t) {
        t.preventDefault(),
        e.remove(),
        wpbingo.setCookie("cookie_consent", !1, 10)
    }),
    $("body").on("click", cConsentAgree, function(t) {
        t.preventDefault(),
        e.remove(),
        wpbingo.setCookie("cookie_consent", !0, 10)
    })
}
,
wpbingo.slideshow = function() {
    var t = ".js-wpbingo-slideshow"
      , e = $(t).data("fade")
      , a = $(t).data("autoplay")
      , i = $(t).data("autoplayinterval")
      , o = $(t).data("navigation")
      , n = $(t).data("pagination")
      , r = {
        fade: !0,
        rows: 0,
        arrows: o,
        autoplay: a,
        rtl: wpbingo.rtl_slick(),
        autoplaySpeed: i
    };
    void 0 === e || null == e || (r.fade = e),
    void 0 === i || null == i || (r.autoplaySpeed = i),
    void 0 === n || null == n || !0 != n ? r.dots = !1 : r.dots = !0,
    $(t).slick(r)
}
,
wpbingo.rtl_slick = function() {
    return !!$("body").hasClass("rtl")
}
,
wpbingo.slickCarousel = function() {
    var t = ".js-carousel";
    $(t).each(function() {
        var t = $(this)
          , e = t.data("nav")
          , a = t.data("dots")
          , i = !t.data("draggable")
          , o = !!t.data("fade")
          , n = t.data("center")
          , r = t.data("infinite")
          , s = t.data("autoplay")
          , c = t.data("autoplayspeed")
          , l = t.data("slidestoscroll") ? t.data("columns") : 1
          , d = t.data("columns")
          , u = t.data("column1440")
          , p = t.data("column1")
          , h = t.data("column2")
          , m = t.data("column3")
          , f = t.data("column4")
          , v = !!t.data("asnavfor") && t.data("asnavfor")
          , g = t.data("rows")
          , b = {
            swipeToSlide: !0,
            rtl: wpbingo.rtl_slick(),
            draggable: i,
            fade: o,
            asNavFor: v,
            arrows: e,
            slidesToShow: d,
            slidesToScroll: l,
            responsive: [{
                breakpoint: 1441,
                settings: {
                    slidesToShow: u,
                    slidesToScroll: u
                }
            }, {
                breakpoint: 1200,
                settings: {
                    slidesToShow: p,
                    slidesToScroll: p
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: h,
                    slidesToScroll: h
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: m,
                    slidesToScroll: m,
                    vertical: !1,
                    verticalSwiping: !1
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: f,
                    slidesToScroll: f,
                    vertical: !1,
                    verticalSwiping: !1
                }
            }]
        };
        if (void 0 === n || null == n || !0 != n ? b.centerMode = !1 : b.centerMode = !0,
        void 0 === a || null == a || !0 != a ? b.dots = !1 : b.dots = !0,
        void 0 === r || null == r || !0 != r ? b.infinite = !1 : b.infinite = !0,
        s && (b.autoplay = s,
        b.autoplaySpeed = c),
        void 0 !== g && null != g && 1 != g ? (b.rows = g,
        b.slidesPerRow = columnone,
        b.slidesToShow = 1,
        b.responsive = [{
            breakpoint: 1025,
            settings: {
                slidesPerRow: columntwo,
                slidesToShow: 1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesPerRow: columnthree,
                slidesToShow: 1
            }
        }]) : b.rows = 0,
        t.slick(b),
        $(".slick-arrow", t).length > 0) {
            var C = $(".slick-prev", t).clone();
            $(".slick-prev", t).remove(),
            0 == t.parent().find(".slick-prev").length && C.prependTo(t.parent()),
            C.on("click", function() {
                t.slick("slickPrev")
            });
            var y = $(".slick-next", t).clone();
            $(".slick-next", t).remove(),
            0 == t.parent().find(".slick-next").length && y.appendTo(t.parent()),
            y.on("click", function() {
                t.slick("slickNext")
            })
        }
    }),
    $(".product-tabs__nav-link").on("shown.bs.tab", function() {
        var e = $(this).closest(".product-tabs");
        e.find(t).length > 0 && e.find(t).slick("setPosition")
    })
}
,
wpbingo.elementslickCarousel = function(t) {
    var e = t.data("nav")
      , a = (t.data("infinite"),
    t.data("columns") ? t.data("columns") : 1)
      , i = t.data("column1440")
      , o = t.data("column1")
      , n = t.data("column2")
      , r = t.data("column3")
      , s = t.data("column4")
      , c = t.data("rows")
      , l = {
        swipeToSlide: !0,
        arrows: e,
        slidesToShow: a,
        slidesToScroll: a,
        rtl: wpbingo.rtl_slick(),
        responsive: [{
            breakpoint: 1441,
            settings: {
                slidesToShow: i,
                slidesToScroll: i
            }
        }, {
            breakpoint: 1200,
            settings: {
                slidesToShow: o,
                slidesToScroll: o
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: n,
                slidesToScroll: n
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: r,
                slidesToScroll: r,
                vertical: !1,
                verticalSwiping: !1
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: s,
                slidesToScroll: s,
                vertical: !1,
                verticalSwiping: !1
            }
        }]
    };
    if (void 0 !== c && null != c && 1 != c ? (l.rows = c,
    l.slidesPerRow = columnone,
    l.slidesToShow = 1,
    l.responsive = [{
        breakpoint: 1025,
        settings: {
            slidesPerRow: columntwo,
            slidesToShow: 1
        }
    }, {
        breakpoint: 768,
        settings: {
            slidesPerRow: columnthree,
            slidesToShow: 1
        }
    }]) : l.rows = 0,
    t.slick(l),
    $(".slick-arrow", t).length > 0) {
        var d = $(".slick-prev", t).clone();
        $(".slick-prev", t).remove(),
        0 == t.parent().find(".slick-prev").length && d.prependTo(t.parent()),
        d.on("click", function() {
            t.slick("slickPrev")
        });
        var u = $(".slick-next", t).clone();
        $(".slick-next", t).remove(),
        0 == t.parent().find(".slick-next").length && u.appendTo(t.parent()),
        u.on("click", function() {
            t.slick("slickNext")
        })
    }
}
,
wpbingo.countdown = function(t) {
    $("[data-countdown]").each(function() {
        var t = $(this)
          , e = $(this).data("countdown")
          , a = new Date(e).getTime()
          , i = Date.now()
          , o = t.closest(".product-card")
          , n = $(this).data("day") ? $(this).data("day") : wpbingo.strings.countdownDays;
        text_hour = $(this).data("hour") ? $(this).data("hour") : wpbingo.strings.countdownHours,
        time_min = $(this).data("min") ? $(this).data("min") : wpbingo.strings.countdownMinutes,
        text_sec = $(this).data("sec") ? $(this).data("sec") : wpbingo.strings.countdownSeconds,
        a > i ? t.countdown(e, function(e) {
            var a = '<div class="countdown__item"><span>%D</span><span>' + n + '</span></div><div class="countdown__item"><span>%H</span><span>' + text_hour + '</span></div><div class="countdown__item"><span>%M</span><span>' + time_min + '</span></div><div class="countdown__item"><span>%S</span><span>' + text_sec + "</span></div>";
            t.html(e.strftime(a))
        }).on("finish.countdown", function() {
            t.html(wpbingo.strings.countdownFinish)
        }) : ($(".countdown-product", o).remove(),
        $(".product-quickview .countdown-quickview").remove())
    })
}
,
wpbingo.countdown_single = function() {
    var t = $(".countdown-single .countdown")
      , e = t.data("countdown_single")
      , a = new Date(e).getTime()
      , i = Date.now()
      , o = t.data("day") ? t.data("day") : wpbingo.strings.countdownDays
      , n = t.data("hour") ? t.data("hour") : wpbingo.strings.countdownHours
      , r = t.data("min") ? t.data("min") : wpbingo.strings.countdownMinutes
      , s = t.data("sec") ? t.data("sec") : wpbingo.strings.countdownSeconds;
    a > i ? t.countdown(e, function(e) {
        var a = '<div class="countdown__item"><span>%D</span><span>' + o + '</span></div><div class="countdown__item"><span>%H</span><span>' + n + '</span></div><div class="countdown__item"><span>%M</span><span>' + r + '</span></div><div class="countdown__item"><span>%S</span><span>' + s + "</span></div>";
        t.html(e.strftime(a))
    }).on("finish.countdown", function() {
        t.html(wpbingo.strings.countdownFinish)
    }) : $(".product-single .countdown-single").remove()
}
,
wpbingo.active_form_login = function() {
    $(".header-account [data-login-account]").on("click", function(t) {
        t.preventDefault();
        var e = $("[data-login_popup]");
        e.hasClass("active") ? e.removeClass("active") : e.addClass("active")
    }),
    $("[data-close_login_popup]").on("click", function(t) {
        t.preventDefault();
        var e = $("[data-login_popup]");
        e.hasClass("active") && e.removeClass("active")
    })
}
,
wpbingo.click_atribute_image = function() {
    var t = wpbingo.strings.moneyFormat;
    $(".wpb-variants-swatch").each(function() {
        var e = $(this);
        $(".swatch-content", e).each(function(a) {
            var i = $(this);
            $(".swatch-items", i).on("click", function() {
                if (!$(this).hasClass("active")) {
                    $(".swatch-items", i).removeClass("active"),
                    $(this).addClass("active");
                    var a = wpbingo.get_variant_value(e)
                      , o = e.data("handle");
                    $.getJSON("/products/" + o + ".js", function(n) {
                        n.variants && (wpbingo.updateVariantsButton(e, n),
                        $.each(n.variants, function(e, n) {
                            if (n.available && n.title == a) {
                                var r = i.closest(".product-card");
                                $(".product-group-price[data-handle=" + o + "] .variant-price", r).html(wpbingo.Currency.formatMoney(n.price, t)),
                                $(".product-card__form[data-handle=" + o + "] input[name='id']", r).val(n.id),
                                $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
                                n.featured_media && (prodImg = n.featured_media.preview_image.src.replace(/(\.[^.]*)$/, "_600x$1").replace("http:", ""),
                                $(".product-card__image-wrapper", r).hasClass("slider") && $(".product-card__image", r).slick("slickGoTo", 0),
                                $(".product-card__image-wrapper", r).hasClass("zoom") && $(".product-card__image img", r).last().attr("src", prodImg),
                                $(".product-card__image img.variant", r).attr("src", prodImg),
                                $(".product-card__image img.variant", r).attr("srcset", prodImg),
                                $(".product-card__image_compare[data-handle=" + o + "] img", ".content-compare.active").attr("src", prodImg),
                                $(".product-card__image_compare[data-handle=" + o + "] img", ".content-compare.active").attr("srcset", prodImg))
                            }
                        }))
                    })
                }
            })
        })
    })
}
,
wpbingo.get_variant_value = function(t) {
    var e = [];
    return $(".swatch-content", t).each(function(t) {
        var a = $(".swatch-items.active label", $(this)).data("variant");
        null === a && (a = "null"),
        e[t] = a
    }),
    variants_value = e.join(" / ")
}
,
wpbingo.updateVariantsButton = function(t, e) {
    for (var a = wpbingo.getCurrentOptions(t), i = e.variants, o = 2; o <= 3; o++)
        if ($(".swatch-content-" + o, t).length) {
            var n = $(".swatch-content-" + o, t);
            $("label", n).each(function() {
                var t, e = $(this), n = e.data("variant");
                2 === o ? t = _.findIndex(i, function(t) {
                    return t.option1 === a[0].value && t.option2 === n && !0 === t.available
                }) : 3 === o && (t = _.findIndex(i, function(t) {
                    return t.option1 === a[0].value && t.option2 === a[1].value && t.option3 === n && !0 === t.available
                })),
                -1 !== t ? e.closest(".swatch-items").removeClass("disabled") : e.closest(".swatch-items").addClass("disabled")
            })
        }
}
,
wpbingo.getCurrentOptions = function(t) {
    var e = [];
    return $(".swatch-content", t).each(function(t) {
        var a = {};
        a.index = $(".swatch-items.active label", $(this)).data("index");
        var i = $(".swatch-items.active label", $(this)).data("variant");
        null === i && (i = "null"),
        a.value = i,
        e[t] = a
    }),
    _.compact(e)
}
,
wpbingo.sticky_product = function() {
    var t = $(".template-product");
    $(".sticky-cart-single", t).length > 0 && ($(window).width(),
    $(window).scroll(function() {
        var e = $(window).scrollTop()
          , a = $(".product-single__buttons", t).offset().top
          , i = $(".bwp-footer").offset().top
          , o = a - e
          , n = i - e - $(window).height();
        o <= 0 ? (t.addClass("act_sticky_active"),
        $(".sticky-cart-single", t).addClass("sticky")) : (t.removeClass("act_sticky_active"),
        $(".sticky-cart-single", t).removeClass("sticky")),
        $(".sticky-cart-single", t).hasClass("sticky") && (n <= 0 ? (t.addClass("act_sticky_active"),
        $(".sticky-cart-single", t).removeClass("sticky")) : (t.removeClass("act_sticky_active"),
        $(".sticky-cart-single", t).addClass("sticky")))
    }))
}
,
wpbingo.sticky_header = function() {
    if ($(".bwp-header").data("sticky_header")) {
        var t = 0;
        $(window).width(),
        $(window).scroll(function() {
            var e = $(this).scrollTop();
            e > 200 ? $(".bwp-header").addClass("sticky") : e <= 200 && $(".bwp-header").removeClass("sticky"),
            t = e
        })
    }
}
,
wpbingo.click_button = function() {
    $(".search-toggle").on("click", function() {
        $(".content-search-toggle").hasClass("active") ? ($(".content-search-toggle").removeClass("active"),
        $(".bwp-header-topbar ").removeClass("active-index"),
        $("body").removeClass("active_search")) : ($(".content-search-toggle").addClass("active"),
        $(".bwp-header-topbar ").addClass("active-index"),
        $("body").addClass("active_search"))
    }),
    $("[data-close-search-toggle]").on("click", function() {
        $(".content-search-toggle").hasClass("active") ? ($(".content-search-toggle").removeClass("active"),
        $(".bwp-header-topbar ").removeClass("active-index"),
        $("body").removeClass("active_search")) : ($(".content-search-toggle").addClass("active"),
        $(".bwp-header-topbar ").addClass("active-index"),
        $("body").addClass("active_search"))
    }),
    $(".title-size-guide").on("click", function() {
        $(".size-guide").hasClass("active") ? $(".size-guide").removeClass("active") : $(".size-guide").addClass("active")
    })
}
,
wpbingo.lookbook = function() {
    $(window).on("click.Bst", function(t) {
        var e = $(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card .product-card")
          , a = $(".wpbingo-section--lookbook:not(.lookbook-simple) .lookbook-card__point");
        0 == e.has(t.target).length && !e.is(t.target) && 0 == a.has(t.target).length && !a.is(t.target) && $(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card").hasClass("active") && ($(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card").removeClass("active").removeAttr("style"),
        $(".wpbingo-section--lookbook:not(.lookbook-simple) .lookbook-card__btn").removeClass("active"))
    }),
    $(".wpbingo-section--lookbook:not(.lookbook-simple) .close-lookbook").on("click", function() {
        $(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card").hasClass("active") && ($(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card").removeClass("active").removeAttr("style"),
        $(".wpbingo-section--lookbook:not(.lookbook-simple) .lookbook-card__btn").removeClass("active"))
    }),
    $(".wpbingo-section--lookbook:not(.lookbook-simple) .lookbook-card__btn").on("click", function() {
        var t = $(this).closest(".wpbingo-section--lookbook:not(.lookbook-simple)")
          , e = $(this).data("target")
          , a = $(this).offset();
        $(".content-product-card", t).removeClass("active").removeAttr("style"),
        $(".lookbook-card__btn", t).removeClass("active"),
        $(this).hasClass("active") ? ($(this).removeClass("active"),
        $("#" + e, t).removeClass("active").removeAttr("style")) : ($(this).addClass("active"),
        $("#" + e, t).addClass("active").css({
            top: a.top,
            left: a.left
        }))
    }),
    $(".wpbingo-section--lookbook.lookbook-split .wpbingo-lookbook__item").mouseover(function() {
        !$(this).hasClass("active") && ($(".wpbingo-section--lookbook.lookbook-split .wpbingo-lookbook__item").removeClass("active"),
        $(this).addClass("active"),
        $(".wpbingo-section--lookbook.lookbook-split .content-product-card").hasClass("active") && ($(".wpbingo-section--lookbook.lookbook-split .content-product-card").removeClass("active").removeAttr("style"),
        $(".wpbingo-section--lookbook.lookbook-split .lookbook-card__btn").removeClass("active")))
    }),
    $(".wpbingo-section--lookbook.lookbook-simple .lookbook-card__btn").on("click", function() {
        var t = $(this).closest(".wpbingo-section--lookbook.lookbook-simple")
          , e = $(this).closest(".lookbook__item")
          , a = $(this).data("target");
        if (!$(this).hasClass("active")) {
            $(".content-product-card", e).removeClass("active"),
            $(".lookbook-card__btn", e).removeClass("active"),
            $(this).addClass("active"),
            $("#" + a, t).addClass("active");
            var i = $("#" + a, t).data("slick-index");
            $(".lookbook-product", e).slick("slickGoTo", i)
        }
    })
}
,
wpbingo.newsletter = function() {
    $(".js-wpbingo-newsletter").each(function() {
        var e = $(this);
        e.on("submit", function(a) {
            a.preventDefault(),
            $(".js-alert-newsletter").remove(),
            $.ajax({
                type: e.attr("method"),
                url: e.attr("action"),
                data: e.serialize(),
                cache: !1,
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function(a) {
                    "success" === a.result ? (e.prepend(t(wpbingo.strings.newsletterSuccess, "success")),
                    $(".js-input-newsletter").val("")) : e.prepend(t(a.msg.replace("0 - ", ""), "danger"))
                },
                error: function(a) {
                    e.prepend(t(a, "danger"))
                }
            })
        })
    }),
    t = function(t, e) {
        return '<div class="js-alert-newsletter alert alert--mailchimp alert-' + e + '">' + t + "</div>"
    }
    ;
    var t, e = ".js-newsletter-popup", a = ".js-newsletter-popup-close", i = ".js-newsletter-popup-submit", o = "", n = "newsletter-popup--active";
    $(e).find(".js-newsletter-popup-success").length > 0 && wpbingo.setCookie("wpbingo_newsletter_popup", 1, 30),
    1 == (o = wpbingo.getCookie("wpbingo_newsletter_popup")) && $(e).remove(),
    1 == o || $(".shopify-challenge__container").length > 0 || $(window).on("scroll", function() {
    var scrollPosition = $(window).scrollTop() + $(window).height();
    var halfwayPoint = $(document).height() / 2;

    if (scrollPosition >= halfwayPoint) {
        $(e).addClass("show");
        $(e).addClass(n);
        $(window).off("scroll");
    }
}),
    $(a).on("click", function() {
        $(e).find(".alert--mailchimp").length > 0 ? wpbingo.setCookie("wpbingo_newsletter_popup", 1, 30) : wpbingo.setCookie("wpbingo_newsletter_popup", 1, 1),
        $(e).removeClass(n),
        setTimeout(function() {
            $(e).removeClass("show")
        }, 1e3)
    }),
    $(i).on("click", function() {
        wpbingo.setCookie("wpbingo_newsletter_popup", 1, 30)
    });
    var r = $(".js-newsletter-popup .image").width()
      , s = $(".js-newsletter-popup .image").height();
    $(e).css("--width-image", r + "px"),
    $(e).css("--height-image", s + "px")
}
,
wpbingo.verify_popup = function() {
    if ($(".js-verify-popup").length) {
        var t = "";
        t || $(".js-verify-popup").addClass("active"),
        $(".js-verify-popup .button-not-allow").on("click", function() {
            wpbingo.setCookie("wpbingo_verify_popup", "exit", 1),
            $(".js-verify-popup").addClass("disabled"),
            $(".js-verify-popup .verify-info").addClass("hidden"),
            $(".js-verify-popup .alert-verify").removeClass("hidden"),
            $("body").addClass("not-scroll")
        }),
        $(".js-verify-popup .button-allow").on("click", function() {
            wpbingo.setCookie("wpbingo_verify_popup", "allow", 1),
            $(".js-verify-popup").removeClass("active")
        }),
        "allow" == (t = wpbingo.getCookie("wpbingo_verify_popup")) && $(".js-verify-popup").removeClass("active"),
        "exit" == t && ($(".js-verify-popup").addClass("disabled"),
        $(".js-verify-popup .verify-info").addClass("hidden"),
        $(".js-verify-popup .alert-verify").removeClass("hidden"),
        $("body").addClass("not-scroll"))
    }
}
,
wpbingo.header_campar = function() {
    var t = "";
    $(".bwp-header-campar .close-campbar").on("click", function() {
        wpbingo.setCookie("wpbingo_header_campar", 1, 1),
        $(".bwp-header-campar").slideUp()
    }),
    1 != (t = wpbingo.getCookie("wpbingo_header_campar")) && ($(".bwp-header-campar").removeClass("active"),
    $(".bwp-header-campar").slideDown())
}
,
wpbingo.customNumberInput = function() {
    var t, e = $("body"), a = ".js-qty-adjust", i = ".js-qty-number";
    e.on("click", a, function() {
        var e = $(this)
          , a = e.siblings(i)
          , o = parseInt(a.val().replace(/\D/g, ""));
        o = t(o),
        e.hasClass("wpbingo-qty__adjust--plus") ? o += 1 : ((o -= 1) <= 0 && (o = 0),
        o <= 0 && "1" == a.attr("min") && (o = 1)),
        a.val(o)
    }),
    e.on("focus", a, function() {
        var t = $(this);
        setTimeout(function() {
            t.select()
        }, 50)
    }),
    t = function(t) {
        return (parseFloat(t) !== parseInt(t) || isNaN(t)) && (t = 1),
        t
    }
}
,
wpbingo.ajaxFilterCategory = function(t) {
    if (t)
        var e = t;
    else
        var e = $(".js-page-collection .FacetsWrapperDesktop .sidebar-categories");
    if ($(".wpbingo-breadcrumbs").hasClass("have-collection"))
        var a = !0;
    var i = ".js-collection-content-product"
      , o = ".collection-sidebar"
      , n = ".wpbingo-breadcrumbs__inner"
      , r = ".active-facets-desktop"
      , s = ".js-change-view"
      , c = ".FacetsWrapperDesktop ";
    $(e).on("click", "a", function(t) {
        t.preventDefault();
        var e = $(this).attr("href")
          , l = $(this).attr("title");
        History.pushState({
            param: Shopify.queryParams
        }, e, e),
        delete Shopify.queryParams.page,
        $("#pre-loading").addClass("load-product"),
        $("#pre-loading .pre-loading__bar").css({
            width: "40%"
        }),
        $.ajax({
            type: "get",
            url: e,
            success: function(t) {
                document.title = l,
                $(i).replaceWith($(t).find(i)),
                $(o).replaceWith($(t).find(o)),
                $(n).replaceWith($(t).find(n)),
                $(r).replaceWith($(t).find(r)),
                $(c).replaceWith($(t).find(c)),
                $(".wpbingo-breadcrumbs__image").replaceWith($(t).find(".wpbingo-breadcrumbs__image")),
                a && wpbingo.elementslickCarousel($(".wpbingo-breadcrumbs__image .js-carousel")),
                wpbingo.ajaxFilterCategory(),
                wpbingo.click_atribute_image(),
                wpbingo.zoom_thumb(),
                $(".product-card__image-wrapper.slider", i).each(function() {
                    wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                }),
                wpbingo.popup_product_card(),
                wpbingo.hideLoading(),
                window.SPR && (SPR.initRatingHandler(),
                SPR.initDomEls(),
                SPR.loadProducts(),
                SPR.loadBadges()),
                wpbingo.countdown(),
                (cViewCollection = wpbingo.getCookie("wpbingo_view_collection")) && ($("#JsCollectionProduct").removeAttr("class"),
                $("#JsCollectionProduct").addClass(cViewCollection),
                $(s).removeClass("active"),
                $("[data-view=" + cViewCollection + "]").addClass("active")),
                $(".js-page-collection").on("click", s, function(t) {
                    t.preventDefault(),
                    $(this).hasClass("active") || ($(".product-card__image-wrapper.slider", i).each(function() {
                        $(".js-carousel", $(this)).slick("refresh")
                    }),
                    wpbingo.setCookie("wpbingo_view_collection", $(this).data("view"), 1),
                    $(s).removeClass("active"),
                    $(this).addClass("active"),
                    $("#JsCollectionProduct").removeAttr("class"),
                    $("#JsCollectionProduct").addClass($(this).data("view")))
                }),
                wpbingo.sidebarCollection(),
                initButtons(),
                initButtonsCompare(),
                wpbingo.countActiveSidebar(),
                wpbingo.toggleSidebar(),
                $(".js-page-collection").hasClass("dropdown") || $(".js-page-collection").hasClass("on_top") || wpbingo.toggleSidebar(),
                $("#pre-loading .pre-loading__bar").css({
                    width: "100%"
                }),
                setTimeout(function() {
                    $("#pre-loading .pre-loading__bar").css({
                        width: "0"
                    }),
                    $("#pre-loading").removeClass("load-product")
                }, 500)
            },
            error: function(t, e) {
                console.log(e)
            }
        }),
        $("body,html").animate({
            scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
        }, 600)
    })
}
,
wpbingo.zoom_thumb = function() {
    $(".product-card .product-card__image-wrapper").hasClass("zoom") && $(".product-card .product-card__image").zoom()
}
,
wpbingo.popup_product_card = function() {
    $(".product-card .btn-select").length && ($(".product-card .btn-select").on("click", function(t) {
        t.preventDefault(),
        $(".product-card .product-card_popup").hasClass("active") && ($(".product-card .product-card_popup").removeClass("active"),
        $(".product-card .btn-select").removeClass("hide"));
        var e = $(this).closest(".product-card");
        $(".product-card_popup", e).hasClass("active") || ($(".product-card_popup", e).addClass("active"),
        $(".btn-select", e).addClass("hide"))
    }),
    $(window).on("click.Bst", function(t) {
        var e = $(".product-card .product-card_popup")
          , a = $(".product-card .product-card__form");
        if (0 == e.has(t.target).length && !e.is(t.target) && 0 == a.has(t.target).length && !a.is(t.target)) {
            var i = $(".product-card");
            $(".product-card_popup", i).hasClass("active") && ($(".product-card_popup", i).removeClass("active"),
            $(".btn-select", i).removeClass("hide"))
        }
    }))
}
,
wpbingo.sale_nofication = function() {
    if ($(".sale-nofication").length) {
        var t = $(".sale-nofication")
          , e = 0
          , a = t.data("start")
          , i = t.data("start_unit");
        "second" == i ? e = 1e3 * a : "minute" == i && (e = 6e4 * a),
        $(".close-notification", t).on("click", function() {
            t.hasClass("active") && t.removeClass("active")
        }),
        setTimeout(function() {
            wpbingo.sale_nofication_start()
        }, e)
    }
}
,
wpbingo.sale_nofication_start = function() {
    if ($(".sale-nofication").length) {
        var t = $(".sale-nofication");
        t.data("id");
        var e = t.data("array_product")
          , a = t.data("limit") - 1
          , i = t.data("stay")
          , o = t.data("stay_unit")
          , n = window.routes.user_purchased
          , r = window.routes.list_time;
        let s = n.split("|")
          , c = r.split("|");
        var l = 0;
        "second" == o ? l = 1e3 * i : "minute" == o && (l = 6e4 * i);
        var d = e.split('""')
          , u = Math.floor(a * Math.random())
          , p = d[u].split('"');
        if (0 == u)
            var h = p[1];
        else
            var h = p[0];
        $.getJSON("/products/" + h + ".js", function(e) {
            $("#image", t).attr("src", e.featured_image),
            $("a", t).attr("href", "/products/" + e.handle),
            $(".product-title a", t).text(e.title),
            $(".notification-purchased .name", t).text(s[u]),
            $(".time-suggest", t).text(c[u]),
            t.addClass("active")
        }),
        $(".scroll-notification", t).css("animation-duration", i + "s"),
        setTimeout(function() {
            t.removeClass("active"),
            wpbingo.sale_nofication()
        }, l)
    }
}
,
wpbingo.discount_single = function() {
    if ($(".product-single #buy_more_form").length > 0) {
        var t = $(".product-single #buy_more_form")
          , e = $(".buy_more", t).data("quatily")
          , a = $("input[name='items[][id]']", t).attr("value")
          , i = {
            type: "POST",
            url: "/cart.js",
            processData: !1,
            contentType: !1,
            dataType: "json",
            success: function(i) {
                if (0 == i.items.length)
                    $(".buy-more-cart", t).removeClass("disabled");
                else
                    for (var o in i.items) {
                        var n = i.items[o];
                        if (n.variant_id == a) {
                            n.quantity >= e ? ($(".buy-more-cart", t).addClass("disabled"),
                            $(".buy-more-cart", t).prop("disabled", !0)) : ($(".buy-more-cart", t).removeClass("disabled"),
                            $(".buy-more-cart", t).prop("disabled", !1));
                            break
                        }
                        $(".buy-more-cart", t).removeClass("disabled"),
                        $(".buy-more-cart", t).prop("disabled", !1)
                    }
            },
            error: function(t, e) {
                "function" == typeof errorCallback ? errorCallback(t, e) : ShopifyAPI.onError(t, e)
            }
        };
        jQuery.ajax(i)
    }
}
,
wpbingo.pick_up = function(t) {
    if ($(".product-single .product-single__pick_up").length > 0) {
        var e = $(".product-single .product-single__pick_up")
          , a = e.data("product_title")
          , i = e.data("src");
        if (null == t)
            var t = e.data("id");
        fetch(window.Shopify.routes.root + "variants/" + t + "/?section_id=pickup-availability").then(t => t.text()).then(t => {
            let o = document.querySelector("[data-store-availability-container]")
              , n = new DOMParser().parseFromString(t, "text/html").querySelector(".shopify-section");
            o.appendChild(n),
            $(".content-info .title", e).html(a),
            !0 == e.data("only_variant") && $(".product-info .content-image img", e).attr("src", i),
            $(".pickup_modal-content", e).slideUp(),
            $(".pickup-availability-information", e).on("click", function() {
                $(".pickup-availabilities-modal", e).hasClass("active") || ($(".pickup-availabilities-modal", e).addClass("active"),
                $(".pickup_modal-content", e).slideDown())
            }),
            $(".pickup_modal-close", e).on("click", function() {
                $(".pickup-availabilities-modal", e).hasClass("active") && ($(".pickup_modal-content", e).slideUp(),
                setTimeout(function() {
                    $(".pickup-availabilities-modal", e).removeClass("active")
                }, 500))
            })
        }
        ).catch(t => {
            console.error(t)
        }
        )
    }
}
,
wpbingo.time_estimated_delivery = function() {
    if ($(".product-single .estimated_delivery").length > 0) {
        var t = $(".product-single .estimated_delivery")
          , e = $(".product-single .estimated_delivery").data("date_now");
        if (e)
            var a = new Date(e).getTime();
        else
            var a = Date.now();
        var i = new Date
          , o = 864e5
          , n = $(t).data("number_day")
          , r = new Date(n * o + a)
          , s = new Date((n + 4) * o + a)
          , r = r.toLocaleDateString("en-us", {
            weekday: "long",
            month: "short",
            day: "numeric"
        })
          , s = s.toLocaleDateString("en-us", {
            weekday: "long",
            month: "short",
            day: "numeric"
        })
          , c = (o - ((60 * i.getHours() + i.getMinutes()) * 60 + i.getSeconds()) * 1e3) / 1e3
          , l = (c - c % 60) / 60 % 60
          , d = ((c - c % 60) / 60 - l % 60) / 60;
        $("span.time_hour", t).html(d),
        $("span.time_min", t).html(l),
        $("span.day_start", t).html(r),
        $("span.day_stop", t).html(s)
    }
}
,
wpbingo.countActiveSidebar = function() {
    var t = 0;
    if ($(".js-page-collection").hasClass("dropdown") || $(".js-page-collection").hasClass("on_top"))
        var e = $(".js-page-collection .FacetsWrapperDesktop");
    else
        var e = $(".js-page-collection .collection-sidebar");
    $(".js-filter", e).each(function() {
        (t = $("input:checked", $(this)).length) > 0 ? ($(".block-sidebar__title .count", $(this)).removeClass("hide"),
        $(".facets__display .reset-filter", $(this)).removeClass("hide"),
        $(".block-sidebar__title .count", $(this)).text(t)) : $(".block-sidebar__title .count", $(this)).addClass("hide"),
        $(this).hasClass("show") && ($("h4.block-sidebar__title", $(this)).hasClass("active") ? $("h4.block-sidebar__title", $(this)).removeClass("active") : $("h4.block-sidebar__title", $(this)).addClass("active"))
    }),
    $(".js-page-collection.dropdown .sidebar-categories ul li.active").length > 0 ? $(".js-page-collection.dropdown .sidebar-categories .block-sidebar__title .count").removeClass("hide") : $(".js-page-collection.dropdown .sidebar-categories .block-sidebar__title .count").addClass("hide"),
    $(".collection-sidebar .js-filter .facets__display .select-filter label").on("click", function() {
        $(".collection-sidebar .js-filter").removeClass("show"),
        $(this).closest(".js-filter").addClass("show")
    }),
    $(".collection-sidebar .js-filter .facets__display .facets__price input").change(function() {
        $(".collection-sidebar .js-filter").removeClass("show"),
        $(this).closest(".js-filter").addClass("show")
    }),
    $(".js-page-collection.on_top .js-filter .facets__display li label").on("click", function() {
        var t = $(this).closest(".js-page-collection.on_top ");
        t.hasClass("show") || t.addClass("show")
    }),
    $(".js-page-collection.on_top .js-filter .facets__display .facets__price input").change(function() {
        var t = $(this).closest(".js-page-collection.on_top ");
        t.hasClass("show") || t.addClass("show")
    })
}
,
wpbingo.toggleSidebar = function(t) {
    if ($(".js-page-collection:not(.sidebar_4,.on_top) h4.block-sidebar__title").on("click", function() {
        if ($(".js-page-collection").hasClass("dropdown") && !$(this).hasClass("active") && ($(".js-page-collection.dropdown .facets__display").slideUp(),
        $(".js-page-collection.dropdown h4.block-sidebar__title").removeClass("active")),
        t) {
            if ($(".js-page-collection").hasClass("dropdown"))
                var e = $(this).closest(".js-filter");
            else
                var e = $(this).closest(".js-filter:not(.sidebar-categories)")
        } else
            var e = $(this).closest(".js-filter");
        $("h4.block-sidebar__title", e).hasClass("active") ? $("h4.block-sidebar__title", e).removeClass("active") : $("h4.block-sidebar__title", e).addClass("active"),
        $(".facets__display", e).slideToggle()
    }),
    $(window).width() > 991 ? ($(".js-page-collection.on_top .js-sidebar-toggle").on("click", function() {
        $(this).toggleClass("active"),
        $(".js-page-collection.on_top .dropdown_ontop").slideToggle(),
        $(".js-page-collection.on_top").hasClass("show") && $(".js-page-collection.on_top").removeClass("show")
    }),
    $(".js-page-collection .collection-sidebar__overlay").on("click", function() {
        $("body").hasClass("collection-sidebar--open") && ($(".js-page-collection.on_top .dropdown_ontop").slideUp(),
        $(".js-page-collection").hasClass("on_top") ? setTimeout(function() {
            $("body").removeClass("collection-sidebar--open"),
            $(".js-page-collection.on_top").hasClass("show") && $(".js-page-collection.on_top").removeClass("show")
        }, 600) : $("body").removeClass("collection-sidebar--open"))
    })) : t || $(".js-page-collection.on_top .collection-sidebar__overlay").on("click", function() {
        $("body").hasClass("collection-sidebar--open") ? $("body").removeClass("collection-sidebar--open") : $("body").addClass("collection-sidebar--open")
    }),
    $(".js-page-collection").hasClass("viewmore")) {
        var e = $(".js-page-collection").data("list_number");
        if ($(".js-page-collection").hasClass("sidebar_1") || $(".js-page-collection").hasClass("side_out") || $(".js-page-collection").hasClass("filter_drawer")) {
            if (t) {
                if ($(".js-page-collection").hasClass("on_top"))
                    var a = $(".filter-list");
                else
                    var a = $(".filter-list:not(.sidebar-categories)")
            } else
                var a = $(".filter-list")
        } else if ($(".js-page-collection").hasClass("sidebar_2")) {
            if (t)
                var a = $(".js-filter:not(.sidebar-categories,.filter-color,.js-filter-price,.filter-image)");
            else
                var a = $(".js-filter:not(.filter-color,.js-filter-price,.filter-image)")
        } else if ($(".js-page-collection").hasClass("sidebar_3")) {
            if (t)
                var a = $(".js-filter:not(.sidebar-categories,.js-filter-price,.filter-image,.filter-label)");
            else
                var a = $(".js-filter:not(.js-filter-price,.filter-image,.filter-label)")
        } else if ($(".js-page-collection").hasClass("sidebar_4")) {
            if (t)
                var a = $(".filter-list:not(.sidebar-categories,.filter-out_stock)");
            else
                var a = $(".filter-list:not(.filter-out_stock)")
        } else if ($(".js-page-collection").hasClass("dropdown") || $(".js-page-collection").hasClass("on_top"))
            var a = $(".js-filter:not(.filter-image)");
        $(a).each(function() {
            var t = $(".facets__display>ul>li", $(this)).length;
            !$(".facets__display>ul>li.view", $(this)).length && t > e && $(".facets__display>ul", $(this)).append('<li class="view"><span>' + window.strings.view_more + "</span></li>"),
            $(".facets__display>ul>li:not(.view)", $(this)).each(function(t) {
                t + 1 > e && $(this).css("display", "none")
            })
        }),
        $(".facets__display>ul>li.view", a).on("click", function() {
            var t = $(this).closest("ul");
            if ($(">li:not(.view)", t).each(function(t) {
                t + 1 > e && $(this).slideToggle()
            }),
            $(this).hasClass("show")) {
                $(this).removeClass("show"),
                $("span", $(this)).text(window.strings.view_more);
                return
            }
            $(this).addClass("show"),
            $("span", $(this)).text(window.strings.view_less)
        })
    }
}
,
wpbingo.sidebarCollection = function(t) {
    if (t)
        var e = $(".js-page-collection .FacetsWrapperDesktop");
    else
        var e = $(".js-page-collection");
    $(".sidebar-categories ul li a", e).on("click", function() {
        var t = $(this).closest("li");
        $(".sidebar-categories ul li").removeClass("active"),
        t.hasClass("active") || t.addClass("active")
    }),
    $(".sidebar-categories .toggle_collection-children", e).on("click", function() {
        var t = $(this).closest("li");
        $(this).toggleClass("show"),
        $(">.collection-children", t).slideToggle()
    }),
    $(".sidebar-categories .collection-children li", e).each(function() {
        if ($(this).hasClass("active")) {
            var t = $(this).parents(".collection-children")
              , e = $(this).parents("li");
            t.css({
                display: "block"
            }),
            $(">.link-collection >.toggle_collection-children", e).hasClass("show") || $(">.link-collection >.toggle_collection-children", e).addClass("show")
        }
    })
}
,
wpbingo.gift_wrapper = function() {
    var t = {
        body: "body",
        GiftCard: "[data-gift_wrapper_card]",
        giftWrapCheckbox: "#gift-wrapping",
        giftNoteInput: ".gift-note__input",
        cartDrawer: "#cart-drawer" // Ensure we track when the cart drawer updates
    };

    function e(t) {
        this.$container = $(t),
        this.cache = {},
        this.productVariants = [],
        this.currentVariant = {},
        this.cacheSelectors(),
        this.initializeEvents()
    }

    return e.prototype = _.assignIn({}, e.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $body: $("body"),
                $giftWrapCheckbox: $(t.giftWrapCheckbox),
                $giftNoteInput: $(t.giftNoteInput),
                $cartDrawer: $(t.cartDrawer)
            };
        },

        initializeEvents: function() {
            var e = this;

            // Handle Gift Wrap Checkbox
            $(t.body).on("change", t.giftWrapCheckbox, function() {
                e.toggleGiftNote();
                var isChecked = $(this).is(":checked") ? "yes" : "";

                // Update cart attributes
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { 'gift_wrap': isChecked } })
                });
            });

            // Handle Gift Note Input
            $(t.body).on("input", "#gift-note", function() {
                var note = $(this).val();

                // Update cart attributes
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { 'gift_note': note } })
                });
            });

            // Ensure gift note shows in cart drawer
            $(t.body).on("cart:updated drawer.open", function() {
                e.toggleGiftNote();
            });

            // Run on load to maintain state
            e.toggleGiftNote();
        },

        toggleGiftNote: function() {
            var $checkbox = $(t.giftWrapCheckbox);
            var $noteInput = $(t.giftNoteInput);

            if ($checkbox.length && $checkbox.is(":checked")) {
                $noteInput.show();
            } else {
                $noteInput.hide();
            }
        }
    }),
    e;
}(),
wpbingo.gift_wrap = function() {
    var t = {
        body: "body",
        GiftCard: "[data-gift-card]",
        giftWrapTemplate: "#gift-card-template",
        giftWrapBtn: ".gift-wrap [data-gift_card]",
        giftCardContainer: "[data-gift-card-container]",
        giftCardClose: "[data-gift-card-close]",
        giftCardImages: "[data-gift-card-images]",
        giftCardVariant: ".js-giftcard-option-selector",
        originalSelectorId: "[data-edit_variant-variant]",
        giftCardProductPrice: ".js-gift-product-price",
        giftCardProductPriceCompare: ".js-gift-product-price-compare",
        giftCardQty: "[data-gift-card-quantity]",
        giftCardAvaiable: ".product-avaiable",
        giftCardAvaiableInStock: ".product-avaiable--instock",
        giftCardAvaiableOutStock: ".product-avaiable--outstock",
        giftCardProductDetailsURL: ".js-qv-product-details"
    };
    function e(t) {
        this.$container = $(t),
        this.cache = {},
        this.productVariants = [],
        this.currentVariant = {},
        this.cacheSelectors(),
        this.initializeEvents()
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $body: $("body"),
                $giftCardContainer: this.$container.find(t.giftCardContainer)
            }
        },
        initializeEvents: function() {
            var e = this;
            $(t.body).on("click", t.giftWrapBtn, function(a) {
                a.preventDefault();
                var i = $(this).data("gift_card");
                $(this).addClass("load-giftcard"),
                $.getJSON("/products/" + i + ".js", function(a) {
                    a.available ? e.firstAvailableVariant(a.variants, e) : e.currentVariant = a.variants[0],
                    $(t.giftWrapBtn).removeClass("load-giftcard"),
                    e.buildGiftCard(a),
                    e.show(),
                    e.createImageCarousel(a)
                })
            }),
            $(t.body).on("click", t.giftCardClose, function(t) {
                t.preventDefault(),
                e.hide()
            }),
            $(t.giftCardContainer).on("change", t.giftCardVariant, function(t) {
                e.onVariantChange()
            })
        },
        firstAvailableVariant: function(t, e) {
            e.productVariants = t;
            for (var a = 0; a < t.length; a++) {
                var i = t[a];
                if (i.available) {
                    e.currentVariant = i;
                    break
                }
            }
        },
        buildGiftCard: function(e) {
            var a = wpbingo.strings.moneyFormat
              , i = this.currentVariant
              , o = $(t.giftWrapTemplate).html()
              , n = Handlebars.compile(o)
              , r = ""
              , s = ""
              , c = {
                id: e.id
            };
            if (void 0 !== e.media) {
                r += '<div class="gift_card-images__list slick-carousel" data-gift-card-images>';
                for (var l = 0; l < e.media.length; l++) {
                    var d = e.media[l];
                    "image" === d.media_type && (r += '<div class="slick-carousel__item"><div class="giftcard-images__item" data-media-id=' + d.id + '><img class="img-fluid" alt="' + e.title + '" src="' + d.src + '" /></div></div>')
                }
                r += "</div>"
            }
            c.variantID = i.id,
            c.sku = null !== i.sku && "" !== i.sku ? i.sku : "N/A",
            c.images = r,
            c.title = e.title,
            c.url = e.url,
            s += '<div class="price-container">',
            s += '<div class="js-gift-product-price-compare product-single__price--compare-at ' + (null !== e.compare_at_price ? "" : "d-none") + '">' + wpbingo.Currency.formatMoney(e.compare_at_price, a) + "</div>",
            s += '<div class="js-gift-product-price product-single__price">' + wpbingo.Currency.formatMoney(e.price, a) + "</div>",
            s += '</div">',
            c.price = s,
            c.variants = this.buildVariant(e),
            $(t.giftCardContainer).html(n(c)),
            this.updateMedia(i),
            this.updateDetailsLink(i),
            $("#form-gift-card-addtocart .btn--add-to-cart").on("click", function(t) {
                t.preventDefault(),
                $(this).removeClass("added"),
                $(this).addClass("active");
                let e = document.querySelector("#form-gift-card-addtocart");
                var a = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(e),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(t) {
                        $("#form-gift-card-addtocart .btn--add-to-cart").removeClass("active"),
                        $("#form-gift-card-addtocart .btn--add-to-cart").addClass("added"),
                        setTimeout(function() {
                            $("#form-gift-card-addtocart .btn--add-to-cart").removeClass("added")
                        }, 3e3),
                        ajaxCart.load(),
                        ajaxCartPage.load()
                    },
                    error: function(t, e) {
                        "function" == typeof errorCallback ? errorCallback(t, e) : ShopifyAPI.onError(t, e)
                    }
                };
                jQuery.ajax(a)
            }),
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        convertToSlug: function(t) {
            return t.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        buildVariant: function(t) {
            var e = ""
              , a = this.currentVariant;
            if ("Title" !== t.options[0].name)
                for (var i = t.options, o = 0; o < i.length; o++) {
                    var n = i[o]
                      , r = o + 1;
                    e += '<div class="variants-wrapper product-form__item" data-giftcard-variant-option="' + r + '">',
                    e += '<label class="variants__label">' + n.name + "</label>",
                    e += '<div class="variants__options">';
                    for (var s = 0; s < n.values.length; s++) {
                        for (var c = n.values[s], l = !0, d = "", u = 0; u < this.productVariants.length; u++) {
                            var p = this.productVariants[u];
                            if (p.available) {
                                if (0 == o && p.option1 === c) {
                                    l = !1;
                                    break
                                }
                                if (1 == o && p.option2 === c && p.option1 == a.option1) {
                                    l = !1;
                                    break
                                }
                                if (2 == o && p.option3 === c && p.option2 == a.option2 && p.option1 == a.option1) {
                                    l = !1;
                                    break
                                }
                            }
                        }
                        e += '<div class="single-option-selector">',
                        e += '<input type="radio" data-single-option-button',
                        e += a.options[o] === c ? " checked " : " ",
                        l && (e += 'disabled="disabled"'),
                        e += 'value="' + _.escape(c) + '" data-index="option' + r + '" name="option' + n.position + '" ',
                        e += 'class="js-giftcard-option-selector',
                        l && (e += " disabled"),
                        e += '" id="giftcard-product-option-' + o + "-" + c.toLowerCase() + '">',
                        e += '<label class="' + c + '" data-toggle="tooltip" title="' + c + '" for="giftcard-product-option-' + o + "-" + c.toLowerCase() + '" ' + d,
                        l && (e += ' class="disabled"'),
                        e += ">" + c + '<span class="d-none"></span></label>',
                        e += "</div>"
                    }
                    e += "</div>",
                    e += "</div>"
                }
            return e
        },
        createImageCarousel: function(e) {
            e.media.length > 1 && $(t.GiftCard).find(t.giftCardImages).slick({
                infinite: !1,
                rows: 0,
                arrows: !1,
                rtl: wpbingo.rtl_slick()
            })
        },
        getCurrentOptions: function() {
            var e = _.map($(t.giftCardVariant, t.giftCardContainer), function(t) {
                var e = $(t)
                  , a = e.attr("type")
                  , i = {};
                return "radio" !== a && "checkbox" !== a ? (i.value = e.val(),
                i.index = e.data("index"),
                i) : !!e[0].checked && (i.value = e.val(),
                i.index = e.data("index"),
                i)
            });
            return _.compact(e)
        },
        getVariantFromOptions: function() {
            var t = this.getCurrentOptions()
              , e = this.productVariants;
            return _.find(e, function(e) {
                return t.every(function(t) {
                    return _.isEqual(e[t.index], t.value)
                })
            })
        },
        updateVariantsButton: function() {
            for (var e = this.getCurrentOptions(), a = this.productVariants, i = 2; i <= 3; i++)
                $('[data-giftcard-variant-option="' + i + '"]', t.giftCardContainer).length && $('[data-giftcard-variant-option="' + i + '"] ' + t.giftCardVariant, t.giftCardContainer).each(function() {
                    var t, o = $(this), n = o.val();
                    2 === i ? t = _.findIndex(a, function(t) {
                        return t.option1 === e[0].value && t.option2 === n && !0 === t.available
                    }) : 3 === i && (t = _.findIndex(a, function(t) {
                        return t.option1 === e[0].value && t.option2 === e[1].value && t.option3 === n && !0 === t.available
                    })),
                    -1 !== t ? (o.removeAttr("disabled", "disabled").removeClass("disabled"),
                    o.next("label").removeClass("disabled")) : (o.attr("disabled", "disabled").addClass("disabled"),
                    o.next("label").addClass("disabled"))
                })
        },
        updateVariantsButtonDisabed: function() {
            for (var e = 2; e <= 3; e++)
                if ($('[data-giftcard-variant-option="' + e + '"]', t.giftCardContainer).length) {
                    var a = !1;
                    $('[data-giftcard-variant-option="' + e + '"] ' + t.giftCardVariant, t.giftCardContainer).each(function() {
                        var t = $(this)
                          , e = t.attr("type");
                        if (("radio" === e || "checkbox" === e) && this.checked && t.hasClass("disabled"))
                            return t.prop("checked", !1),
                            a = !0,
                            !1
                    }),
                    $('[data-giftcard-variant-option="' + e + '"] ' + t.giftCardVariant, t.giftCardContainer).each(function() {
                        var t = $(this)
                          , e = t.attr("type");
                        if (a && ("radio" === e || "checkbox" === e) && !t.hasClass("disabled"))
                            return t.prop("checked", !0),
                            a = !1,
                            t.trigger("change"),
                            !1
                    })
                }
        },
        updateMasterSelect: function(e) {
            e && $(t.originalSelectorId, t.giftCardContainer).val(e.id)
        },
        updateMedia: function(e) {
            e && e.featured_media && e.featured_media.id && $(t.giftCardImages, t.giftCardContainer).find(".giftcard-images__item").each(function() {
                var a = $(this).data("media-id");
                if (e.featured_media.id == a) {
                    var i = $(this).closest(".slick-carousel__item").data("slick-index");
                    null != i && $(t.giftCardImages, t.giftCardContainer).slick("slickGoTo", i)
                }
            })
        },
        updatePrice: function(e) {
            var a = wpbingo.strings.moneyFormat;
            e ? ($(t.giftCardProductPrice, t.giftCardContainer).removeClass("d-none"),
            $(t.giftCardProductPriceCompare, t.giftCardContainer).removeClass("d-none"),
            $(t.giftCardProductPrice, t.giftCardContainer).html(wpbingo.Currency.formatMoney(e.price, a)),
            e.compare_at_price > e.price ? ($(t.giftCardProductPriceCompare, t.giftCardContainer).html(wpbingo.Currency.formatMoney(e.compare_at_price, a)).removeClass("d-none"),
            $(t.giftCardProductPrice, t.giftCardContainer).addClass("on-sale")) : ($(t.giftCardProductPriceCompare, t.giftCardContainer).addClass("d-none"),
            $(t.giftCardProductPrice, t.giftCardContainer).removeClass("on-sale"))) : ($(t.giftCardProductPrice, t.giftCardContainer).addClass("d-none"),
            $(t.giftCardProductPriceCompare, t.giftCardContainer).addClass("d-none")),
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        updateProductAvaiable: function(e) {
            var a = "product-avaiable--active"
              , i = wpbingo.strings;
            $(t.giftCardAvaiable, t.giftCardContainer).removeClass(a),
            e ? (e.available ? ($(t.giftCardQty, t.giftCardContainer).removeClass("d-none"),
            $(t.giftCardAvaiableInStock, t.giftCardContainer).addClass(a)) : ($(t.giftCardQty, t.giftCardContainer).addClass("d-none"),
            $(t.giftCardAvaiableOutStock, t.giftCardContainer).addClass(a)),
            e.available ? ($(t.giftCardContainer).find(".btn--add-to-cart").removeClass("disabled").prop("disabled", !1),
            $(t.giftCardContainer).find(".btn--add-to-cart .btn__text").html(i.addToCart)) : ($(t.giftCardContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0),
            $(t.giftCardContainer).find(".btn--add-to-cart .btn__text").html(i.soldOut))) : ($(t.giftCardQty, t.giftCardContainer).addClass("d-none"),
            $(t.giftCardContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0),
            $(t.giftCardContainer).find(".btn--add-to-cart .btn__text").html(i.unavailable))
        },
        updateDetailsLink: function(e) {
            if (e) {
                var a = $(t.giftCardProductDetailsURL, t.giftCardContainer).data("url") + "?variant=" + e.id;
                $(t.giftCardProductDetailsURL, t.giftCardContainer).removeClass("d-none").attr("href", a)
            } else
                $(t.giftCardProductDetailsURL, t.giftCardContainer).addClass("d-none")
        },
        onVariantChange: function() {
            var e = this.getVariantFromOptions();
            if ($("[data-single-option-button]", t.giftCardContainer).length && (this.updateVariantsButton(),
            !e || !e.available)) {
                this.updateVariantsButtonDisabed();
                return
            }
            this.updateMasterSelect(e),
            this.updateMedia(e),
            this.updatePrice(e),
            this.updateProductAvaiable(e),
            this.updateDetailsLink(e),
            this.currentVariant = e
        },
        show: function() {
            $(t.body).addClass("giftcard-active"),
            $(t.GiftCard).addClass("show"),
            setTimeout(function() {
                $(".gift_card-container .gift_card__content").addClass("show")
            }, 400)
        },
        hide: function() {
            $(t.giftCardContainer).html(),
            $(t.body).removeClass("giftcard-active"),
            $(".gift_card-container .gift_card__content").removeClass("show"),
            setTimeout(function() {
                $(t.GiftCard).removeClass("show")
            }, 400)
        }
    }),
    e
}(),
wpbingo.update_variant_cartpage = function() {
    var t = {
        body: "body",
        EditVariant: "[data-edit_variant-cart]",
        EditVariantTemplate: "#edit_variants-template",
        EditVariantBtn: ".cart-product-edit_variant",
        EditVariantContainer: "[data-edit_variant-cart-container]",
        EditVariantClose: "[data-edit_variant-cart-close]",
        EditVariantImages: "[data-edit_variant-images]",
        EditVariantVariant: ".js-edit_variant-option-selector",
        originalSelectorId: "[data-edit_variant-variant]",
        EditVariantProductPrice: ".js-edit_variant-product-price",
        EditVariantProductPriceCompare: ".js-edit_variant-product-price-compare",
        EditVariantQty: "[data-edit_variant-quantity]",
        EditVariantAvaiable: ".product-avaiable",
        EditVariantAvaiableInStock: ".product-avaiable--instock",
        EditVariantAvaiableOutStock: ".product-avaiable--outstock",
        EditVariantDetailsURL: ".js-qv-product-details"
    };
    function e(t) {
        this.$container = $(t),
        this.cache = {},
        this.productVariants = [],
        this.currentVariant = {},
        this.cacheSelectors(),
        this.initializeEvents()
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $body: $("body"),
                $EditVariantContainer: this.$container.find(t.EditVariantContainer)
            }
        },
        initializeEvents: function() {
            var e = this;
            $(t.body).on("click", t.EditVariantBtn, function(a) {
                a.preventDefault();
                var i = $(this).data("handle")
                  , o = $(this).data("value")
                  , n = $(this).data("line")
                  , r = $(this).data("id_variant")
                  , s = $(this).closest(".content-edit_variant-popup");
                $(this).addClass("load-edit_variant"),
                $(".image-popup", s).addClass("imagepopup_active"),
                $("body").addClass("editv_overlay-layer"),
                $.getJSON("/products/" + i + ".js", function(a) {
                    a.available ? e.firstAvailableVariant(a.variants, e) : e.currentVariant = a.variants[0],
                    $(t.EditVariantBtn).removeClass("load-edit_variant"),
                    e.buildEditVariant(a, o, n, r);
                    var i = $(".edit_variant-cart-container .content_product_detail .variants-wrapper");
                    $(i).each(function() {
                        var t = $(this)
                          , e = $("input:checked", t).attr("value");
                        $(".variants__label span", t).html(e)
                    }),
                    $(t.EditVariantContainer).on("change", t.EditVariantVariant, function(t) {
                        e.onVariantChange(r)
                    }),
                    767 > $(window).width() ? $(t.EditVariant).addClass("is-visible") : ($(t.EditVariant).addClass("transform"),
                    setTimeout(function() {
                        $(t.EditVariant).addClass("is-visible")
                    }, 300))
                })
            }),
            $(t.body).on("click", t.EditVariantClose, function(e) {
                767 > $(window).width() ? ($(t.EditVariant).removeClass("is-visible"),
                $("body").removeClass("editv_overlay-layer"),
                setTimeout(function() {
                    $("[data-edit_variant-cart-container]").empty()
                }, 300)) : ($(t.EditVariant).removeClass("is-visible"),
                setTimeout(function() {
                    $(t.EditVariant).removeClass("transform")
                }, 500),
                setTimeout(function() {
                    $("body").removeClass("editv_overlay-layer"),
                    $("[data-edit_variant-cart-container]").empty()
                }, 700))
            }),
            $(t.body).on("click", function(e) {
                $(e.target).is("body.editv_overlay-layer") && (767 > $(window).width() ? ($(t.EditVariant).removeClass("is-visible"),
                $("body").removeClass("editv_overlay-layer"),
                setTimeout(function() {
                    $("[data-edit_variant-cart-container]").empty()
                }, 300)) : ($(t.EditVariant).removeClass("is-visible"),
                setTimeout(function() {
                    $(t.EditVariant).removeClass("transform")
                }, 500),
                setTimeout(function() {
                    $("body").removeClass("editv_overlay-layer"),
                    $("[data-edit_variant-cart-container]").empty()
                }, 700)))
            })
        },
        firstAvailableVariant: function(t, e) {
            e.productVariants = t;
            for (var a = 0; a < t.length; a++) {
                var i = t[a];
                if (i.available) {
                    e.currentVariant = i;
                    break
                }
            }
        },
        buildEditVariant: function(e, a, i, o) {
            var n = wpbingo.strings.moneyFormat
              , r = this.currentVariant;
            for (var s in e.variants)
                if (o == e.variants[s].id)
                    var r = e.variants[s];
            var c = $(t.EditVariantTemplate).html()
              , l = Handlebars.compile(c)
              , d = ""
              , u = ""
              , p = {
                id: e.id
            };
            if (void 0 !== e.media) {
                d += '<div class="edit_variant-images__list slick-carousel" data-edit_variant-images>';
                for (var h = 0; h < e.media.length; h++) {
                    var m = e.media[h];
                    "image" === m.media_type && (0 == h ? d += '<div class="slick-carousel__item show"><div class="edit_variant-images__item" data-media-id=' + m.id + '><img class="img-fluid" alt="' + e.title + '" src="' + m.src + '" /></div></div>' : d += '<div class="slick-carousel__item"><div class="edit_variant-images__item" data-media-id=' + m.id + '><img class="img-fluid" alt="' + e.title + '" src="' + m.src + '" /></div></div>')
                }
                d += "</div>"
            }
            p.variantID = r.id,
            p.sku = null !== r.sku && "" !== r.sku ? r.sku : "N/A",
            p.images = d,
            p.title = e.title,
            p.qty = a,
            p.line = i,
            p.url = e.url,
            u += '<div class="price-container">',
            u += '<div class="js-edit_variant-product-price-compare product-single__price--compare-at ' + (null !== e.compare_at_price ? "" : "d-none") + '">' + wpbingo.Currency.formatMoney(e.compare_at_price, n) + "</div>",
            u += '<div class="js-edit_variant-product-price product-single__price">' + wpbingo.Currency.formatMoney(e.price, n) + "</div>",
            u += '</div">',
            p.price = u,
            p.variants = this.buildVariant(e, o),
            $(t.EditVariantContainer).html(l(p)),
            this.updateMedia(r),
            this.updateDetailsLink(r),
            $("#form-edit_variants-addtocart .btn--add-to-cart").on("click", function(e) {
                e.preventDefault();
                var a = $(this).closest(".product-edit_variants");
                $(this).removeClass("added"),
                $(this).addClass("active");
                let i = document.querySelector("#form-edit_variants-addtocart");
                var o = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(i),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(e) {
                        var i = a.data("line") + 1;
                        $("#form-edit_variants-addtocart .btn--add-to-cart").removeClass("active"),
                        $("#form-edit_variants-addtocart .btn--add-to-cart").addClass("added"),
                        setTimeout(function() {
                            $("#form-edit_variants-addtocart .btn--add-to-cart").removeClass("added")
                        }, 2e3),
                        ShopifyAPI.changeItem(i, 0),
                        setTimeout(function() {
                            ajaxCart.load()
                        }, 300),
                        $("body").hasClass("template-cart") && setTimeout(function() {
                            ajaxCartPage.load()
                        }, 300),
                        setTimeout(function() {
                            767 > $(window).width() ? ($(t.EditVariant).removeClass("is-visible"),
                            $("body").removeClass("editv_overlay-layer"),
                            setTimeout(function() {
                                $("[data-edit_variant-cart-container]").empty()
                            }, 300)) : ($(t.EditVariant).removeClass("is-visible"),
                            setTimeout(function() {
                                $(t.EditVariant).removeClass("transform")
                            }, 500),
                            setTimeout(function() {
                                $("body").removeClass("editv_overlay-layer"),
                                $("[data-edit_variant-cart-container]").empty()
                            }, 700))
                        }, 500)
                    },
                    error: function(t, e) {
                        "function" == typeof errorCallback ? errorCallback(t, e) : ShopifyAPI.onError(t, e)
                    }
                };
                jQuery.ajax(o)
            }),
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        convertToSlug: function(t) {
            return t.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        buildVariant: function(t, e) {
            var a = ""
              , i = this.currentVariant;
            for (var o in t.variants)
                if (e == t.variants[o].id)
                    var i = t.variants[o];
            if ("Title" !== t.options[0].name)
                for (var n = t.options, r = 0; r < n.length; r++) {
                    var s = n[r]
                      , c = r + 1
                      , l = "label";
                    wpbingo.settings.filter_name_1 === s.name ? l = wpbingo.settings.select_filter_1 : wpbingo.settings.filter_name_2 === s.name ? l = wpbingo.settings.select_filter_2 : wpbingo.settings.filter_name_3 === s.name && (l = wpbingo.settings.select_filter_3),
                    a += '<div class="variants-wrapper product-form__item ' + l + '" data-edit_variants-variant-option="' + c + '">',
                    a += '<label class="variants__label">' + s.name + ": <span></span></label>",
                    a += '<div class="variants__options">';
                    for (var d = 0; d < s.values.length; d++) {
                        for (var u = s.values[d], p = !0, h = "", m = 0; m < this.productVariants.length; m++) {
                            var f = this.productVariants[m];
                            if (f.available) {
                                if (0 == r && f.option1 === u) {
                                    p = !1;
                                    break
                                }
                                if (1 == r && f.option2 === u && f.option1 == i.option1) {
                                    p = !1;
                                    break
                                }
                                if (2 == r && f.option3 === u && f.option2 == i.option2 && f.option1 == i.option1) {
                                    p = !1;
                                    break
                                }
                            }
                        }
                        a += '<div class="single-option-selector">',
                        a += '<input type="radio" data-single-option-button',
                        a += i.options[r] === u ? " checked " : " ",
                        p && (a += 'disabled="disabled"'),
                        a += 'value="' + _.escape(u) + '" data-index="option' + c + '" name="option' + s.position + '" ',
                        a += 'class="js-edit_variant-option-selector',
                        p && (a += " disabled"),
                        a += '" id="edit_variants-product-option-' + r + "-" + u.toLowerCase() + '">',
                        a += '<label class="' + u + '" data-toggle="tooltip" title="' + u + '" for="edit_variants-product-option-' + r + "-" + u.toLowerCase() + '" ' + h,
                        p && (a += ' class="disabled"'),
                        a += ">" + u + '<span class="tool-tip">' + u + "</span></label>",
                        a += "</div>"
                    }
                    a += "</div>",
                    a += "</div>"
                }
            return a
        },
        createImageCarousel: function(e) {
            e.media.length > 1 && $(t.EditVariant).find(t.EditVariantImages).slick({
                infinite: !1,
                rows: 0,
                fade: !0,
                rtl: wpbingo.rtl_slick()
            })
        },
        getCurrentOptions: function() {
            var e = _.map($(t.EditVariantVariant, t.EditVariantContainer), function(t) {
                var e = $(t)
                  , a = e.attr("type")
                  , i = {};
                return "radio" !== a && "checkbox" !== a ? (i.value = e.val(),
                i.index = e.data("index"),
                i) : !!e[0].checked && (i.value = e.val(),
                i.index = e.data("index"),
                i)
            });
            return _.compact(e)
        },
        getVariantFromOptions: function() {
            var t = this.getCurrentOptions()
              , e = this.productVariants;
            return _.find(e, function(e) {
                return t.every(function(t) {
                    return _.isEqual(e[t.index], t.value)
                })
            })
        },
        updateVariantsButton: function() {
            for (var e = this.getCurrentOptions(), a = this.productVariants, i = 2; i <= 3; i++)
                $('[data-edit_variants-variant-option="' + i + '"]', t.EditVariantContainer).length && $('[data-edit_variants-variant-option="' + i + '"] ' + t.EditVariantVariant, t.EditVariantContainer).each(function() {
                    var t, o = $(this), n = o.val();
                    2 === i ? t = _.findIndex(a, function(t) {
                        return t.option1 === e[0].value && t.option2 === n && !0 === t.available
                    }) : 3 === i && (t = _.findIndex(a, function(t) {
                        return t.option1 === e[0].value && t.option2 === e[1].value && t.option3 === n && !0 === t.available
                    })),
                    -1 !== t ? (o.removeAttr("disabled", "disabled").removeClass("disabled"),
                    o.next("label").removeClass("disabled")) : (o.attr("disabled", "disabled").addClass("disabled"),
                    o.next("label").addClass("disabled"))
                })
        },
        updateVariantsButtonDisabed: function() {
            for (var e = 2; e <= 3; e++)
                if ($('[data-edit_variants-variant-option="' + e + '"]', t.EditVariantContainer).length) {
                    var a = !1;
                    $('[data-edit_variants-variant-option="' + e + '"] ' + t.EditVariantVariant, t.EditVariantContainer).each(function() {
                        var t = $(this)
                          , e = t.attr("type");
                        if (("radio" === e || "checkbox" === e) && this.checked && t.hasClass("disabled"))
                            return t.prop("checked", !1),
                            a = !0,
                            !1
                    }),
                    $('[data-edit_variants-variant-option="' + e + '"] ' + t.EditVariantVariant, t.EditVariantContainer).each(function() {
                        var t = $(this)
                          , e = t.attr("type");
                        if (a && ("radio" === e || "checkbox" === e) && !t.hasClass("disabled"))
                            return t.prop("checked", !0),
                            a = !1,
                            t.trigger("change"),
                            !1
                    })
                }
        },
        updateMasterSelect: function(e) {
            e && $(t.originalSelectorId, t.EditVariantContainer).val(e.id)
        },
        updateLabelvariant: function(t) {
            var e = $(".edit_variant-cart-container .content_product_detail .variants-wrapper");
            $(e).each(function() {
                var t = $(this)
                  , e = $("input:checked", t).attr("value");
                $(".variants__label span", t).html(e)
            })
        },
        updateMedia: function(e) {
            e && e.featured_media && e.featured_media.id && ($(".slick-carousel__item", t.EditVariantContainer).removeClass("show"),
            $(t.EditVariantImages, t.EditVariantContainer).find(".edit_variant-images__item").each(function() {
                var a = $(this).data("media-id");
                if (e.featured_media.id == a) {
                    $(this).closest(".slick-carousel__item").addClass("show");
                    var i = $(this).closest(".slick-carousel__item").data("slick-index");
                    null != i && $(t.EditVariantImages, t.EditVariantContainer).slick("slickGoTo", i)
                }
            }))
        },
        updatePrice: function(e) {
            var a = wpbingo.strings.moneyFormat;
            e ? ($(t.EditVariantProductPrice, t.EditVariantContainer).removeClass("d-none"),
            $(t.EditVariantProductPriceCompare, t.EditVariantContainer).removeClass("d-none"),
            $(t.EditVariantProductPrice, t.EditVariantContainer).html(wpbingo.Currency.formatMoney(e.price, a)),
            e.compare_at_price > e.price ? ($(t.EditVariantProductPriceCompare, t.EditVariantContainer).html(wpbingo.Currency.formatMoney(e.compare_at_price, a)).removeClass("d-none"),
            $(t.EditVariantProductPrice, t.EditVariantContainer).addClass("on-sale")) : ($(t.EditVariantProductPriceCompare, t.EditVariantContainer).addClass("d-none"),
            $(t.EditVariantProductPrice, t.EditVariantContainer).removeClass("on-sale"))) : ($(t.EditVariantProductPrice, t.EditVariantContainer).addClass("d-none"),
            $(t.EditVariantProductPriceCompare, t.EditVariantContainer).addClass("d-none")),
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        updateProductAvaiable: function(e) {
            var a = "product-avaiable--active"
              , i = wpbingo.strings;
            $(t.EditVariantAvaiable, t.EditVariantContainer).removeClass(a),
            e ? (e.available ? ($(t.EditVariantQty, t.EditVariantContainer).removeClass("d-none"),
            $(t.EditVariantAvaiableInStock, t.EditVariantContainer).addClass(a)) : ($(t.EditVariantQty, t.EditVariantContainer).addClass("d-none"),
            $(t.EditVariantAvaiableOutStock, t.EditVariantContainer).addClass(a)),
            e.available ? ($(t.EditVariantContainer).find(".btn--add-to-cart").removeClass("disabled").prop("disabled", !1),
            $(t.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(i.addToCart)) : ($(t.EditVariantContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0),
            $(t.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(i.soldOut))) : ($(t.EditVariantQty, t.EditVariantContainer).addClass("d-none"),
            $(t.EditVariantContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0),
            $(t.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(i.unavailable))
        },
        updateDetailsLink: function(e) {
            if (e) {
                var a = $(t.EditVariantDetailsURL, t.EditVariantContainer).data("url") + "?variant=" + e.id;
                $(t.EditVariantDetailsURL, t.EditVariantContainer).removeClass("d-none").attr("href", a)
            } else
                $(t.EditVariantDetailsURL, t.EditVariantContainer).addClass("d-none")
        },
        onVariantChange: function(e) {
            var a = this.getVariantFromOptions();
            if ($("[data-single-option-button]", t.EditVariantContainer).length && (this.updateVariantsButton(),
            !a || !a.available)) {
                this.updateVariantsButtonDisabed();
                return
            }
            setTimeout(function() {
                a.id != e ? $(".btn--add-to-cart", t.EditVariantContainer).prop("disabled", !1) : $(".btn--add-to-cart", t.EditVariantContainer).prop("disabled", !0)
            }, 100),
            this.updateMasterSelect(a),
            this.updateLabelvariant(a),
            this.updateMedia(a),
            this.updatePrice(a),
            this.updateProductAvaiable(a),
            this.updateDetailsLink(a),
            this.currentVariant = a
        }
    }),
    e
}();
var ajaxCartPage = function(t, e) {
    "use strict";
    var a, i, o, n, r, s, c, l, d, u, p, h, m, f, v;
    return a = function(t) {
        o = {
            cartContainer: "[data-cartpage-container]",
            cartCostSelector: ".cart-total__subtotal-price",
            cartRemoveSelector: ".cart-product-info__btn--remove",
            moneyFormat: "${{amount}}",
            disableAjaxCart: !1,
            cartTemplate: "#cart-form-template"
        },
        void 0 !== wpbingo.strings.moneyFormat && (o.moneyFormat = wpbingo.strings.moneyFormat),
        e.extend(o, t),
        c = e(o.cartContainer),
        s = e(o.cartCostSelector),
        r = e("body"),
        n = !1,
        l(),
        m()
    }
    ,
    l = function() {
        r.on("click", o.cartRemoveSelector, function(t) {
            if (t.preventDefault(),
            !n) {
                var a, i = e(this).data("line");
                i && (e('.item-cart[data-line="' + i + '"]').addClass("is-loading"),
                n = !0,
                setTimeout(function() {
                    ShopifyAPI.changeItem(i, 0, f)
                }, 250))
            }
        })
    }
    ,
    i = function() {
        ShopifyAPI.getCart(u)
    }
    ,
    d = function(t) {
        s && s.html(wpbingo.Currency.formatMoney(t.total_price, o.moneyFormat))
    }
    ,
    u = function(t, a) {
        d(t),
        p(t),
        t.item_count > 0 ? (e(".page-cart .content-cart_page").removeClass("hidden"),
        e(".page-cart .page-cart__header").removeClass("hidden"),
        e(".page-cart .page-cart-empty").addClass("hidden")) : (e(".page-cart .content-cart_page").addClass("hidden"),
        e(".page-cart .page-cart__header").addClass("hidden"),
        e(".page-cart .page-cart-empty").removeClass("hidden"))
    }
    ,
    p = function(t, a) {
        if (c.empty(),
        0 === t.item_count) {
            c.append('<p class="cart-empty-message">' + wpbingo.strings.cartEmpty + '</p>\n<p class="cookie-message">' + wpbingo.strings.cartCookies + "</p>"),
            h(t),
            e(".js-drawer .drawer__title .count").text("0"),
            e(".shipping-bar-cart").addClass("hidden");
            return
        }
        var i = []
          , n = {}
          , r = {}
          , s = e(o.cartTemplate).html()
          , l = Handlebars.compile(s);
        if (e.each(t.items, function(a, r) {
            var s, c = null;
            if (s = null !== r.image ? r.image.replace(/(\.[^.]*)$/, "_120x$1").replace("http:", "") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif",
            null !== r.properties && e.each(r.properties, function(t, e) {
                "_" !== t.charAt(0) && e || delete r.properties[t]
            }),
            null !== r.properties && e.each(r.properties, function(t, e) {
                "_" !== t.charAt(0) && e || delete r.properties[t]
            }),
            0 !== r.line_level_discount_allocations.length)
                for (var l in r.line_level_discount_allocations) {
                    var d = r.line_level_discount_allocations[l].amount;
                    r.line_level_discount_allocations[l].formattedAmount = wpbingo.Currency.formatMoney(d, o.moneyFormat)
                }
            if (0 !== t.cart_level_discount_applications.length)
                for (var u in t.cart_level_discount_applications) {
                    var p = t.cart_level_discount_applications[u].total_allocated_amount;
                    t.cart_level_discount_applications[u].formattedAmount = wpbingo.Currency.formatMoney(p, o.moneyFormat)
                }
            r.unit_price_measurement && (c = {
                addRefererenceValue: 1 !== r.unit_price_measurement.reference_value,
                price: wpbingo.Currency.formatMoney(r.unit_price, o.moneyFormat),
                reference_value: r.unit_price_measurement.reference_value,
                reference_unit: r.unit_price_measurement.reference_unit
            }),
            n = {
                key: r.key,
                line: a + 1,
                url: r.url,
                img: s,
                name: r.product_title,
                variation: r.variant_title,
                variant: null !== r.variant_title,
                options: r.options_with_values,
                variant_id: r.variant_id,
                price: wpbingo.Currency.formatMoney(r.price, o.moneyFormat),
                discountprice: wpbingo.Currency.formatMoney(r.original_line_price, o.moneyFormat),
                finalPrice: wpbingo.Currency.formatMoney(r.final_line_price, o.moneyFormat),
                handle: r.handle,
                properties: r.properties,
                itemAdd: r.quantity + 1,
                itemMinus: r.quantity - 1,
                itemQty: r.quantity,
                discounts: r.line_level_discount_allocations,
                discountsApplied: 0 !== r.line_level_discount_allocations.length,
                vendor: r.vendor,
                unitPrice: c
            },
            i.push(n),
            wpbingo.discount_single()
        }),
        r = {
            items: i,
            note: t.note,
            totalPrice: wpbingo.Currency.formatMoney(t.total_price, o.moneyFormat),
            cartDiscounts: t.cart_level_discount_applications,
            cartDiscountsApplied: 0 !== t.cart_level_discount_applications.length
        },
        c.append(l(r)),
        h(t),
        e(".shipping-bar-cart").removeClass("hidden"),
        e(".shipping-bar-cart").length) {
            var d = e(".shipping-bar-cart").data("price_shipping_bar");
            if (d > t.total_price && 0 != d) {
                var u = d - t.total_price
                  , p = wpbingo.Currency.formatMoney(u, o.moneyFormat)
                  , m = t.total_price / d * 100;
                e(".shipping-bar-cart .title-spend .spend").html(p),
                e(".shipping-bar-cart .shipping-progress").css("width", m + "%"),
                e(".shipping-bar-cart .title-shipping").addClass("hide"),
                e(".shipping-bar-cart .title-spend").removeClass("hide"),
                e(".shipping-bar-cart .shipping-progress").removeClass("full"),
                e(".shipping-bar-cart .shipping-progress").removeClass("fire-done"),
                e("#fire_work").addClass("hide")
            } else
                e(".shipping-bar-cart .title-shipping").removeClass("hide"),
                e(".shipping-bar-cart .title-spend").addClass("hide"),
                e(".shipping-bar-cart .shipping-progress").css("width", "100%"),
                e(".shipping-bar-cart .shipping-progress").addClass("full"),
                e(".shipping-bar-cart .shipping-progress").hasClass("fire-done") || e(".shipping-bar-cart .shipping-progress").addClass("fire"),
                e(".shipping-bar-cart .shipping-progress").hasClass("fire") && (e("#fire_work").removeClass("hide"),
                confettiLoop()),
                setTimeout(function() {
                    e(".shipping-bar-cart .shipping-progress").addClass("fire-done"),
                    e(".shipping-bar-cart .shipping-progress").removeClass("fire")
                }, 100),
                setTimeout(function() {
                    e("#fire_work").addClass("hide")
                }, 5e3)
        }
        e(".page-cart .pre_order-cart >span").each(function() {
            var t = e(this).data("handle");
            for (var a in r.items)
                r.items[a].variant_id == t && e('.page-cart .item-cart[data-line="' + r.items[a].line + '"] .pre_order').removeClass("hidden")
        }),
        e(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
    }
    ,
    h = function(t) {
        window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize()
    }
    ,
    m = function() {
        function t(t, a) {
            n = !0;
            var i = e('#cart-form .item-cart[data-line="' + t + '"]').addClass("is-loading");
            0 === a && i.parent().addClass("is-removed"),
            setTimeout(function() {
                ShopifyAPI.changeItem(t, a, f)
            }, 250)
        }
        r.on("click", "#cart-form .ajaxcart__qty-adjust", function() {
            if (!n) {
                var a = e(this)
                  , i = a.data("line")
                  , o = a.siblings(".ajaxcart__qty-num")
                  , r = parseInt(o.val().replace(/\D/g, ""));
                r = v(r),
                a.hasClass("ajaxcart__qty--plus") ? r += 1 : (r -= 1) <= 0 && (r = 0),
                i ? t(i, r) : o.val(r)
            }
        }),
        r.on("change", "#cart-form .ajaxcart__qty-num", function() {
            if (!n) {
                var a = e(this)
                  , i = a.data("line")
                  , o = parseInt(a.val().replace(/\D/g, ""));
                o = v(o),
                i && t(i, o)
            }
        }),
        r.on("submit", "#cart-form ", function(t) {
            n && t.preventDefault()
        }),
        r.on("focus", "#cart-form .ajaxcart__qty-adjust", function() {
            var t = e(this);
            setTimeout(function() {
                t.select()
            }, 50)
        })
    }
    ,
    f = function(t) {
        d(t),
        ajaxCart.load(),
        setTimeout(function() {
            ShopifyAPI.getCart(p),
            n = !1,
            t.item_count > 0 ? (e(".page-cart .content-cart_page").removeClass("hidden"),
            e(".page-cart .page-cart__header").removeClass("hidden"),
            e(".page-cart .page-cart-empty").addClass("hidden")) : (e(".page-cart .content-cart_page").addClass("hidden"),
            e(".page-cart .page-cart__header").addClass("hidden"),
            e(".page-cart .page-cart-empty").removeClass("hidden"))
        }, 150)
    }
    ,
    v = function(t) {
        return (parseFloat(t) !== parseInt(t) || isNaN(t)) && (t = 1),
        t
    }
    ,
    t = {
        init: a,
        load: i
    }
}(ajaxCartPage || {}, jQuery);
wpbingo.ajax_cartpage = function() {
    $("body").hasClass("template-cart") && (ajaxCartPage.init(),
    ajaxCartPage.load())
}
,
wpbingo.ajax_blogpage = function() {
    var t, e, a, i, o, n, r = function() {
        e(),
        a(),
        i(),
        o(),
        t(),
        n()
    };
    return i = function() {
        $(".page-blog .pagination-ajax-blog-loadmore").length && $(".page-blog .pagination-ajax-blog-loadmore").on("click", "a", function(e) {
            e.preventDefault();
            var a = $(this).attr("href")
              , o = $(this).attr("title")
              , r = $(this).attr("href").match(/page=\d+/g);
            parseInt(r[0].match(/\d+/g)),
            $(this).addClass("active"),
            $("#pre-loading").addClass("load-product"),
            $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            });
            var s = $(this).offset().top;
            a && $.ajax({
                type: "get",
                url: a,
                success: function(e) {
                    document.title = o,
                    $(".page-blog .article__list").append($(e).find(".page-blog .article__list").html()),
                    $(".page-blog .pagination-ajax-blog-loadmore").replaceWith($(e).find(".page-blog .pagination-ajax-blog-loadmore")),
                    $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }),
                    $("body,html").animate({
                        scrollTop: s
                    }, 600),
                    setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }),
                        $("#pre-loading").removeClass("load-product")
                    }, 500),
                    t(),
                    n(),
                    i(),
                    wpbingo.christmas_snow(),
                    $(this).removeClass("active")
                },
                error: function(t, e) {
                    console.log(e)
                }
            })
        })
    }
    ,
    e = function() {
        $(".page-blog .pagination-ajax-blog").length && $(".page-blog .pagination-ajax-blog").on("click", "a", function(a) {
            a.preventDefault();
            var i = $(this).attr("href")
              , o = $(this).closest(".pagination-ajax-blog").attr("title");
            History.pushState({
                param: Shopify.queryParams
            }, i, i),
            $("#pre-loading").addClass("load-product"),
            $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }),
            i && $.ajax({
                type: "get",
                url: i,
                success: function(a) {
                    document.title = o,
                    $(".page-blog").replaceWith($(a).find(".page-blog")),
                    $("body,html").animate({
                        scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
                    }, 600),
                    $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }),
                    setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }),
                        $("#pre-loading").removeClass("load-product")
                    }, 500),
                    t(),
                    n(),
                    e()
                },
                error: function(t, e) {
                    console.log(e)
                }
            })
        })
    }
    ,
    o = function() {
        $(".page-portfolio .pagination-ajax-blog-loadmore").length && $(".page-portfolio .pagination-ajax-blog-loadmore").on("click", "a", function(e) {
            e.preventDefault();
            var a = $(this).attr("href")
              , i = $(this).attr("title")
              , n = $(this).attr("href").match(/page=\d+/g);
            parseInt(n[0].match(/\d+/g)),
            $(this).addClass("active"),
            $("#pre-loading").addClass("load-product"),
            $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }),
            a && $.ajax({
                type: "get",
                url: a,
                success: function(e) {
                    document.title = i,
                    $(".page-portfolio .article__list").append($(e).find(".page-portfolio .article__list").html()),
                    $(".page-portfolio .pagination-ajax-blog-loadmore").replaceWith($(e).find(".page-portfolio .pagination-ajax-blog-loadmore")),
                    $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }),
                    setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }),
                        $("#pre-loading").removeClass("load-product")
                    }, 500),
                    t(),
                    o(),
                    wpbingo.christmas_snow(),
                    $(this).removeClass("active")
                },
                error: function(t, e) {
                    console.log(e)
                }
            })
        })
    }
    ,
    a = function() {
        $(".page-portfolio .pagination-ajax-blog").length && $(".page-portfolio .pagination-ajax-blog").on("click", "a", function(e) {
            e.preventDefault();
            var i = $(this).attr("href")
              , o = $(this).closest(".pagination-ajax-blog").attr("title");
            History.pushState({
                param: Shopify.queryParams
            }, i, i),
            $("#pre-loading").addClass("load-product"),
            $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }),
            i && $.ajax({
                type: "get",
                url: i,
                success: function(e) {
                    document.title = o,
                    $(".page-portfolio").replaceWith($(e).find(".page-portfolio")),
                    $("body,html").animate({
                        scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
                    }, 600),
                    $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }),
                    setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }),
                        $("#pre-loading").removeClass("load-product")
                    }, 500),
                    t(),
                    a()
                },
                error: function(t, e) {
                    console.log(e)
                }
            })
        })
    }
    ,
    t = function() {
        if ($(".wpbingo-breadcrumbs .wpbingo-blog-list").length) {
            var r = $(".wpbingo-blog-list");
            $(r).on("click", "a", function(r) {
                r.preventDefault();
                var s = $(this).attr("href")
                  , c = $(this).attr("title");
                $(this).closest(".item-blog").addClass("active"),
                History.pushState({
                    param: Shopify.queryParams
                }, s, s),
                delete Shopify.queryParams.page,
                $("#pre-loading").addClass("load-product"),
                $("#pre-loading .pre-loading__bar").css({
                    width: "40%"
                }),
                $.ajax({
                    type: "get",
                    url: s,
                    success: function(r) {
                        document.title = c,
                        $(".page-blog").replaceWith($(r).find(".page-blog")),
                        $(".page-portfolio").replaceWith($(r).find(".page-portfolio")),
                        $(".wpbingo-breadcrumbs .wpbingo-blog-list").replaceWith($(r).find(".wpbingo-breadcrumbs .wpbingo-blog-list")),
                        $("#pre-loading .pre-loading__bar").css({
                            width: "100%"
                        }),
                        setTimeout(function() {
                            $("#pre-loading .pre-loading__bar").css({
                                width: "0"
                            }),
                            $("#pre-loading").removeClass("load-product")
                        }, 500),
                        t(),
                        n(),
                        e(),
                        a(),
                        i(),
                        o()
                    },
                    error: function(t, e) {
                        console.log(e)
                    }
                }),
                $("body,html").animate({
                    scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
                }, 600)
            })
        }
    }
    ,
    n = function() {
        if ($(".page-blog .blog-sidebar .list-category").length) {
            var a = $(".blog-sidebar .list-category");
            $(a).on("click", "a", function(a) {
                a.preventDefault();
                var o = $(this).attr("href")
                  , r = $(this).attr("title");
                $(this).closest("li").addClass("active"),
                History.pushState({
                    param: Shopify.queryParams
                }, o, o),
                delete Shopify.queryParams.page,
                $("#pre-loading").addClass("load-product"),
                $("#pre-loading .pre-loading__bar").css({
                    width: "40%"
                }),
                $.ajax({
                    type: "get",
                    url: o,
                    success: function(a) {
                        document.title = r,
                        $(".page-blog").replaceWith($(a).find(".page-blog")),
                        $(".wpbingo-breadcrumbs .wpbingo-blog-list").replaceWith($(a).find(".wpbingo-breadcrumbs .wpbingo-blog-list")),
                        $("#pre-loading .pre-loading__bar").css({
                            width: "100%"
                        }),
                        setTimeout(function() {
                            $("#pre-loading .pre-loading__bar").css({
                                width: "0"
                            }),
                            $("#pre-loading").removeClass("load-product")
                        }, 500),
                        t(),
                        n(),
                        e(),
                        i()
                    },
                    error: function(t, e) {
                        console.log(e)
                    }
                }),
                $("body,html").animate({
                    scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
                }, 600)
            })
        }
    }
    ,
    r
}(),
wpbingo.checkbox_terms_conditions = function() {
    $(".ajaxcart_terms_conditions").length > 0 && ($(".agree_terms_conditions").is(":checked") ? $('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !1) : $('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !0),
    setTimeout(function() {
        $(".agree_terms_conditions").is(":checked") ? $('[data-shopify="payment-button"] button').prop("disabled", !1) : $('[data-shopify="payment-button"] button').prop("disabled", !0)
    }, 1e3),
    $("body").on("click", ".agree_terms_conditions", function() {
        $(this).is(":checked") ? ($("body").find(".agree_terms_conditions").each(function() {
            $(this).attr("checked", "checked")
        }),
        $('[data-shopify="payment-button"] button, [name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !1)) : ($("body").find(".agree_terms_conditions").each(function() {
            $(this).removeAttr("checked")
        }),
        $('[data-shopify="payment-button"] button, [name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !0))
    }),
    $(".content_terms_conditions [data-close-terms_conditions]").on("click", function(t) {
        $(".content_terms_conditions").removeClass("show"),
        setTimeout(function() {
            $(".content_terms_conditions").removeClass("active")
        }, 300)
    }),
    $(".ajaxcart_terms_conditions a").on("click", function(t) {
        t.preventDefault(),
        $(".content_terms_conditions").addClass("active"),
        setTimeout(function() {
            $(".content_terms_conditions").addClass("show")
        }, 300)
    }))
}
,
wpbingo.check_width_megamenu = function() {
    $(".menu-dropdown--mega.width_custom_pos").length > 0 && $(".menu-dropdown--mega.width_custom_pos .menu-dropdown__content--megamenu").each(function() {
        var t = $(this).offset().left
          , e = $(this).width() + t
          , a = $(this).closest(".width_custom_pos");
        e >= $(window).width() && a.addClass("width_custom_pos_right")
    })
}
,
wpbingo.slick_mobile = function() {
    767 > $(window).width() && $(".bwp-load-slick-mobile").each(function() {
        $(this).slick({
            infinite: !0,
            slidesToShow: $(this).data("col1"),
            slidesToScroll: $(this).data("col1"),
            arrows: $(this).data("nav"),
            dots: $(this).data("dot"),
            autoplay: $(this).data("autoplay"),
            autoplaySpeed: 5e3,
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: $(this).data("col2"),
                    slidesToScroll: $(this).data("col2")
                }
            }]
        })
    })
}
,
wpbingo.accordion_footer = function() {
    $(".footer-center").hasClass("accordion") && 767 > $(window).width() && $(".accordion .content-toggle").each(function() {
        var t = $(".footer-block", $(this));
        $(".title-footer", $(this)).on("click", function() {
            $(this).closest(".content-toggle").toggleClass("active"),
            t.slideToggle(),
            $(".footer-instagram").hasClass("active") && $(".js-carousel").slick("refresh")
        })
    })
}
,
wpbingo.productLoadMore = function() {
    function t(t, a, i, o) {
        $.ajax({
            type: "GET",
            url: t,
            beforeSend: function() {
                $("section.load-more .product-more--btn").off("click")
            },
            success: function(t) {
                o.remove(),
                $(t).find("." + a).insertBefore(i),
                window.SPR && (SPR.registerCallbacks(),
                SPR.initRatingHandler(),
                SPR.initDomEls(),
                SPR.loadProducts(),
                SPR.loadBadges()),
                initButtonsCompare(),
                initButtons(),
                wpbingo.countdown(),
                wpbingo.click_atribute_image(),
                wpbingo.zoom_thumb(),
                wpbingo.popup_product_card(),
                e(),
                $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
            }
        })
    }
    function e() {
        $("section.load-more .product-more--btn").on("click", function(e) {
            if (e.preventDefault,
            $(this).hasClass("disableLoadMore"))
                return !1;
            var a = $(this).attr("href")
              , i = $(this).closest(".load-more")
              , o = $(".product-more__content", i).attr("data-id")
              , n = $(".product-more__bottom-" + o, i)
              , r = $(this);
            return r.addClass("loading"),
            t(a, o, n, r),
            !1
        })
    }
    e()
}
,
wpbingo.hover_collection = function() {
    $(".wpbingo-section--collections-title").length > 0 && $(".wpbingo-section--collections-title .collection-item").each(function() {
        $(this).mousemove(function(t) {
            var e = t.pageX - $(this).offset().left;
            $(".collection-item__image", $(this)).css("left", e + "px")
        })
    })
}
,
wpbingo.christmas_snow = function() {
    if ($(".frame-snow").length > 0) {
        var t, e, a, i, o, n, r, s, c, l, d = window.routes.svg_christmas;
        function u() {
            $('<div class="snow" style="left:' + t + "%;transform:scale(" + e / 50 + "); animation-duration:" + a + 's">' + d + "</div>").appendTo(".frame-snow")
        }
        function p() {
            (i = $(".frame-snow .snow")).each(function() {
                n = $(this).offset().top,
                o = $(this).offset().left,
                n > r + 200 && $(this).remove(),
                o > s + 200 && $(this).remove()
            })
        }
        r = $(document).height(),
        s = $(document).width(),
        l = 0,
        $(window).resize(function() {
            r = $(document).height(),
            s = $(document).width()
        }),
        $(".frame-snow").css({
            height: r + "px"
        }),
        c = setInterval(function() {
            t = Math.round(100 * Math.random()),
            e = Math.round(100 * Math.random()),
            a = Math.floor(30 * Math.random()) + Math.round(r / 1e3),
            u()
        }, 100),
        c = setInterval(function() {
            r = $(document).height(),
            p()
        }, 10)
    }
}
,
wpbingo.address_delete = function() {
    $(".address-delete").on("click", function() {
        var t = $(this)
          , e = t.data("target");
        confirm(t.data("confirm-message") || "Are you sure you wish to delete this address?") && Shopify.postLink(e, {
            parameters: {
                _method: "delete"
            }
        })
    })
}
,
wpbingo.change_head = function() {
    var t = $(document).attr("title");
    if ($("#before-you-leave").length > 0)
        var e = 6e4 * $("#before-you-leave").data("time");
    function a() {
        change_out1 = function() {}
        ,
        change_out2 = function() {}
        ,
        !($("#before-you-leave").length > 0) || $("#before-you-leave").hasClass("active") || $("#before-you-leave").hasClass("hiden") || $("#before-you-leave").addClass("hiden"),
        $(document).attr("title", t)
    }
    document.addEventListener("visibilitychange", function(t) {
        document.hidden ? (change_out2 = function() {
            $(document).attr("title", wpbingo.strings.come_back),
            setTimeout(function() {
                change_out1()
            }, 500)
        }
        ,
        change_out1 = function() {
            $(document).attr("title", wpbingo.strings.forget),
            setTimeout(function() {
                change_out2()
            }, 500)
        }
        ,
        $("#before-you-leave").length > 0 && $("#before-you-leave").hasClass("hiden") && $("#before-you-leave").removeClass("hiden"),
        setTimeout(function() {
            !($("#before-you-leave").length > 0) || $("#before-you-leave").hasClass("active") || $("#before-you-leave").hasClass("hiden") || $("#before-you-leave").addClass("active")
        }, e),
        change_out1()) : a()
    })
}
,
wpbingo.before_you_leave = function() {
    if ($("#before-you-leave").length > 0) {
        var t = 6e4 * $("#before-you-leave").data("time");
        $("#before-you-leave [data-close-you-leave]").on("click", function() {
            $("#before-you-leave").removeClass("active"),
            $("#before-you-leave").addClass("hiden")
        }),
        window.addEventListener("mouseover", function(t) {
            !($("#before-you-leave").length > 0) || $("#before-you-leave").hasClass("active") || $("#before-you-leave").hasClass("hiden") || $("#before-you-leave").addClass("hiden")
        }),
        window.addEventListener("blur", function(e) {
            $("#before-you-leave").length > 0 && $("#before-you-leave").hasClass("hiden") && $("#before-you-leave").removeClass("hiden"),
            setTimeout(function() {
                !($("#before-you-leave").length > 0) || $("#before-you-leave").hasClass("active") || $("#before-you-leave").hasClass("hiden") || $("#before-you-leave").addClass("active")
            }, t)
        })
    }
}
,
wpbingo.init = function() {
    wpbingo.initializeEvents(),
    wpbingo.setBreakpoints(),
    wpbingo.cartInit(),
    wpbingo.collectionPages(),
    wpbingo.slideshow(),
    wpbingo.slickCarousel(),
    wpbingo.countdown(),
    wpbingo.countdown_single(),
    wpbingo.sticky_product(),
    wpbingo.sticky_header(),
    wpbingo.lookbook(),
    wpbingo.click_button(),
    wpbingo.click_atribute_image(),
    wpbingo.active_form_login(),
    wpbingo.cookieConsent(),
    wpbingo.newsletter(),
    wpbingo.verify_popup(),
    wpbingo.header_campar(),
    wpbingo.customNumberInput(),
    wpbingo.zoom_thumb(),
    wpbingo.popup_product_card(),
    wpbingo.sale_nofication(),
    wpbingo.discount_single(),
    wpbingo.pick_up(),
    wpbingo.time_estimated_delivery(),
    wpbingo.countActiveSidebar(),
    wpbingo.toggleSidebar(),
    wpbingo.sidebarCollection(),
    wpbingo.ajax_cartpage(),
    wpbingo.ajax_blogpage(),
    wpbingo.checkbox_terms_conditions(),
    wpbingo.check_width_megamenu(),
    wpbingo.slick_mobile(),
    wpbingo.accordion_footer(),
    wpbingo.productLoadMore(),
    wpbingo.hover_collection(),
    wpbingo.christmas_snow(),
    wpbingo.address_delete(),
    wpbingo.change_head(),
    wpbingo.before_you_leave(),
    new wpbingo.update_variant_cartpage(".js-edit_variants"),
    wpbingo.settings.enableGiftCard && new wpbingo.gift_wrap(".js-giftcard"),
    wpbingo.settings.enableGiftWrapperCard && new wpbingo.gift_wrapper(".js-giftwrappercard"),
    wpbingo.settings.enableQuickView && new wpbingo.QuickView(".js-quickview"),
    $("body").hasClass("template-product") && "slider" != $(".product-single").data().layout_thumb && ($(".product-media__wrapper--video iframe").css("width", $(".product-single__main-media .mfp-image").width()),
    $(".product-media__wrapper--video iframe").css("height", $(".product-single__main-media .mfp-image").height()),
    $(".js-product-media-item model-viewer").css("width", $(".js-product-media").width()),
    $(".js-product-media-item model-viewer").css("height", $(".mfp-image").height()))
}
;
const confetti = document.getElementById("fire_work")
  , confettiCtx = confetti.getContext("2d");
let container, confettiElements = [], clickPosition;
rand = (t, e) => Math.random() * (e - t) + t;
const confettiParams = {
    number: 200,
    size: {
        x: [5, 10],
        y: [10, 10]
    },
    initSpeed: 100,
    gravity: .9,
    drag: .5,
    terminalVelocity: 6,
    flipSpeed: .07
}
  , colors = [{
    front: "#3B870A",
    back: "#235106"
}, {
    front: "#B96300",
    back: "#6f3b00"
}, {
    front: "#E23D34",
    back: "#88251f"
}, {
    front: "#CD3168",
    back: "#7b1d3e"
}, {
    front: "#664E8B",
    back: "#3d2f53"
}, {
    front: "#394F78",
    back: "#222f48"
}, {
    front: "#008A8A",
    back: "#005353"
}, ];
function Conf() {
    this.randomModifier = rand(-1, 1),
    this.colorPair = colors[Math.floor(rand(0, colors.length))],
    this.dimensions = {
        x: rand(confettiParams.size.x[0], confettiParams.size.x[1]),
        y: rand(confettiParams.size.y[0], confettiParams.size.y[1])
    },
    this.position = {
        x: clickPosition[0],
        y: clickPosition[1]
    },
    this.rotation = rand(0, 2 * Math.PI),
    this.scale = {
        x: 1,
        y: 1
    },
    this.velocity = {
        x: .4 * rand(-confettiParams.initSpeed, confettiParams.initSpeed),
        y: rand(-confettiParams.initSpeed, confettiParams.initSpeed)
    },
    this.flipSpeed = rand(.2, 1.5) * confettiParams.flipSpeed,
    this.position.y <= container.h && (this.velocity.y = -Math.abs(this.velocity.y)),
    this.terminalVelocity = rand(1, 1.5) * confettiParams.terminalVelocity,
    this.update = function() {
        this.velocity.x *= .98,
        this.position.x += this.velocity.x,
        this.velocity.y += this.randomModifier * confettiParams.drag,
        this.velocity.y += confettiParams.gravity,
        this.velocity.y = Math.min(this.velocity.y, this.terminalVelocity),
        this.position.y += this.velocity.y,
        this.scale.y = Math.cos((this.position.y + this.randomModifier) * this.flipSpeed),
        this.color = this.scale.y > 0 ? this.colorPair.front : this.colorPair.back
    }
}
function updateConfetti() {
    confettiCtx.clearRect(0, 0, container.w, container.h),
    confettiElements.forEach(t => {
        t.update(),
        confettiCtx.translate(t.position.x, t.position.y),
        confettiCtx.rotate(t.rotation);
        let e = t.dimensions.x * t.scale.x
          , a = t.dimensions.y * t.scale.y;
        confettiCtx.fillStyle = t.color,
        confettiCtx.fillRect(-.5 * e, -.5 * a, e, a),
        confettiCtx.setTransform(1, 0, 0, 1, 0, 0)
    }
    ),
    confettiElements.forEach( (t, e) => {
        (t.position.y > container.h || t.position.x < -.5 * container.x || t.position.x > 1.5 * container.x) && confettiElements.splice(e, 1)
    }
    ),
    window.requestAnimationFrame(updateConfetti)
}
function setupCanvas() {
    container = {
        w: confetti.clientWidth,
        h: confetti.clientHeight
    },
    confetti.width = container.w,
    confetti.height = container.h
}
function addConfetti(t) {
    let e = confetti.getBoundingClientRect();
    clickPosition = t ? [t.clientX - e.left, t.clientY - e.top] : [e.width * Math.random(), e.height * Math.random()];
    for (let a = 0; a < confettiParams.number; a++)
        confettiElements.push(new Conf)
}
function hideConfetti() {
    confettiElements = [],
    window.cancelAnimationFrame(updateConfetti)
}
function confettiLoop() {
    for (let t = 0; t < 8; t++)
        addConfetti()
}
setupCanvas(),
updateConfetti(),
window.addEventListener("resize", () => {
    setupCanvas(),
    hideConfetti()
}
);
const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist"
  , LOCAL_STORAGE_DELIMITER = ","
  , BUTTON_ACTIVE_CLASS = "active"
  , GRID_LOADED_CLASS = "loaded"
  , selectors = {
    button: ".button-wishlist >button",
    grid: "[grid-wishlist]",
    productCard: ".product-content-card"
};
document.addEventListener("DOMContentLoaded", () => {
    initButtons(),
    initGrid();
    let t = getWishlist();
    $("[data-count-wishlist] .count").html(t.length)
}
),
document.addEventListener("shopify-wishlist:updated", t => {
    initGrid()
}
);
const fetchProductCardHTML = t => {
    let e = `/products/${t}?view=wishlist`;
    return fetch(e).then(t => t.text()).then(t => {
        let e = t
          , a = new DOMParser
          , i = a.parseFromString(e, "text/html")
          , o = i.documentElement.querySelector(selectors.productCard);
        return o.outerHTML
    }
    ).catch(e => console.error(`[Shopify Content] Failed to load content for handle: ${t}`, e))
}
  , setupGrid = async t => {
    let e = getWishlist()
      , a = e.map(fetchProductCardHTML)
      , i = await Promise.all(a)
      , o = i.join("");
    t.innerHTML = o,
    t.classList.add(GRID_LOADED_CLASS),
    initButtons(),
    initButtonsCompare(),
    wpbingo.countdown(),
    wpbingo.click_atribute_image(),
    $(".bwp_currency").length > 0 && e.length > 0 && Currency.Currency_customer(!0),
    ajaxCart.init();
    let n = new CustomEvent("shopify-wishlist:init-product-grid",{
        detail: {
            wishlist: e
        }
    });
    document.dispatchEvent(n),
    $(".wishlist__grid").removeClass("loading_wishlist"),
    e.length > 0 ? $(".wishlist_empty").addClass("hidden") : $(".wishlist_empty").removeClass("hidden")
}
  , setupButtons = t => {
    t.forEach(t => {
        let e = t.dataset.productHandle || !1;
        if (!e)
            return console.error("[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.");
        wishlistContains(e) && t.classList.add(BUTTON_ACTIVE_CLASS),
        t.addEventListener("click", () => {
            function a() {
                if (t.classList.remove("load-wishlist"),
                t.classList.toggle(BUTTON_ACTIVE_CLASS),
                $(t).hasClass("active")) {
                    var e = t.closest(".button-wishlist");
                    e.setAttribute("data-title", window.strings.remove_wishlist)
                } else {
                    var e = t.closest(".button-wishlist");
                    e.setAttribute("data-title", window.strings.wishlist)
                }
            }
            setTimeout(a, 1e3),
            updateWishlist(e),
            t.classList.add("load-wishlist")
        }
        )
    }
    )
}
  , initGrid = () => {
    let t = document.querySelector(selectors.grid) || !1;
    t && setupGrid(t)
}
  , initButtons = t => {
    if (t) {
        let e = document.querySelector(t)
          , a = e.querySelectorAll(selectors.button) || [];
        if (!a.length)
            return;
        setupButtons(a)
    } else {
        let i = document.querySelectorAll(selectors.button) || [];
        if (!i.length)
            return;
        setupButtons(i)
    }
    let o = new CustomEvent("shopify-wishlist:init-buttons",{
        detail: {
            wishlist: getWishlist()
        }
    });
    document.dispatchEvent(o),
    $(selectors.button).each(function(t) {
        if ($(this).hasClass("active")) {
            var e = $(this).closest(".button-wishlist");
            e.attr("data-title", window.strings.remove_wishlist)
        } else {
            var e = $(this).closest(".button-wishlist");
            e.attr("data-title", window.strings.wishlist)
        }
    })
}
  , getWishlist = () => {
    let t = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || !1;
    return t ? t.split(LOCAL_STORAGE_DELIMITER) : []
}
  , setWishlist = t => {
    let e = t.join(LOCAL_STORAGE_DELIMITER);
    t.length ? localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, e) : localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    let a = new CustomEvent("shopify-wishlist:updated",{
        detail: {
            wishlist: t
        }
    });
    return document.dispatchEvent(a),
    e
}
  , updateWishlist = t => {
    let e = getWishlist()
      , a = e.indexOf(t);
    return -1 === a ? e.push(t) : e.splice(a, 1),
    $("[data-count-wishlist] .count").html(e.length),
    setWishlist(e)
}
  , wishlistContains = t => {
    let e = getWishlist();
    return e.includes(t)
}
  , resetWishlist = () => setWishlist([])
  , LOCAL_STORAGE_COMPARE_KEY = "shopify-compare"
  , LOCAL_STORAGE_DELIMITER_COMPARE = ","
  , BUTTON_ACTIVE_CLASS_COMPARE = "active"
  , GRID_LOADED_CLASS_COMPARE = "loaded"
  , selectorscompare = {
    button: ".button-compare >button",
    remove: ".remove-compare >button",
    grid: "[grid-compare]",
    table: ".compare__table",
    productCard: ".product-content-compare"
};
document.addEventListener("DOMContentLoaded", () => {
    initButtonsCompare(),
    initGridCompare();
    let t = getCompare();
    0 === t.length ? $(selectorscompare.table).removeClass(GRID_LOADED_CLASS_COMPARE) : ($(selectorscompare.table).addClass(GRID_LOADED_CLASS_COMPARE),
    $(".show-compare .count", selectorscompare.table).html(t.length))
}
),
document.addEventListener("shopify-compare:updated", t => {
    initGridCompare()
}
);
const fetchProductCardHTMLCOMPARE = t => {
    let e = `/products/${t}?view=compare`;
    return fetch(e).then(t => t.text()).then(t => {
        let e = t
          , a = new DOMParser
          , i = a.parseFromString(e, "text/html")
          , o = i.documentElement.querySelector(selectorscompare.productCard);
        return o.outerHTML
    }
    ).catch(e => console.error(`[Shopify Content] Failed to load content for handle: ${t}`, e))
}
  , setupGridCompare = async t => {
    let e = getCompare()
      , a = e.map(fetchProductCardHTMLCOMPARE);
    a && ($.each(a, function(t, e) {
        e.then(function(t) {
            let e = new DOMParser().parseFromString(t, "text/html").querySelector(".clone-remove-compare").innerHTML;
            $(".remove-button", selectorscompare.table).append("<li>" + e + "</li>")
        }, function(t) {
            console.log(t)
        })
    }),
    $.each(a, function(t, e) {
        e.then(function(t) {
            let e = new DOMParser().parseFromString(t, "text/html").querySelector(".clone-compare-title").innerHTML;
            $(".compare-name", selectorscompare.table).append("<li>" + e + "</li>")
        }, function(t) {
            console.log(t)
        })
    }),
    $.each(a, function(t, e) {
        e.then(function(t) {
            let e = new DOMParser().parseFromString(t, "text/html").querySelector(".clone-compare-image").innerHTML;
            $(".compare-image", selectorscompare.table).append("<li>" + e + "</li>")
        }, function(t) {
            console.log(t)
        })
    }),
    $.each(a, function(t, e) {
        e.then(function(t) {
            let e = new DOMParser().parseFromString(t, "text/html").querySelector(".clone-compare-card__content").innerHTML;
            $(".compare-variants", selectorscompare.table).append("<li>" + e + "</li>")
        }, function(t) {
            console.log(t)
        })
    }),
    $.each(a, function(t, e) {
        e.then(function(t) {
            let e = new DOMParser().parseFromString(t, "text/html").querySelector(".clone-compare-inventory").innerHTML;
            $(".compare-availability", selectorscompare.table).append("<li>" + e + "</li>")
        }, function(t) {
            console.log(t)
        })
    }),
    $.each(a, function(t, e) {
        e.then(function(t) {
            let e = new DOMParser().parseFromString(t, "text/html").querySelector(".clone-compare-price").innerHTML;
            $(".compare-price", selectorscompare.table).append("<li>" + e + "</li>")
        }, function(t) {
            console.log(t)
        })
    }),
    $.each(a, function(t, e) {
        e.then(function(t) {
            let e = new DOMParser().parseFromString(t, "text/html").querySelector(".clone-compare-atc").innerHTML;
            $(".compare-atc", selectorscompare.table).append("<li>" + e + "</li>")
        }, function(t) {
            console.log(t)
        })
    }));
    let i = await Promise.all(a);
    i.join(""),
    wpbingo.click_atribute_image(),
    e.length > 0 && $(".bwp_currency").length > 0 && $(".bwp_currency").length > 0 && Currency.Currency_customer(!0),
    removeCompare();
    let o = new CustomEvent("shopify-compare:init-product-grid",{
        detail: {
            compare: e
        }
    });
    document.dispatchEvent(o)
}
  , setupButtonsCompare = t => {
    t.forEach(t => {
        let e = t.dataset.productHandle || !1;
        if (!e)
            return console.error("[Shopify Compare] Missing `data-product-handle` attribute. Failed to update the compare.");
        compareContains(e) && t.classList.add(BUTTON_ACTIVE_CLASS_COMPARE),
        t.addEventListener("click", () => {
            function a() {
                if (t.classList.remove("load-compare"),
                $(".content", selectorscompare.table).removeClass("load-compare"),
                t.classList.toggle(BUTTON_ACTIVE_CLASS_COMPARE),
                $(t).hasClass("active")) {
                    var e = t.closest(".button-compare");
                    e.setAttribute("data-title", window.strings.remove_compare)
                } else {
                    var e = t.closest(".button-compare");
                    e.setAttribute("data-title", window.strings.compare)
                }
            }
            $(t).hasClass("active") || ($(".content-compare", selectorscompare.table).addClass("active"),
            $(".content", selectorscompare.table).addClass("load-compare")),
            setTimeout(a, 1e3),
            updateCompare(e),
            t.classList.add("load-compare")
        }
        )
    }
    )
}
  , removeButtonsCompare = t => {
    t.forEach(t => {
        let e = t.dataset.productHandle || !1;
        if (!e)
            return console.error("[Shopify Compare] Missing `data-product-handle` attribute. Failed to update the compare.");
        compareContains(e) && t.classList.add(BUTTON_ACTIVE_CLASS_COMPARE),
        t.addEventListener("click", () => {
            function a() {
                $(".content", selectorscompare.table).removeClass("load-compare"),
                $(".button-compare >button[data-product-handle=" + t.getAttribute("data-product-handle") + "]").removeClass(BUTTON_ACTIVE_CLASS_COMPARE),
                $(selectorscompare.button).each(function(t) {
                    if ($(this).hasClass("active")) {
                        var e = $(this).closest(".button-compare");
                        e.attr("data-title", window.strings.remove_compare)
                    } else {
                        var e = $(this).closest(".button-compare");
                        e.attr("data-title", window.strings.compare)
                    }
                })
            }
            setTimeout(a, 1e3),
            updateCompare(e),
            $(".content", selectorscompare.table).addClass("load-compare")
        }
        )
    }
    )
}
  , initGridCompare = () => {
    let t = document.querySelector(selectorscompare.grid) || !1;
    t && ($(".remove-button", selectorscompare.table).empty(),
    $(".compare-name", selectorscompare.table).empty(),
    $(".compare-image", selectorscompare.table).empty(),
    $(".compare-variants", selectorscompare.table).empty(),
    $(".compare-availability", selectorscompare.table).empty(),
    $(".compare-price", selectorscompare.table).empty(),
    $(".compare-atc", selectorscompare.table).empty(),
    $(".remove-button", selectorscompare.table).append('<li class="label"></li>'),
    $(".compare-name", selectorscompare.table).append('<li class="label">' + $(".compare-name").data("label") + "</li>"),
    $(".compare-image", selectorscompare.table).append('<li class="label"></li>'),
    $(".compare-variants", selectorscompare.table).append('<li class="label">' + $(".compare-variants").data("label") + "</li>"),
    $(".compare-availability", selectorscompare.table).append('<li class="label">' + $(".compare-availability").data("label") + "</li>"),
    $(".compare-price", selectorscompare.table).append('<li class="label">' + $(".compare-price").data("label") + "</li>"),
    $(".compare-atc", selectorscompare.table).append('<li class="label"></li>'),
    setupGridCompare(t)),
    $(".compare__table .hide-compare").on("click", function() {
        $(".compare__table .content-compare").hasClass("active") && $(".compare__table .content-compare").removeClass("active")
    }),
    $(".compare__table .show-compare").on("click", function() {
        $(".compare__table .content-compare").hasClass("active") || $(".compare__table .content-compare").addClass("active")
    })
}
  , initButtonsCompare = t => {
    if (t) {
        let e = document.querySelector(t)
          , a = e.querySelectorAll(selectorscompare.button) || [];
        if (!a.length)
            return;
        setupButtonsCompare(a)
    } else {
        let i = document.querySelectorAll(selectorscompare.button) || [];
        if (!i.length)
            return;
        setupButtonsCompare(i)
    }
    let o = new CustomEvent("shopify-compare:init-buttons",{
        detail: {
            compare: getCompare()
        }
    });
    document.dispatchEvent(o),
    $(selectorscompare.button).each(function(t) {
        if ($(this).hasClass("active")) {
            var e = $(this).closest(".button-compare");
            e.attr("data-title", window.strings.remove_compare)
        } else {
            var e = $(this).closest(".button-compare");
            e.attr("data-title", window.strings.compare)
        }
    })
}
  , removeCompare = () => {
    let t = document.querySelectorAll(selectorscompare.remove) || [];
    if (!t.length)
        return;
    removeButtonsCompare(t);
    let e = new CustomEvent("shopify-compare:init-buttons",{
        detail: {
            compare: getCompare()
        }
    });
    document.dispatchEvent(e)
}
  , getCompare = () => {
    let t = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || !1;
    return t ? t.split(LOCAL_STORAGE_DELIMITER_COMPARE) : []
}
  , setCompare = t => {
    let e = t.join(LOCAL_STORAGE_DELIMITER_COMPARE);
    t.length ? localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, e) : localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);
    let a = new CustomEvent("shopify-compare:updated",{
        detail: {
            compare: t
        }
    });
    return document.dispatchEvent(a),
    e
}
  , updateCompare = t => {
    let e = getCompare()
      , a = e.indexOf(t)
      , i = document.querySelector(selectorscompare.table);
    return -1 === a ? e.push(t) : e.splice(a, 1),
    0 === e.length ? i.classList.remove(GRID_LOADED_CLASS_COMPARE) : (i.classList.add(GRID_LOADED_CLASS_COMPARE),
    $(".show-compare .count", selectorscompare.table).html(e.length)),
    setCompare(e)
}
  , compareContains = t => {
    let e = getCompare();
    return e.includes(t)
}
  , resetCompare = () => setCompare([]);
$(document).ready(function() {
    wpbingo.init();
    var t = new wpbingo.Sections;
    if (t.register("product-template", wpbingo.Product),
    t.register("header-section", wpbingo.HeaderSection),
    t.register("header-topbar-section", wpbingo.HeaderSection),
    t.register("product-recommendations", wpbingo.ProductRecommendations),
    t.register("login-register", wpbingo.LoginRegister),
    t.register("search", wpbingo.Search),
    $("body").hasClass("template-product") && (t.register("product-template", Shopify.Products.showRecentlyViewed()),
    t.register("product-template", Shopify.Products.recordRecentlyViewed()),
    "slider" == $(".product-single").data().layout_thumb && ($(".product-media__wrapper--video iframe").css("width", $(".product-single__main-media #slick-slide11 .mfp-image").width()),
    $(".product-media__wrapper--video iframe").css("height", $(".product-single__main-media #slick-slide11 .mfp-image").height()),
    $(".js-product-media-item model-viewer").css("width", $(".product-single__main-media #slick-slide11 .mfp-image").width()),
    $(".js-product-media-item model-viewer").css("height", $(".product-single__main-media #slick-slide11 .mfp-image").height()))),
    wpbingo.settings.enablePreLoading && $("#pre-loading").addClass("loading-done"),
    setTimeout(function() {
        $("#pre-loading").removeClass("loading-done"),
        $("#pre-loading").removeClass("loading-page")
    }, 1300),
    window.Shopify.designMode) {
        $(".main-content").addClass("designMode_active");
        let e = window.performance.getEntriesByType("navigation")[0].type;
        console.log(e)
    }
});
